<!-- eslint-disable -->
<template xmlns="http://www.w3.org/1999/html">
    <main class="container" role="main">
        <div class="row">
            <div class="col-md-12">
                <h3 class="pb-4 mb-4 border-bottom">
                    Готовые изделия
                </h3>
            </div>

            <div class="col-md-12 tabs">
<!--                <div class="row">-->
<!--                    <div class="col-md-12">-->
<!--                        <router-link to="/news/100789" style="font-size: 20px; color: red; font-weight: bold">ВНИМАНИЕ!!!! В рулонных шторах ZEBRA RM изменился оттенок ткани Basic антрацит <i class="las la-info-circle" style="font-size: 30px; vertical-align: bottom;"></i></router-link><br/><br/>-->
<!--                    </div>-->
<!--                </div>-->
                <div class="row">
                    <a class="col-4 tab" v-bind:class="{ active: mode == 2 }" @click="setMode(2)">
                        <span>Со склада (габаритный размер)</span>
                    </a>
                    <div class="col-4 tab" v-bind:class="{ active: mode == 1 }" @click="setMode(1)">
                        <span>Под заказ (габаритный размер)</span>
                    </div>
                    <div class="col-4 tab" v-bind:class="{ active: mode == 3 }" @click="setMode(3)">
                        <span>Под заказ (размер по ткани)</span>
                    </div>
                </div>
            </div>

            <div class="col-md-12">
                <div>
                    <div class="rmGroup">
                        <div>
                            <table class="table readyMadeTable">
                                <thead>
                                <tr>
                                    <th v-if="mode == 1" class="noAfter" colspan="18" style="border-bottom: 1px solid #b7b7b7;">
                                        <p class="m-2 rmMenu">
<!--                                            <a href="javascript:" @click="setOrderMode(1)" v-bind:class="{ selected: orderMode == 1 }">Рулонные шторы RM</a>-->
                                            <a href="javascript:" @click="setOrderMode(10)" v-bind:class="{ selected: orderMode == 10 }">Рулонные шторы RM-140 картон</a>
<!--                                            <a href="javascript:" @click="setOrderMode(9)" v-bind:class="{ selected: orderMode == 9 }">Рулонные шторы RM картон</a>-->
                                            <a href="javascript:" @click="setOrderMode(1)" v-bind:class="{ selected: orderMode == 1 }">Рулонные шторы RM блистер</a>
                                            <a href="javascript:" @click="setOrderMode(4)" v-bind:class="{ selected: orderMode == 4 }">Горизонтальные жалюзи RM картон</a>
                                            <a href="javascript:" @click="setOrderMode(5)" v-bind:class="{ selected: orderMode == 5 }">Горизонтальные жалюзи RM блистер</a>
<!--                                            <a href="javascript:" @click="setOrderMode(2)" v-bind:class="{ selected: orderMode == 2 }">Вертикальные жалюзи RM</a>-->
                                            <a href="javascript:" @click="setOrderMode(2)" v-bind:class="{ selected: orderMode == 2 }">Вертикальные жалюзи RM карнизы</a>
                                            <a href="javascript:" @click="setOrderMode(8)" v-bind:class="{ selected: orderMode == 8 }">Вертикальные жалюзи RM ткани</a>
<!--                                            <a href="javascript:" @click="setOrderMode(3)" v-bind:class="{ selected: orderMode == 3 }" class="newRm2"><span style="font-weight: bold; color: black">NEW</span> Круглые карнизы RM</a>-->
                                            <a href="javascript:" @click="setOrderMode(6)" v-bind:class="{ selected: orderMode == 6 }" v-if="isStorageAdmin">Ремкомплекты</a>
<!--                                            <a href="javascript:" @click="setOrderMode(6)" v-bind:class="{ selected: orderMode == 6 }">Ремкомплекты</a>-->
                                        </p>
                                        <button v-if="rmOpened" class="btn btn-light hideMobile" @click="rmOpened = false"><i class="las la-angle-up"></i></button>
                                        <button v-if="!rmOpened" class="btn btn-light hideMobile" @click="rmOpened = true; corniceOpened = false; verticalOpened = false"><i class="las la-angle-down"></i></button>
                                    </th>

                                    <th v-if="mode == 2" class="noAfter" colspan="18" style="border-bottom: 1px solid #b7b7b7;">
                                        <p class="m-2 rmMenu">
                                            <a href="javascript:" @click="setOrderMode(1)" v-bind:class="{ selected: orderMode == 1 }">Рулонные шторы RM</a>
                                            <a href="javascript:" @click="setOrderMode(4)" v-bind:class="{ selected: orderMode == 4 }">Горизонтальные жалюзи RM картон</a>
<!--                                            <a href="javascript:" @click="setOrderMode(6)" v-bind:class="{ selected: orderMode == 6 }">Ремкомплекты</a>-->
                                        </p>
                                        <button v-if="rmOpened" class="btn btn-light hideMobile" @click="rmOpened = false"><i class="las la-angle-up"></i></button>
                                        <button v-if="!rmOpened" class="btn btn-light hideMobile" @click="rmOpened = true; corniceOpened = false; verticalOpened = false"><i class="las la-angle-down"></i></button>
                                    </th>

                                    <th v-if="mode == 3" class="noAfter" colspan="18" style="border-bottom: 1px solid #b7b7b7;">
                                        <p class="m-2 rmMenu">
                                            <a href="javascript:" @click="setOrderMode(7)" v-bind:class="{ selected: orderMode == 7 }">Рулонные шторы RM</a>
                                        </p>
                                        <button v-if="rmOpened" class="btn btn-light hideMobile" @click="rmOpened = false"><i class="las la-angle-up"></i></button>
                                        <button v-if="!rmOpened" class="btn btn-light hideMobile" @click="rmOpened = true; corniceOpened = false; verticalOpened = false"><i class="las la-angle-down"></i></button>
                                    </th>

<!--                                    <th v-else class="noAfter text-center" colspan="12"-->
<!--                                        style="border-bottom: 1px solid #b7b7b7;">-->
<!--                                        <p class="m-2">Рулонные шторы RM и горизонтальные жалюзи RM</p>-->
<!--                                        <button v-if="rmOpened" class="btn btn-light" @click="rmOpened = false"><i-->
<!--                                            class="las la-angle-up"></i></button>-->
<!--                                        <button v-if="!rmOpened" class="btn btn-light"-->
<!--                                                @click="rmOpened = true; corniceOpened = false; verticalOpened = false"><i-->
<!--                                            class="las la-angle-down"></i></button>-->
<!--                                    </th>-->
                                </tr>
                                <tr v-if="rmOpened && (orderMode == 1 || orderMode == 4 || orderMode == 5 || orderMode == 7 || orderMode == 9 || orderMode == 10)" class="hideMobile">
                                    <th class="noAfter" style="width: 6px;"></th>
                                    <th style="width: 284px;">Тип изделия <br><i class="las la-angle-down"></i></th>
                                    <th v-if="orderMode == 1 || orderMode == 4 || orderMode == 5 || orderMode == 9 || orderMode == 10"></th>
                                    <th>Материал <br><i class="las la-angle-down"></i></th>
                                    <th v-if="orderMode != 7" style="width: 67px;">Габ-ная ширина изделия, см <br><i class="las la-angle-down"></i></th>
                                    <th v-else style="width: 67px;">Ширина по ткани, см <br><i class="las la-angle-down"></i></th>
                                    <th style="width: 66px;">Габ-ная высота изделия, см <br><i class="las la-angle-down"></i></th>
                                    <th v-if="orderMode != 7" style="width: 66px;">Габаритные размеры упаковки<br><i class="las la-angle-down"></i></th>
                                    <th v-if="orderMode != 7"></th>
                                    <th style="width: 74px;">Кол-во (шт.) <br><i class="las la-angle-down"></i></th>
                                    <th>Сторона управления <br><i class="las la-angle-down"></i></th>
                                    <th v-if="orderMode != 4 && orderMode != 5">Намотка ткани <br><i class="las la-angle-down"></i></th>
                                    <th v-if="useAltBarcodes" style="width: 74px;">Тип штрих кода</th>
                                    <th v-if="useAltBarcodes" style="width: 74px;">Штрихкод</th>
                                    <th v-if="useAltBarcodes" style="width: 74px;">Текстовое поле ШК</th>

<!--                                    <th class="noAfter" style="width: 68px;">Цена без скидки <br><i class="las la-angle-down"></i></th>-->

                                    <th style="width: 68px;">Цена за одно изделие (прайс) <br><i class="las la-angle-down"></i></th>
                                    <th style="width: 68px;">Цена за одно изделие со скидкой <br><i class="las la-angle-down"></i></th>
                                    <th class="noAfter" style="width: 68px;">Цена общая со скидкой <br><i class="las la-angle-down"></i></th>

                                    <th class="noAfter"></th>
                                    <th class="text-right noAfter"></th>
                                    <th class="noAfter" style="width: 6px;"></th>
                                </tr>
                                </thead>
                                <tbody v-if="rmOpened && items[0] && (orderMode == 1 || orderMode == 4 || orderMode == 5 || orderMode == 7 || orderMode == 9 || orderMode == 10)">
                                <!-- eslint-disable -->
                                <tr v-for="(item, index) in items" v-bind:key="index" v-bind:class="{ redBack: item.template.amount == 0 }">
                                    <!-- eslint-enable -->
                                    <td></td>
                                    <td v-if="(mode == 1 || mode == 3) && !isStorageAdmin" class="systemSelect" data-label="Тип изделия">
<!--                                        <select v-model="item.mid" class="form-control" @change="changeType(index, item.mid)">-->
<!--                                            <option v-for="type in types" v-bind:key="type.mid" :value="type.mid">-->
<!--&lt;!&ndash;                                                {{ type.nameRu }} {{ type.name }}&ndash;&gt;-->
<!--                                                {{ type.name }}-->
<!--                                            </option>-->
<!--                                        </select>-->

                                        <div class="button">
                                            <div>
                                                <img v-if="item.mid == 140 || item.mid == 141" src="./../assets/img/hblinds_ball.png" />
                                                <img v-else src="./../assets/img/rolo_ball.png" />
                                            </div>
                                            <div class="text" @click="openSystems(index)">{{ typesAll[item.mid].name}}</div>
                                        </div>
                                        <div v-if="item.systemsState" class="overlay" @click="overlayClick()"></div>
                                        <div v-if="item.systemsState" class="content">
                                            <ul v-if="orderMode == 1" class="select2-results__options">
                                                <li class="select2-results__option" v-for="type in sortedTypes          " v-bind:key="type.mid" @click="selectSystem(type.mid, index)">
                                                    <div class="select2_el izds">
                                                        <img v-if="item.mid == 140 || item.mid == 141" src="./../assets/img/hblinds_ball.png" />
                                                        <img v-else src="./../assets/img/rolo_ball.png" />
                                                        <span class="name">{{ typesAll[type.mid].name }}</span>
                                                    </div>
                                                </li>
                                            </ul>

                                            <ul v-else class="select2-results__options">
                                                <li class="select2-results__option" v-for="type in types" v-bind:key="type.mid" @click="selectSystem(type.mid, index)">
                                                    <div class="select2_el izds">
                                                        <img v-if="item.mid == 140 || item.mid == 141" src="./../assets/img/hblinds_ball.png" />
                                                        <img v-else src="./../assets/img/rolo_ball.png" />
                                                        <span class="name">{{ typesAll[type.mid].name }}</span>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                    <td v-if="mode == 2 || isStorageAdmin" class="systemSelect" data-label="Тип изделия">
<!--                                        <select v-model="item.mid" class="form-control" @change="changeType(index, item.mid)">-->
<!--                                            &lt;!&ndash; eslint-disable &ndash;&gt;-->
<!--                                            <option v-for="type in types" v-if="storageMids.indexOf(type.mid) != -1" v-bind:key="type.mid" :value="type.mid">-->
<!--&lt;!&ndash;                                                 {{ type.nameRu }} {{ type.name }}&ndash;&gt;-->
<!--                                                 {{ type.name }}-->
<!--                                            </option>-->
<!--                                            &lt;!&ndash; eslint-enable &ndash;&gt;-->
<!--                                        </select>-->

                                        <div class="button">
                                            <div>
                                                <img v-if="item.mid == 140 || item.mid == 141" src="./../assets/img/hblinds_ball.png" />
                                                <img v-else src="./../assets/img/rolo_ball.png" />
                                            </div>
                                            <div class="text" @click="openSystems(index)">{{ typesAll[item.mid].name}}</div>
                                        </div>
                                        <div v-if="item.systemsState" class="overlay" @click="overlayClick()"></div>
                                        <div v-if="item.systemsState" class="content">
                                            <ul class="select2-results__options">
                                                <!-- eslint-disable -->
                                                <li class="select2-results__option" v-for="type in types" v-if="storageMids.indexOf(type.mid) != -1" v-bind:key="type.mid" @click="selectSystem(type.mid, index)">
                                                    <div class="select2_el izds">
                                                        <img v-if="item.mid == 140 || item.mid == 141" src="./../assets/img/hblinds_ball.png" />
                                                        <img v-else src="./../assets/img/rolo_ball.png" />
                                                        <span class="name">{{ typesAll[type.mid].name }}</span>
                                                    </div>
                                                </li>
                                                <!-- eslint-enable -->
                                            </ul>
                                        </div>
                                    </td>
                                    <td v-if="item.mid == 5">

                                    </td>
                                    <td v-if="item.mid == 6">
                                        <button class="btn btn-primary remove" @click="$modal.show('modalRolo')"><i class="las la-info"></i></button>
                                    </td>
                                    <td v-if="item.mid == 140">
                                        <button class="btn btn-primary remove" @click="$modal.show('modalBlister')"><i class="las la-info"></i></button>
                                    </td>
                                    <td v-else-if="item.mid == 141">
                                        <button class="btn btn-primary remove" @click="$modal.show('modalCarton')"><i class="las la-info"></i></button>
                                    </td>
                                    <td v-if="item.mid == 15">
                                        <button class="btn btn-primary remove" @click="$modal.show('modalCarton2')"><i class="las la-info"></i></button>
                                    </td>
                                    <td v-if="item.mid == 16 || item.mid == 13">
                                    </td>
                                    <td v-else-if="item.mid == 17">
                                        <button class="btn btn-primary remove" @click="$modal.show('modal140')"><i class="las la-info"></i></button>
                                    </td>
                                    <td class="fabricSelect" data-label="Материал" :class="{ barcodesMaterial: useAltBarcodes }">
                                        <div class="button">
                                            <div>
                                                <silentbox-single :src="'https://sale.katris.ru/uploads/___res_w600_q60/images/saleKatrisCatalog/' + item.materials[item.template.material].img + '.png'" :autoplay="true" :description="item.materials[item.template.material].name">
                                                    <img :src="'https://sale.katris.ru/uploads/___res_w80_q60/images/saleKatrisCatalog/' + item.materials[item.template.material].img + '.png'" :alt="item.materials[item.template.material].name" />
                                                </silentbox-single>
                                            </div>
                                            <div class="text" @click="openFabric(index)">{{ item.materials[item.template.material].name }}</div>
                                        </div>
                                        <div v-if="item.fabricState" class="overlay" @click="overlayClick()"></div>
                                        <div v-if="item.fabricState" class="content">
                                            <div class="row">
                                                <div class="col-12">
                                                    <input v-model="search" class="form-control search" placeholder="Поиск по наименованию"/>
                                                </div>
                                            </div>
                                            <div v-if="(mode == 1 || mode == 3) && !isStorageAdmin" class="row scroll">
                                                <div v-for="fabric in filteredList" v-bind:key="fabric.id_good"
                                                     class="col-4">
                                                    <figure v-if="fabric.available == 'green'" @click="selectFabric(fabric.id_good, index)">
                                                        <img v-if="fabric.action && fabric.actionMids.indexOf(String(item.mid)) != -1" style="position: absolute; max-width: 60px;" :src="'https://sale.katris.ru/uploads/images/saleKatrisActions/' + fabric.actionImage">
                                                        <img :alt="fabric.name" :src="'https://sale.katris.ru/uploads/___res_w200_q60/images/saleKatrisCatalog/' + fabric.img + '.png'">
                                                        <figcaption>
                                                            {{ fabric.name }}
<!--                                                            <span v-if="fabric.action" style="font-weight: bold; color: red">Скидка {{fabric.actionSale}}%</span>-->
                                                            <span v-if="fabric.action && fabric.actionMids.indexOf(String(item.mid)) != -1" style="font-weight: bold; color: red">Акция</span>
                                                        </figcaption>
                                                    </figure>
                                                    <figure v-if="fabric.available == 'yellow'" style="background-color: rgba(255,249,134,0.76)" @click="selectFabric(fabric.id_good, index)">
                                                        <img v-if="fabric.action && fabric.actionMids.indexOf(String(item.mid)) != -1" style="position: absolute; max-width: 60px;" :src="'https://sale.katris.ru/uploads/images/saleKatrisActions/' + fabric.actionImage">
                                                        <img :alt="fabric.name" :src="'https://sale.katris.ru/uploads/___res_w200_q60/images/saleKatrisCatalog/' + fabric.img + '.png'">
<!--                                                        <figcaption>{{ fabric.name }} <span v-if="fabric.action" style="font-weight: bold; color: red">Скидка {{fabric.actionSale}}%</span> - Остаток {{ fabric.gdsInStock }}м</figcaption>-->
                                                        <figcaption>{{ fabric.name }} <span v-if="fabric.action && fabric.actionMids.indexOf(String(item.mid)) != -1" style="font-weight: bold; color: red">Акция</span> - Остаток {{ fabric.gdsInStock }}м</figcaption>
                                                    </figure>
                                                    <figure v-else-if="fabric.available == 'red'" style="background-color: rgba(255, 134, 134, 0.76)">
                                                        <img v-if="fabric.action && fabric.actionMids.indexOf(String(item.mid)) != -1" style="position: absolute; max-width: 60px;" :src="'https://sale.katris.ru/uploads/images/saleKatrisActions/' + fabric.actionImage">
                                                        <img :alt="fabric.name" :src="'https://sale.katris.ru/uploads/___res_w200_q60/images/saleKatrisCatalog/' + fabric.img + '.png'">
                                                        <figcaption>
                                                            {{ fabric.name }} - Временно нет в наличии!
                                                            <button v-if="!fabric.notify" class="btn btn-outline-primary btn-sm btn-block mt-2" @click="notifyMe(fabric)"><i class="las la-bell"></i> Уведомить</button>
                                                            <button v-if="fabric.notify" class="btn btn-outline-primary btn-sm btn-block mt-2" style="font-size: 12px; height: 31px;" @click="disableNotifications(fabric)"><i class="las la-bell-slash"></i> Не уведомлять</button>
                                                        </figcaption>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div v-if="mode == 2 || isStorageAdmin" class="row scroll">
                                                <!-- eslint-disable -->
                                                <div v-for="fabric in filteredList" v-if="storageGroups[item.mid].materials[fabric.id_good]" v-bind:key="fabric.id_good" class="col-4">
                                                    <!-- eslint-enable -->
                                                    <figure v-if="storageGroups[item.mid].materials[fabric.id_good].available || (mode == 1 && isStorageAdmin)" @click="selectFabric(fabric.id_good, index)">
                                                        <img v-if="fabric.storageAction && fabric.storageActionMids.indexOf(String(item.mid)) != -1" style="position: absolute; max-width: 60px;" :src="'https://sale.katris.ru/uploads/images/saleKatrisActions/' + fabric.storageActionImage">
                                                        <img :alt="fabric.name" :src="'https://sale.katris.ru/uploads/images/saleKatrisCatalog/' + fabric.img + '.png'">
                                                        <figcaption>
                                                            {{ fabric.name }}
                                                            <span v-if="fabric.storageAction && fabric.storageActionMids.indexOf(String(item.mid)) != -1" style="font-weight: bold; color: red">Акция</span>
                                                        </figcaption>
                                                    </figure>
                                                    <figure v-else style="background-color: rgba(255, 134, 134, 0.76)">
                                                        <img v-if="fabric.storageAction && fabric.storageActionMids.indexOf(String(item.mid)) != -1" style="position: absolute; max-width: 60px;" :src="'https://sale.katris.ru/uploads/images/saleKatrisActions/' + fabric.storageActionImage">
                                                        <img :alt="fabric.name" :src="'https://sale.katris.ru/uploads/images/saleKatrisCatalog/' + fabric.img + '.png'">
                                                        <figcaption>
                                                            {{ fabric.name }} - Временно нет в наличии!
                                                        </figcaption>
                                                    </figure>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td v-if="(mode == 1 || mode == 3) && !isStorageAdmin" data-label="Ширина, см">
                                        <select v-if="item.template.mid == 141" v-model="item.template.gab_width" class="form-control"
                                                @change="changeSize(index, 0)">
                                            <!-- eslint-disable -->
                                            <option v-for="(option, index) in item.prices[item.template.material][item.template.gab_height]" v-bind:key="index" :value="index" v-if="gFormCarton.indexOf(index / 10) != -1">{{ index / 10 }}</option>
                                            <!-- eslint-enable -->
                                        </select>
                                        <select v-else v-model="item.template.gab_width" class="form-control"
                                                @change="changeSize(index, 0)">
                                            <option
                                                v-for="(option, index) in item.prices[item.template.material][item.template.gab_height]"
                                                v-bind:key="index" :value="index">{{ index / 10 }}
                                            </option>
                                        </select>
                                    </td>
                                    <td v-if="(mode == 1 || mode == 3) && !isStorageAdmin" data-label="Высота, см">
                                        <span v-if="Object.keys(item.prices[item.template.material]).length == 1">{{ item.template.gab_height / 10 }}</span>
                                        <select v-else v-model="item.template.gab_height" class="form-control"
                                                @change="changeSize(index, 1)">
                                            <option v-for="(option, index) in item.prices[item.template.material]"
                                                    v-bind:key="index" :value="index">{{ index / 10 }}
                                            </option>
                                        </select>
                                    </td>
                                    <td v-if="(mode == 1 || mode == 3) && isStorageAdmin" data-label="Ширина, см">
                                        <select v-if="storageGroups[item.mid].materials[item.template.material]" v-model="item.template.gab_width"
                                                class="form-control"
                                                @change="changeSize(index, 0)">
                                            <!-- eslint-disable -->
                                            <option
                                                v-for="(option, index) in storageGroups[item.mid].materials[item.template.material].heights[item.template.gab_height].widths" v-if="storageGroups[item.mid].materials[item.template.material].heights[item.template.gab_height].widths[index].controlSides[item.template.ControlSide]" v-bind:key="index" :value="index">{{ index / 10 }}
                                            </option>
                                            <!-- eslint-enable -->
                                        </select>
                                    </td>
                                    <td v-if="mode == 2" data-label="Ширина, см">
                                        <select v-if="storageGroups[item.mid].materials[item.template.material]" v-model="item.template.gab_width"
                                                class="form-control"
                                                @change="changeSize(index, 0)">
                                            <!-- eslint-disable -->
                                            <option
                                                v-for="(option, index) in storageGroups[item.mid].materials[item.template.material].heights[item.template.gab_height].widths"
                                                v-if="storageGroups[item.mid].materials[item.template.material].heights[item.template.gab_height].widths[index].controlSides[item.template.ControlSide] && storageGroups[item.mid].materials[item.template.material].heights[item.template.gab_height].widths[index].controlSides[item.template.ControlSide].count > 0 && storageGroups[item.mid].materials[item.template.material].heights[item.template.gab_height].widths[index].controlSides[item.template.ControlSide].count >= item.prices[item.template.material][item.template.gab_height][item.template.gab_width].amount"
                                                v-bind:key="index" :value="index">{{ index / 10 }}
                                            </option>
                                            <!-- eslint-enable -->
                                        </select>
                                    </td>
                                    <td v-if="(mode == 2 && !isStorageAdmin) && storageGroups[item.mid].materials[item.template.material]" data-label="Высота, см">
                                        <span v-if="item.mid != 141">{{ item.template.gab_height / 10 }}</span>

                                        <select v-else-if="storageGroups[item.mid].materials[item.template.material]" v-model="item.template.gab_height"
                                                class="form-control"
                                                @change="changeSize(index, 0)">
                                            <!-- eslint-disable -->
                                            <option
                                                v-for="(option, index) in storageGroups[item.mid].materials[item.template.material].heights"
                                                v-if="storageGroups[item.mid].materials[item.template.material].heights[index].widths[item.template.gab_width] &&
                                                storageGroups[item.mid].materials[item.template.material].heights[index].widths[item.template.gab_width].controlSides[item.template.ControlSide] &&
                                                storageGroups[item.mid].materials[item.template.material].heights[index].widths[item.template.gab_width].controlSides[item.template.ControlSide].count > 0 &&
                                                storageGroups[item.mid].materials[item.template.material].heights[index].widths[item.template.gab_width].controlSides[item.template.ControlSide].count >= item.prices[item.template.material][item.template.gab_height][item.template.gab_width].amount"
                                                v-bind:key="index" :value="index">{{ index / 10 }}
                                            </option>
                                            <!-- eslint-enable -->
                                        </select>
                                    </td>
                                    <td v-if="(mode == 1 && isStorageAdmin) && storageGroups[item.mid].materials[item.template.material]" data-label="Высота, см">
                                        <span v-if="item.mid != 141">{{ item.template.gab_height / 10 }}</span>

                                        <select v-else-if="storageGroups[item.mid].materials[item.template.material]" v-model="item.template.gab_height"
                                                class="form-control"
                                                @change="changeSize(index, 0)">
                                            <!-- eslint-disable -->
                                            <option
                                                v-for="(option, index) in storageGroups[item.mid].materials[item.template.material].heights"
                                                v-if="storageGroups[item.mid].materials[item.template.material].heights[index].widths[item.template.gab_width] &&
                                                storageGroups[item.mid].materials[item.template.material].heights[index].widths[item.template.gab_width].controlSides[item.template.ControlSide]"
                                                v-bind:key="index" :value="index">{{ index / 10 }}
                                            </option>
                                            <!-- eslint-enable -->
                                        </select>
                                    </td>

                                    <td v-if="orderMode !=7">{{item.template.packSize}}</td>
                                    <td v-if="orderMode !=7"><button class="btn btn-primary remove" @click="openInfo(item.template)"><i class="las la-info"></i></button></td>

                                    <td v-if="(mode == 1 || mode == 3)" data-label="Кол-во, шт">
                                        <select v-if="orderMode == 4" v-model="item.template.amount" class="form-control"
                                                @change="changeAmount(index)">
                                            <option v-for="n in 125"
                                                    v-bind:key="n"
                                                    :value="n * item.prices[item.template.material][item.template.gab_height][item.template.gab_width].amount">
                                                {{ n * item.prices[item.template.material][item.template.gab_height][item.template.gab_width].amount }}
                                            </option>
                                        </select>

                                        <select v-else v-model="item.template.amount" class="form-control" @change="changeAmount(index)">
                                            <option v-for="n in 40" v-bind:key="n" :value="n * item.prices[item.template.material][item.template.gab_height][item.template.gab_width].amount">
                                                {{ n * item.prices[item.template.material][item.template.gab_height][item.template.gab_width].amount }}
                                            </option>
                                        </select>
                                    </td>
                                    <td v-if="mode == 2" data-label="Кол-во, шт">
                                        <select v-if="storageGroups[item.mid].materials[item.template.material] && storageGroups[item.mid].materials[item.template.material].heights[item.template.gab_height].widths[item.template.gab_width]" v-model="item.template.amount"
                                                class="form-control"
                                                @change="changeAmount(index)">
                                            <option
                                                v-for="n in parseInt(Number(storageGroups[item.mid].materials[item.template.material].heights[item.template.gab_height].widths[item.template.gab_width].controlSides[item.template.ControlSide].count) / item.prices[item.template.material][item.template.gab_height][item.template.gab_width].amount)"
                                                v-bind:key="n"
                                                :value="n * item.prices[item.template.material][item.template.gab_height][item.template.gab_width].amount">
                                                {{ n * item.prices[item.template.material][item.template.gab_height][item.template.gab_width].amount }}
                                            </option>
                                        </select>

                                        <span style="display: block; text-decoration: underline; color: red" v-if="allowBuyMore && Number(storageGroups[item.mid].materials[item.template.material].heights[item.template.gab_height].widths[item.template.gab_width].controlSides[item.template.ControlSide].count) < item.template.amount">{{ item.template.amount }}</span>
                                    </td>
                                    <td v-if="(mode == 1 || mode == 3)" data-label="Сторона управления">
                                        <select v-if="item.params.ControlSide && item.template" v-model="item.template.ControlSide" class="form-control" @change="recalc(index, item.mid)">
                                            <option value="1">Левая</option>
                                            <option value="2">Правая</option>
                                        </select>
                                    </td>
                                    <td v-if="mode == 2" data-label="Сторона управления">
                                        <span v-if="Object.keys(storageGroups[item.mid].materials[item.template.material].heights[item.template.gab_height].widths[item.template.gab_width].controlSides).length == 1">
                                            <span v-if="item.params.ControlSide && item.template.ControlSide == 1">Левая</span>
                                            <span v-else-if="item.params.ControlSide && item.template.ControlSide == 2">Правая</span>
                                        </span>
                                        <select v-else v-model="item.template.ControlSide" class="form-control" @change="changeControlSide(item, index)">
                                            <option value="1">Левая</option>
                                            <option value="2">Правая</option>
                                        </select>
                                    </td>
                                    <td v-if="item.mid != 140 && item.mid != 141 && ((mode == 1 || mode == 3) && !isStorageAdmin)" data-label="Намотка ткани">
<!--                                        <select-->
<!--                                            v-if="item.params.BackWrap && [9505,30004698,10001,9507,30004697,30004699,30004700,30004701,30004702,30004703,30004704,30004705,30004706,30004707,30004708].indexOf(item.template.material) != -1"-->
<!--                                            v-model="item.template.BackWrap" class="form-control"-->
<!--                                            v-bind:class="{ redBorder: item.template.BackWrap == 0 }"-->
<!--                                            @change="recalc(index, item.mid)">-->
<!--                                            <option value="0">-</option>-->
<!--                                            <option value="1">Прямая</option>-->
<!--                                            <option value="2">Обратная</option>-->
<!--                                        </select>-->
                                        <select
                                            v-if="item.params.BackWrap && [9505,30004698,10001,9507,30004697,30004699,30004700,30004701,30004702,30004703,30004704,30004705,30004706,30004707,30004708,30005847,30005848,30007718].indexOf(item.template.material) != -1"
                                            v-model="item.template.BackWrap" class="form-control"
                                            v-bind:class="{ redBorder: item.template.BackWrap == 0 }"
                                            @change="recalc(index, item.mid)">
                                            <option value="0">-</option>
                                            <option value="1">Прямая</option>
                                            <option value="2">Обратная</option>
                                        </select>
                                        <span v-else-if="item.params.BackWrap">Прямая</span>
                                        <span v-else>-</span>
                                    </td>
                                    <td v-else-if="mode == 2 || isStorageAdmin" data-label="Намотка ткани">
                                        <span v-if="item.params.BackWrap && item.template.BackWrap == 1">Прямая</span>
                                        <span v-else-if="item.params.BackWrap && item.template.BackWrap == 2">Обратная</span>
                                        <span v-else>-</span>
                                    </td>
                                    <td v-if="useAltBarcodes" data-label="Тип штрихкода">
                                        <select v-model="item.template.barcodeType" @change="searchBarcodeForItem(item)" class="form-control">
                                            <option value="1">EAN 13</option>
                                            <option value="2">Code 39</option>
                                        </select>
                                    </td>
                                    <td v-if="useAltBarcodes" data-label="Штрихкод">
                                        <input v-model="item.template.barcode" @change="updateExcelData()" type="text" class="form-control" v-bind:class="{ redBorder: item.template.barcodeRed }" />
                                    </td>
                                    <td v-if="useAltBarcodes" data-label="Текстовое поле ШК">
                                        <input v-model="item.template.barcodeText1" @change="updateExcelData()" type="text" class="form-control mb-1" v-bind:class="{ redBorder: item.template.barcodeRed }" :maxlength="50" />
                                        <input v-model="item.template.barcodeText2" @change="updateExcelData()" type="text" class="form-control mb-1" v-bind:class="{ redBorder: item.template.barcodeRed }" :maxlength="50" />
                                        <input v-model="item.template.barcodeText3" @change="updateExcelData()" type="text" class="form-control" v-bind:class="{ redBorder: item.template.barcodeRed }" :maxlength="50" />
                                    </td>

<!--                                    <td data-label="Цена без скидки">{{ item.template.price | fixed }}</td>-->

                                    <td data-label="Цена за 1 изделие (прайс)">{{ item.template.price / item.template.amount | fixed }}</td>
                                    <td v-if="item.template.sale == 0" data-label="Цена за 1 изделие со скидкой">{{ (item.template.price - (rm.basket.totalSale / 100 * item.template.price)) / item.template.amount | fixed }}</td>
                                    <td v-else data-label="Цена за 1 изделие со скидкой">{{ (item.template.price - (item.template.sale / 100 * item.template.price)) / item.template.amount | fixed }}</td>
                                    <td v-if="item.template.sale == 0" data-label="Цена общая со скидкой">{{ item.template.price - (rm.basket.totalSale / 100 * item.template.price) | fixed }}</td>
                                    <td v-else data-label="Цена общая со скидкой">{{ item.template.price - (item.template.sale / 100 * item.template.price) | fixed }}</td>

                                    <td data-label="Удалить">
                                        <button class="btn btn-primary remove" @click="remove(index)"><i class="las la-trash"></i></button>
                                    </td>
                                    <td class="text-right" data-label="Копировать">
                                        <button class="btn btn-primary remove" @click="copy(index)"><i
                                            class="lar la-copy"></i></button>
                                    </td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                </tbody>
                                <tbody v-else-if="rmOpened && (orderMode == 1 || orderMode == 4 || orderMode == 5 || orderMode == 7 || orderMode == 9 || orderMode == 10)">
                                <tr>
                                    <td colspan="11"><h3>Пусто</h3></td>
                                </tr>
                                </tbody>
                            </table>
                            <table class="table readyMadeTable" v-if="rmOpened && mode == 1 && orderMode == 2">
                                <tr><td colspan="11"><h3 style="padding: 10px 0px">Карниз V-FORM RM</h3></td></tr>
                                <tr class="hideMobile">
                                    <th class="noAfter" style=""></th>
                                    <th style="">Тип крепления <br><i class="las la-angle-down"></i></th>
                                    <th style="">Тип раздвижки ламелей <br><i class="las la-angle-down"></i></th>
                                    <th style="">Длина <br><i class="las la-angle-down"></i></th>
                                    <th v-if="orderMode !=7" style="width: 66px;" >Габаритные размеры упаковки<br><i class="las la-angle-down"></i></th>
                                    <th v-if="orderMode !=7"></th>
                                    <th style="">Высота управления <br><i class="las la-angle-down"></i></th>
                                    <th style="">Кол-во (шт.)<br> Мин: 2, Макс: 100<br><i class="las la-angle-down"></i></th>
                                    <th v-if="useAltBarcodes" style="width: 74px;">Тип штрих кода</th>
                                    <th v-if="useAltBarcodes" style="width: 74px;">Штрихкод</th>
                                    <th v-if="useAltBarcodes" style="width: 74px;">Текстовое поле ШК</th>

<!--                                    <th class="noAfter" style="">Цена без скидки <br><i class="las la-angle-down"></i></th>-->

                                    <th class="noAfter" style="width: 68px;">Цена за одно изделие (прайс) <br><i class="las la-angle-down"></i></th>
                                    <th class="noAfter" style="width: 68px;">Цена за одно изделие со скидкой <br><i class="las la-angle-down"></i></th>
                                    <th class="noAfter" style="width: 68px;">Цена общая со скидкой <br><i class="las la-angle-down"></i></th>

                                    <th class="noAfter" style="width: 52px"></th>
                                    <th class="text-right noAfter" style="width: 52px"></th>
                                    <th class="noAfter" style="width: 6px;"></th>
                                </tr>
                                <tbody v-if="itemsCorniceVertical[0]">
                                <tr v-for="(item, index) in itemsCorniceVertical" v-bind:key="index">
                                    <td></td>
                                    <td data-label="Тип крепления">
                                        <select v-model="item.template.mountType" @change="recalc(index, 201)" class="form-control">
                                            <option value="1">Потолок</option>
                                            <option value="2">Стена</option>
                                            <option value="3">Стена с удлинителем</option>
                                        </select>
                                    </td>
                                    <td data-label="Тип раздвижки ламелей">
                                        <select v-model="item.template.drive" class="form-control" @change="checkLamelsType(item, index)">
                                            <option value="1">К механизму управления</option>
                                            <option value="2">От центра в две стороны</option>
                                            <option value="3">От механизма управления</option>
                                        </select>
                                    </td>
                                    <td data-label="Длина">
                                        <span v-if="item.template.drive == 1">
                                            <select v-model="item.template.corniceSize" @change="recalc(index, 201)" class="form-control">
                                                <option v-for="(length, index) in vFormLenghtsToMech" v-bind:key="index">{{length}}</option>
                                            </select>
                                        </span>
                                        <span v-else>
                                            <select v-model="item.template.corniceSize" @change="recalc(index, 201)" class="form-control">
                                                <option v-for="(length, index) in vFormLenghtsFromMech" v-bind:key="index">{{length}}</option>
                                            </select>
                                        </span>
                                    </td>

                                    <td v-if="orderMode !=7">{{item.template.packSize}}</td>
                                    <td v-if="orderMode !=7"><button class="btn btn-primary remove" @click="openInfo(item.template)"><i class="las la-info"></i></button></td>

                                    <td data-label="Высота управления">
                                        180 см
                                    </td>
                                    <td data-label="Кол-во">
                                        <input type="number" class="form-control" @change="() => { if (item.template.amount > 100) { item.template.amount = 100 }; if (item.template.amount < 2) { item.template.amount = 2 }; if (item.template.amount % 2 > 0) { item.template.amount = item.template.amount - (item.template.amount % 2) }; recalc(index, 201)}" v-model="item.template.amount" />
                                    </td>
                                    <td v-if="useAltBarcodes" data-label="Тип штрихкода">
                                        <select v-model="item.template.barcodeType" @change="searchBarcodeForItem(item)" class="form-control">
                                            <option value="1">EAN 13</option>
                                            <option value="2">Code 39</option>
                                        </select>
                                    </td>
                                    <td v-if="useAltBarcodes" data-label="Штрихкод">
                                        <input v-model="item.template.barcode" @change="updateExcelData()" type="text" class="form-control" v-bind:class="{ redBorder: item.template.barcodeRed }" />
                                    </td>
                                    <td v-if="useAltBarcodes" data-label="Текстовое поле ШК">
                                        <input v-model="item.template.barcodeText1" @change="updateExcelData()" type="text" class="form-control mb-1" v-bind:class="{ redBorder: item.template.barcodeRed }" :maxlength="50" />
                                        <input v-model="item.template.barcodeText2" @change="updateExcelData()" type="text" class="form-control mb-1" v-bind:class="{ redBorder: item.template.barcodeRed }" :maxlength="50" />
                                        <input v-model="item.template.barcodeText3" @change="updateExcelData()" type="text" class="form-control" v-bind:class="{ redBorder: item.template.barcodeRed }" :maxlength="50" />
                                    </td>

<!--                                    <td data-label="Цена без скидки">{{ item.template.price | fixed }}</td>-->

                                    <td data-label="Цена за 1 изделие (прайс)">{{ item.template.price / item.template.amount | fixed }}</td>
                                    <td v-if="item.template.sale == 0" data-label="Цена за 1 изделие со скидкой">{{ (item.template.price - (rm.basket.totalSale / 100 * item.template.price)) / item.template.amount | fixed }}</td>
                                    <td v-else data-label="Цена за 1 изделие со скидкой">{{ (item.template.price - (item.template.sale / 100 * item.template.price)) / item.template.amount | fixed }}</td>
                                    <td v-if="item.template.sale == 0" data-label="Цена общая со скидкой">{{ item.template.price - (rm.basket.totalSale / 100 * item.template.price) | fixed }}</td>
                                    <td v-else data-label="Цена общая со скидкой">{{ item.template.price - (item.template.sale / 100 * item.template.price) | fixed }}</td>

                                    <td data-label="">
                                        <button class="btn btn-primary remove" @click="removeVFormCornice(index)"><i class="las la-trash"></i></button>
                                    </td>
                                    <td class="text-right" data-label="Копировать">
                                        <button class="btn btn-primary remove" @click="copyVFormCornice(index)"><i
                                            class="lar la-copy"></i></button>
                                    </td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                </tbody>
                                <tbody v-else="">
                                <tr>
                                    <td colspan="11"><h3>Пусто</h3></td>
                                </tr>
                                </tbody>
                                <tbody>
                                <tr>
                                    <td colspan="11">
                                        <div v-if="rmOpened" class="row">
                                            <div class="col-md-4">
                                            </div>
                                            <div class="col-md-4 text-center">
                                            </div>
                                            <div class="col-md-4 text-right mt-3">
                                                <button v-if="(mode == 1 || mode == 3)" class="btn btn-outline-primary mr-2 mb-1" @click="addNewCorniceVertical()"><i
                                                    class="las la-plus"></i> Добавить изделие
                                                </button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <table class="table readyMadeTable" v-if="rmOpened && mode == 1 && orderMode == 8">
<!--                            <table class="table readyMadeTable" v-if="rmOpened && mode == 1 && orderMode == 2">-->
                                <tr><td colspan="11"><h3 style="padding: 10px 0px">Ткань V-FORM RM</h3></td></tr>
                                <tr class="hideMobile">
                                    <th class="noAfter" style=""></th>
                                    <th style="width: 355px;">Материал <br><i class="las la-angle-down"></i></th>
                                    <th style="">Количество ламелей <br><i class="las la-angle-down"></i></th>
                                    <th style="">Габаритная высота изделия<br><i class="las la-angle-down"></i></th>
                                    <th v-if="orderMode !=7" style="width: 66px;" >Габаритные размеры упаковки<br><i class="las la-angle-down"></i></th>
                                    <th v-if="orderMode !=7"></th>
                                    <th style="">Кол-во (шт.)<br> Мин: 1, Макс: 99<br><i class="las la-angle-down"></i></th>
                                    <th v-if="useAltBarcodes" style="width: 74px;">Тип штрих кода</th>
                                    <th v-if="useAltBarcodes" style="width: 74px;">Штрихкод</th>
                                    <th v-if="useAltBarcodes" style="width: 74px;">Текстовое поле ШК</th>
<!--                                    <th class="noAfter" style="width: 165px">Цена без скидки <br><i class="las la-angle-down"></i></th>-->

                                    <th class="noAfter" style="width: 68px;">Цена за одно изделие (прайс) <br><i class="las la-angle-down"></i></th>
                                    <th class="noAfter" style="width: 68px;">Цена за одно изделие со скидкой <br><i class="las la-angle-down"></i></th>
                                    <th class="noAfter" style="width: 68px;">Цена общая со скидкой <br><i class="las la-angle-down"></i></th>

                                    <th class="noAfter" style="width: 52px"></th>
                                    <th class="text-right noAfter" style="width: 52px"></th>
                                    <th class="noAfter" style="width: 6px;"></th>
                                </tr>
                                <tbody v-if="itemsMaterialVertical[0]">
                                <tr v-for="(item, index) in itemsMaterialVertical" v-bind:key="index">
                                    <td></td>
                                    <td data-label="Материал" class="fabricSelect">
                                        <div class="button">
                                            <div>
                                                <silentbox-single :src="'https://sale.katris.ru/uploads/___res_w600_q60/images/saleKatrisCatalog/' + item.materials[item.template.material].img + '.png'" :autoplay="true" :description="item.materials[item.template.material].name">
                                                    <img :src="'https://sale.katris.ru/uploads/___res_w80_q60/images/saleKatrisCatalog/' + item.materials[item.template.material].img + '.png'"
                                                         :alt="item.materials[item.template.material].name" />
                                                </silentbox-single>
                                            </div>
                                            <div class="text" @click="openFabric(index, 202)">{{ item.materials[item.template.material].name }}</div>
                                        </div>
                                        <div v-if="item.fabricState" class="overlay" @click="overlayClick()"></div>
                                        <div v-if="item.fabricState" class="content">
                                            <div class="row">
                                                <div class="col-12">
                                                    <input v-model="search" class="form-control search" placeholder="Поиск по наименованию"/>
                                                </div>
                                            </div>
                                            <div v-if="mode == 1" class="row scroll">
                                                <div v-for="fabric in filteredList" v-bind:key="fabric.id_good"
                                                     class="col-4">
                                                    <figure v-if="fabric.available == 'green'" @click="selectFabric(fabric.id_good, index, true)">
                                                        <img v-if="fabric.action && fabric.actionMids.indexOf(String(item.mid)) != -1" style="position: absolute; max-width: 60px;" :src="'https://sale.katris.ru/uploads/images/saleKatrisActions/' + fabric.actionImage">
                                                        <img :alt="fabric.name" :src="'https://sale.katris.ru/uploads/___res_w200_q60/images/saleKatrisCatalog/' + fabric.img + '.png'">
                                                        <figcaption>
                                                            {{ fabric.name }} <span v-if="fabric.action && fabric.actionMids.indexOf(String(item.mid)) != -1" style="font-weight: bold; color: red">Скидка {{fabric.actionSale}}%</span>
                                                        </figcaption>
                                                    </figure>
                                                    <figure v-if="fabric.available == 'yellow'" style="background-color: rgba(255,249,134,0.76)" @click="selectFabric(fabric.id_good, index, true)">
                                                        <img v-if="fabric.action && fabric.actionMids.indexOf(String(item.mid)) != -1" style="position: absolute; max-width: 60px;" :src="'https://sale.katris.ru/uploads/images/saleKatrisActions/' + fabric.actionImage">
                                                        <img :alt="fabric.name" :src="'https://sale.katris.ru/uploads/___res_w200_q60/images/saleKatrisCatalog/' + fabric.img + '.png'">
                                                        <figcaption>
                                                            {{ fabric.name }} <span v-if="fabric.action && fabric.actionMids.indexOf(String(item.mid)) != -1" style="font-weight: bold; color: red">Скидка {{fabric.actionSale}}%</span> - Остаток {{ fabric.gdsInStock }}м
                                                        </figcaption>
                                                    </figure>
                                                    <figure v-else-if="fabric.available == 'red'" style="background-color: rgba(255, 134, 134, 0.76)">
                                                        <img v-if="fabric.action && fabric.actionMids.indexOf(String(item.mid)) != -1" style="position: absolute; max-width: 60px;" :src="'https://sale.katris.ru/uploads/images/saleKatrisActions/' + fabric.actionImage">
                                                        <img :alt="fabric.name" :src="'https://sale.katris.ru/uploads/___res_w200_q60/images/saleKatrisCatalog/' + fabric.img + '.png'">
                                                        <figcaption>
                                                            {{ fabric.name }} - Временно нет в наличии!
                                                            <button v-if="!fabric.notify" class="btn btn-outline-primary btn-sm btn-block mt-2" @click="notifyMe(fabric)"><i class="las la-bell"></i> Уведомить</button>
                                                            <button v-if="fabric.notify" class="btn btn-outline-primary btn-sm btn-block mt-2" style="font-size: 12px; height: 31px;" @click="disableNotifications(fabric)"><i class="las la-bell-slash"></i> Не уведомлять</button>
                                                        </figcaption>
                                                    </figure>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td data-label="Количество ламелей">
                                        <select v-model="item.template.lamels" @change="recalc(index, 202)" class="form-control">
                                            <option value="10">10</option>
                                            <option value="15">15</option>
                                            <option value="20">20</option>
                                        </select>
                                    </td>
                                    <td data-label="Габаритная высота">
                                        <select v-model="item.template.height" @change="recalc(index, 202)" class="form-control">
                                            <option v-for="(height, index) in vFormHeights" v-bind:key="index">{{height}}</option>
                                        </select>
                                    </td>

                                    <td v-if="orderMode !=7">{{item.template.packSize}}</td>
                                    <td v-if="orderMode !=7"><button class="btn btn-primary remove" @click="openInfo(item.template)"><i class="las la-info"></i></button></td>

                                    <td data-label="Кол-во">
                                        <input type="number" class="form-control" @change="() => { if (item.template.amount > 99) { item.template.amount = 99 }; if (item.template.amount < 1) { item.template.amount = 1 }; recalc(index, 202)}" v-model="item.template.amount" />
                                    </td>
                                    <td v-if="useAltBarcodes" data-label="Тип штрихкода">
                                        <select v-model="item.template.barcodeType" @change="searchBarcodeForItem(item)" class="form-control">
                                            <option value="1">EAN 13</option>
                                            <option value="2">Code 39</option>
                                        </select>
                                    </td>
                                    <td v-if="useAltBarcodes" data-label="Штрихкод">
                                        <input v-model="item.template.barcode" @change="updateExcelData()" type="text" class="form-control" v-bind:class="{ redBorder: item.template.barcodeRed }" />
                                    </td>
                                    <td v-if="useAltBarcodes" data-label="Текстовое поле ШК">
                                        <input v-model="item.template.barcodeText1" @change="updateExcelData()" type="text" class="form-control mb-1" v-bind:class="{ redBorder: item.template.barcodeRed }" :maxlength="50" />
                                        <input v-model="item.template.barcodeText2" @change="updateExcelData()" type="text" class="form-control mb-1" v-bind:class="{ redBorder: item.template.barcodeRed }" :maxlength="50" />
                                        <input v-model="item.template.barcodeText3" @change="updateExcelData()" type="text" class="form-control" v-bind:class="{ redBorder: item.template.barcodeRed }" :maxlength="50" />
                                    </td>

<!--                                    <td data-label="Цена без скидки">{{ item.template.price | fixed }}</td>-->

                                    <td data-label="Цена за 1 изделие (прайс)">{{ item.template.price / item.template.amount | fixed }}</td>
                                    <td v-if="item.template.sale == 0" data-label="Цена за 1 изделие со скидкой">{{ (item.template.price - (rm.basket.totalSale / 100 * item.template.price)) / item.template.amount | fixed }}</td>
                                    <td v-else data-label="Цена за 1 изделие со скидкой">{{ (item.template.price - (item.template.sale / 100 * item.template.price)) / item.template.amount | fixed }}</td>
                                    <td v-if="item.template.sale == 0" data-label="Цена общая со скидкой">{{ item.template.price - (rm.basket.totalSale / 100 * item.template.price) | fixed }}</td>
                                    <td v-else data-label="Цена общая со скидкой">{{ item.template.price - (item.template.sale / 100 * item.template.price) | fixed }}</td>

                                    <td class="text-right" data-label="Удалить">
                                        <button class="btn btn-primary remove" @click="removeMaterial(index)"><i
                                            class="las la-trash"></i></button>
                                    </td>
                                    <td class="text-right" data-label="Копировать">
                                        <button class="btn btn-primary remove" @click="copyMaterial(index)"><i
                                            class="lar la-copy"></i></button>
                                    </td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td colspan="10" class="text-center">
                                        <span style="padding: 10px 0; font-size: 16px; text-decoration: underline">Габаритная высота изделия = высоте ламели + 4см.
                                            На этикетке (бирке) указана габаритная высота изделия</span>
                                    </td>
                                </tr>
                                </tbody>
                                <tbody v-else="">
                                <tr>
                                    <td colspan="11"><h3>Пусто</h3></td>
                                </tr>
                                </tbody>
                                <tbody>
                                <tr>
                                    <td colspan="11">
                                        <div v-if="rmOpened" class="row">
                                            <div class="col-md-4">
                                            </div>
                                            <div class="col-md-4 text-center">
                                            </div>
                                            <div class="col-md-4 text-right mt-3">
                                                <button v-if="mode == 1" class="btn btn-outline-primary mr-2 mb-1" @click="addNewMaterialVertical()"><i
                                                    class="las la-plus"></i> Добавить изделие
                                                </button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <table class="table readyMadeTable corniceTable" v-if="rmOpened && mode == 1 && orderMode == 3">
                                <tr><td colspan="11"><h3 style="padding: 10px 0px">Круглые карнизы RM</h3></td></tr>
                                <tr class="hideMobile">
                                    <th class="noAfter" style="width: 6px;"></th>
                                    <th style="width: 276px;">Тип карниза <br><i class="las la-angle-down"></i></th>
                                    <th class="noAfter" style="width: 277px;">Материал (цвет трубы) <br><i
                                        class="las la-angle-down"></i></th>
                                    <th style="width: 50px;"></th>
                                    <th style="width: 117px;">Длина трубы<br> 16 диаметра <br><i
                                        class="las la-angle-down"></i></th>
                                    <th style="width: 115px;">Кол-во шт. в коробке <br><i class="las la-angle-down"></i>
                                    </th>
                                    <th style="width: 107px;">Наконечник <br><i class="las la-angle-down"></i></th>

                                    <th v-if="useAltBarcodes" style="width: 74px;">Тип штрих кода</th>
                                    <th v-if="useAltBarcodes" style="width: 74px;">Штрихкод</th>
                                    <th v-if="useAltBarcodes" style="width: 74px;">Текстовое поле ШК</th>
<!--                                    <th class="noAfter" style="width: 71px;">Цена без скидки <br><i class="las la-angle-down"></i></th>-->

                                    <th class="noAfter" style="width: 68px;">Цена за одно изделие (прайс) <br><i class="las la-angle-down"></i></th>
                                    <th class="noAfter" style="width: 68px;">Цена за одно изделие со скидкой <br><i class="las la-angle-down"></i></th>
                                    <th class="noAfter" style="width: 68px;">Цена общая со скидкой <br><i class="las la-angle-down"></i></th>

                                    <th class="noAfter"></th>
                                    <th class="text-right noAfter"></th>
                                    <th class="noAfter" style="width: 6px;"></th>
                                </tr>
                                <tbody v-if="itemsCornice[0]">
                                    <tr v-for="(item, index) in itemsCornice" v-bind:key="index" v-bind:class="{ opened: item.corniceOpened }">
                                        <td>
                                            <div class="infoText" v-if="item.corniceOpened && item.mid == 101">
                                                <b>Длина карзиза, м:</b> {{corniceInfo[item.template.size].size}},
                                                <b>Трубы (16), шт.:</b> {{corniceInfo[item.template.size].pipes}},
                                                <b>Наконечник (Заглушка) пара, шт.:</b> {{corniceInfo[item.template.size].cap}},
                                                <b>Кольцо металлическое, шт.:</b> {{corniceInfo[item.template.size].ring}},
                                                <b>Крючок пластиковый, шт.:</b> {{corniceInfo[item.template.size].hook}},
                                                <b>Кронштейн 1й открытый, шт.:</b> {{corniceInfo[item.template.size].bracket}},
                                                <b>Соединитель (16), шт.:</b> {{corniceInfo[item.template.size].connector}}
                                            </div>
                                            <div class="infoText" v-else-if="item.corniceOpened && item.mid == 102">
                                                <b>Длина карзиза, м:</b> {{corniceInfo2[item.template.size].size}},
                                                <b>Трубы (16), шт.:</b> {{corniceInfo2[item.template.size].pipes}},
                                                <b>Наконечник (Заглушка) пара, шт.:</b> {{corniceInfo2[item.template.size].cap}},
                                                <b>Кольцо металлическое, шт.:</b> {{corniceInfo2[item.template.size].ring}},
                                                <b>Крючок пластиковый, шт.:</b> {{corniceInfo2[item.template.size].hook}},
                                                <b>Кронштейн 2й открытый, шт.:</b> {{corniceInfo2[item.template.size].bracket}},
                                                <b>Соединитель (16), шт.:</b> {{corniceInfo2[item.template.size].connector}}
                                            </div>
                                        </td>
                                        <td data-label="Тип карниза">
                                            <select v-model="item.mid" class="form-control" @change="changeType(index, item.mid)">
                                                <option v-for="type in typesCornice" v-bind:key="type.mid" :value="type.mid">{{ type.name }}
                                                </option>
                                            </select>
                                        </td>
                                        <td data-label="Материал (цвет трубы)">
                                            <select v-model="item.template.color" class="form-control" @change="changeColor(index)">
                                                <option value="antic">Антик</option>
                                                <option value="satin">Сатин</option>
                                                <option value="gold">Золото гл.</option>
                                                <option value="chrome">Хром</option>
                                            </select>
                                        </td>
                                        <td data-label="" v-bind:class="{ mobileOpened: item.corniceOpened }">
                                            <button class="btn btn-primary remove" @click="openCorniceInfo(item)"><i class="las la-info"></i></button>
                                        </td>
                                        <td data-label="Длина трубы 16 диаметра">
                                            <select v-model="item.template.size" class="form-control" @change="changeSize(index, 2)">
                                                <option :value="1.4">1.4</option>
                                                <option :value="1.6">1.6</option>
                                                <option :value="1.8">1.8</option>
                                                <option :value="2.0">2</option>
                                                <option :value="2.4">2.4</option>
                                                <option :value="2.8">2.8</option>
                                                <option :value="3.2">3.2</option>
                                            </select>
                                        </td>
                                        <td data-label="Кол-во шт. в  коробке">
                                            <select v-model="item.template.amount" class="form-control" @change="changeAmountCornice(index)">
                                                <option v-for="n in 20" v-bind:key="n" :value="n * item.prices[item.template.color][item.template.size].amount">
                                                    {{ n * item.prices[item.template.color][item.template.size].amount }}
                                                </option>
                                            </select>
                                        </td>
                                        <td data-label="Наконечник">
                                            <span style="padding: 6px 0px;display: inline-block;">Заглушка (16)</span>
                                        </td>
                                        <td v-if="useAltBarcodes" data-label="Тип штрихкода">
                                            <select v-model="item.template.barcodeType" @change="searchBarcodeForItem(item)" class="form-control">
                                                <option value="1">EAN 13</option>
                                                <option value="2">Code 39</option>
                                            </select>
                                        </td>
                                        <td v-if="useAltBarcodes" data-label="Штрихкод">
                                            <input v-model="item.template.barcode" type="text" class="form-control" v-bind:class="{ redBorder: item.template.barcodeRed }" />
                                        </td>
                                        <td v-if="useAltBarcodes" data-label="Текстовое поле ШК">
                                            <input v-model="item.template.barcodeText1" type="text" class="form-control mb-1" v-bind:class="{ redBorder: item.template.barcodeRed }" :maxlength="50" />
                                            <input v-model="item.template.barcodeText2" type="text" class="form-control mb-1" v-bind:class="{ redBorder: item.template.barcodeRed }" :maxlength="50" />
                                            <input v-model="item.template.barcodeText3" type="text" class="form-control" v-bind:class="{ redBorder: item.template.barcodeRed }" :maxlength="50" />
                                        </td>

<!--                                        <td data-label="Цена без скидки"><span style="padding: 6px 0px;display: inline-block;">{{ item.template.price | fixed }}</span></td>-->

                                        <td data-label="Цена за 1 изделие (прайс)">{{ item.template.price / item.template.amount | fixed }}</td>
                                        <td v-if="item.template.sale == 0" data-label="Цена за 1 изделие со скидкой">{{ (item.template.price - (rm.basket.totalSale / 100 * item.template.price)) / item.template.amount | fixed }}</td>
                                        <td v-else data-label="Цена за 1 изделие со скидкой">{{ (item.template.price - (item.template.sale / 100 * item.template.price)) / item.template.amount | fixed }}</td>
                                        <td v-if="item.template.sale == 0" data-label="Цена общая со скидкой">{{ item.template.price - (rm.basket.totalSale / 100 * item.template.price) | fixed }}</td>
                                        <td v-else data-label="Цена общая со скидкой">{{ item.template.price - (item.template.sale / 100 * item.template.price) | fixed }}</td>

                                        <td data-label="Удалить">
                                            <button class="btn btn-primary remove" @click="removeCornice(index)"><i
                                                class="las la-trash"></i></button>
                                        </td>
                                        <td class="text-right" data-label="Копировать">
                                            <button class="btn btn-primary remove" @click="copyCornice(index)"><i
                                                class="lar la-copy"></i></button>
                                        </td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr>
                                        <td colspan="11"><h3>Пусто</h3></td>
                                    </tr>
                                    </tbody>
                                    <tbody>
                                    <tr>
                                        <td colspan="11">
                                            <div v-if="rmOpened" class="row">
                                                <div class="col-md-4">
                                                </div>
                                                <div class="col-md-4 text-center">
                                                </div>
                                                <div class="col-md-4 text-right mt-3">
                                                    <button v-if="mode == 1" class="btn btn-outline-primary mr-2 mb-1" @click="addNewCornice()"><i
                                                        class="las la-plus"></i> Добавить изделие
                                                    </button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <table class="table readyMadeTable" v-if="rmOpened && orderMode == 6">
                                <tr><td colspan="11"><h3 style="padding: 10px 0px">Ремкомплекты</h3></td></tr>
                                <tr class="hideMobile">
                                    <th class="noAfter" style=""></th>
                                    <th style="">Тип ремкомплекта <br><i class="las la-angle-down"></i></th>
                                    <th></th>
                                    <th style="">Кол-во (шт.)<br><i class="las la-angle-down"></i></th>
                                    <th class="noAfter" style="">Цена без скидки <br><i class="las la-angle-down"></i></th>
                                    <th class="noAfter" style="width: 52px"></th>
                                    <th class="text-right noAfter" style="width: 52px"></th>
                                    <th class="noAfter" style="width: 6px;"></th>
                                </tr>
                                <tbody v-if="itemsKits[0]">
                                <tr v-for="(item, index) in itemsKits" v-bind:key="index">
                                    <td></td>
                                    <td data-label="Тип ремкомплекта">
                                        <select v-model="item.template.subtype" @change="recalc(index, 301)" class="form-control">
                                            <option value="1">Ремкомплект 1</option>
                                            <option value="2">Ремкомплект 2</option>
                                            <option value="3">Ремкомплект 3</option>
                                            <option value="4">Ремкомплект 4</option>
                                            <option value="5">Ремкомплект 5</option>
                                            <option value="6">Ремкомплект 6</option>
                                        </select>
                                    </td>
                                    <td data-label="" style="max-width: 23px;">
                                        <button class="btn btn-primary remove" @click="openKitInfo(item)"><i class="las la-info"></i></button>
                                    </td>
                                    <td data-label="Кол-во (шт.)">
                                        <input type="number" class="form-control" @change="changeAmountKits(index, item)" v-model="item.template.amount" />
                                    </td>
                                    <td data-label="Цена без скидки">
                                        {{ item.template.price | fixed }}
                                    </td>
                                    <td data-label="">
                                        <button class="btn btn-primary remove" @click="removeKit(index)"><i
                                            class="las la-trash"></i></button>
                                    </td>
                                    <td class="text-right" data-label="Копировать">
                                        <button class="btn btn-primary remove" @click="copyKit(index)"><i
                                            class="lar la-copy"></i></button>
                                    </td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                </tbody>
                                <tbody v-else="">
                                <tr>
                                    <td colspan="11"><h3>Пусто</h3></td>
                                </tr>
                                </tbody>
                                <tbody>
                                <tr>
                                    <td colspan="11">
                                        <div v-if="rmOpened" class="row">
                                            <div class="col-md-4">
                                            </div>
                                            <div class="col-md-4 text-center">
                                            </div>
                                            <div class="col-md-4 text-right mt-3">
                                                <button class="btn btn-outline-primary mr-2 mb-1" @click="addNewKit()"><i
                                                    class="las la-plus"></i> Добавить изделие
                                                </button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-if="rmOpened" class="row">
                            <div class="col-md-4">

                            </div>
                            <div class="col-md-4 text-center">
                            </div>
                            <div class="col-md-4 text-right mt-3">
                                <button class="btn btn-outline-primary mr-2 mb-1" @click="addNew()" v-if="(orderMode == 1 || orderMode == 4 || orderMode == 5 || orderMode == 7 || orderMode == 9 || orderMode == 10)"><i
                                    class="las la-plus"></i> Добавить изделие
                                </button>
                            </div>
                        </div>
                        <div v-if="rmOpened && mode == 2" class="row mt-2 ml-1 mr-1">
                            <div class="col-md-5">
                                <a href="#" @click="$modal.show('modalDownload')" class="cardHref">
                                    <div class="popupCards">
                                        <p class="bigText">Нужен контент для карточек товара?</p>
                                        <p style="text-decoration: underline">Скачайте в 1 клик</p>
                                        <p>Используйте современные решения и привлекайте больше клиентов</p>
                                        <div class="innerBlock" v-if="orderMode == 1">
                                            <video autoplay muted style="width: 100%">
                                                <source src="https://sale.katris.ru/files/rm/INTEGRA_SLIM_MINI.mp4">
                                            </video>
                                        </div>
                                        <div class="innerBlock" v-else-if="orderMode == 4 || orderMode == 5">
                                            <video autoplay style="width: 100%">
                                                <source src="https://sale.katris.ru/files/rm/GFORM.mp4">
                                            </video>
                                        </div>
                                        <div class="innerBlock" v-bind:style="{ backgroundImage: 'url(./../img/' + backImage + ')' }" v-else>

                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div class="col-md-7">
                                <table class="table" style="font-size: 12px">
                                    <tbody class="font-weight-bold">
                                    <tr>
                                        <td class="sm-hide"></td>
                                        <td class="sm-hide"></td>
                                        <td>Всего позиций</td>
<!--                                        <td>{{ items.length + itemsCornice.length }}</td>-->
                                        <td>{{ items.length + itemsKits.length }}</td>
                                    </tr>
                                    <tr v-if="orderMode != 3">
                                        <td class="sm-hide"></td>
                                        <td class="sm-hide"></td>
                                        <td>Всего изделий, шт.</td>
                                        <td>{{ rm.basket.totalCount }}</td>
                                    </tr>
<!--                                    <tr v-if="mode != 3">-->
<!--                                        <td class="sm-hide"></td>-->
<!--                                        <td class="sm-hide"></td>-->
<!--                                        <td>Общий размер упаковки</td>-->
<!--                                        <td>{{ rm.basket.totalSize }}</td>-->
<!--                                    </tr>-->
                                    <tr>
                                        <td colspan="4"></td>
                                    </tr>
                                    </tbody>
                                    <tbody>
                                    <tr>
                                        <td class="sm-hide"></td>
                                        <td class="sm-hide"></td>
                                        <td>Сумма без скидки, руб.</td>
<!--                                        <td>{{ rm.basket.totalPrice - rm.basket.totalPriceCornice | fixed }}</td>-->
                                        <td>{{ rm.basket.totalPrice | fixed }}</td>
                                    </tr>
                                    <tr>
                                        <td class="sm-hide"></td>
                                        <td class="sm-hide"></td>
                                        <td>Ваша Скидка, % (средняя)</td>
                                        <td>{{ rm.basket.totalSale2 | fixed }}</td>
                                    </tr>
                                    <tr>
                                        <td class="sm-hide"></td>
                                        <td class="sm-hide"></td>
                                        <td>Скидка составила, руб.</td>
                                        <td class="red">
<!--                                            {{ rm.basket.totalSaleSum - rm.basket.totalCorniceSale | fixed }}-->
                                            {{ rm.basket.totalSaleSum | fixed }}
                                        </td>
                                    </tr>
                                    <tr class="font-weight-bold">
                                        <td class="sm-hide"></td>
                                        <td class="sm-hide"></td>
                                        <td>Сумма со скидкой, руб.</td>
<!--                                        <td class="red">{{ rm.basket.totalTotal - rm.basket.totalCornice | fixed }}</td>-->
                                        <td class="red">{{ rm.basket.totalTotal | fixed }}</td>
                                    </tr>
                                    </tbody>
                                </table>

                                <div v-if="nextItems > 0 && nextSale > 0 && nextSale != rm.basket.totalSale"
                                     class="row mt-4 mb-4">
                                    <div class="col-md-12">
                                        <svg
                                            class="bi bi-info-lg"
                                            fill="currentColor" height="60" style="color: #0056b3; float: left; margin-right: 10px; margin-left: -10px;"
                                            viewBox="0 0 16 16" width="60" xmlns="http://www.w3.org/2000/svg">
                                            <path d="m9.708 6.075-3.024.379-.108.502.595.108c.387.093.464.232.38.619l-.975 4.577c-.255 1.183.14 1.74 1.067 1.74.72 0 1.554-.332 1.933-.789l.116-.549c-.263.232-.65.325-.905.325-.363 0-.494-.255-.402-.704l1.323-6.208Zm.091-2.755a1.32 1.32 0 1 1-2.64 0 1.32 1.32 0 0 1 2.64 0Z"/>
                                        </svg>
                                        <p v-if="isPF" class="mb-1 mt-1 font-weight-bold" style="font-size: 15px">Действуют Представительские условия.</p>
                                        <p class="mb-1 font-weight-bold" style="font-size: 15px">Для увеличения скидки до <span style="color: #0056b3; font-size: 20px">{{ nextSale }}%</span>, добавьте в заказ <span style="color: #0056b3; font-size: 20px">{{ nextItems }}</span> изделий(ия).</p>
                                        <p class="font-weight-bold" style="font-size: 15px; margin-left: 59px;">Скидка рассчитывается исходя из суммарно отгруженных изделий FOROOM и изделий RM за последние 30 дней.</p>
                                    </div>
                                </div>

                                <div class="row mb-4" v-if="!(mode == 2 && orderMode == 1)">
                                    <div class="col-md-2">
                                    </div>
                                    <div class="col-md-10">
                                        <input type="checkbox" id="useAltBarcodes" v-model="useAltBarcodes" class="custom-control-input" @change="useBarcodes()">
                                        <label for="useAltBarcodes" class="custom-control-label"></label>
                                        Печатать и наклеивать альтернативные этикетки на товар
                                    </div>
                                </div>

                                <div class="text-center mb-3">
                                    <button class="btn btn-outline-primary btn-lg" @click="prepareOrder()"><i class="las la-shopping-basket"></i> Оформить заказ</button>
<!--                                    <button class="btn btn-outline-primary btn-lg" @click="addToBasket()"><i class="las la-shopping-basket"></i> Добавить в корзину</button>-->
                                </div>

                                <div class="text-center mb-3">
                                    <!--                                    <button class="btn btn-outline-primary btn-lg" @click="makeExcel()"><i class="las la-file-excel"></i> Сохранить в Excel</button>-->
                                    <download-excel class="btn btn-outline-primary btn-lg" :data="json_data" :fields="json_fields" worksheet="Ready Made" name="RM.xls">
                                        <i class="las la-file-excel"></i> Сохранить в Excel
                                    </download-excel>
                                </div>

                                <div class="text-center mb-3">
                                    <button class="btn btn-outline-primary btn-lg" @click="uploadExcel()"><i class="las la-file-excel"></i> Загрузить из Excel</button>
                                </div>

                                <div v-if="isStorageAdmin" class="text-center mb-3">
                                    <button class="btn btn-outline-primary btn-lg" @click="fullfillStorage()"><i class="las la-shopping-basket"></i> Пополнить склад</button>
                                </div>
                            </div>
                        </div>

                        <div v-if="rmOpened && (mode == 1 || mode == 3)" class="row mt-2 ml-1 mr-1">
                            <div class="col-md-5">
                                <a href="#" @click="$modal.show('modalDownload')" class="cardHref">
                                    <div class="popupCards">
                                        <p class="bigText">Нужен контент для карточек товара?</p>
                                        <p style="text-decoration: underline">Скачайте в 1 клик</p>
                                        <p>Используйте современные решения и привлекайте больше клиентов</p>
                                        <div class="innerBlock" v-if="orderMode == 1 || orderMode == 7">
                                            <video autoplay style="width: 100%">
                                                <source src="https://sale.katris.ru/files/rm/INTEGRA_SLIM_MINI.mp4">
                                            </video>
                                        </div>
                                        <div class="innerBlock" v-else-if="orderMode == 4 || orderMode == 5">
                                            <video autoplay style="width: 100%">
                                                <source src="https://sale.katris.ru/files/rm/GFORM.mp4">
                                            </video>
                                        </div>
                                        <div class="innerBlock" v-bind:style="{ backgroundImage: 'url(./../img/' + backImage + ')' }" v-else>

                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div class="col-md-7">
                                <table class="table" style="font-size: 12px">
                                    <tbody class="font-weight-bold">
                                        <tr>
                                            <td class="sm-hide"></td>
                                            <td class="sm-hide"></td>
                                            <td>Всего позиций</td>
                                            <td>{{ items.length + itemsCornice.length + itemsKits.length + itemsCorniceVertical.length + itemsMaterialVertical.length }}</td>
                                        </tr>
                                        <tr>
                                            <td class="sm-hide"></td>
                                            <td class="sm-hide"></td>
                                            <td>Всего изделий, шт.</td>
                                            <td>{{ rm.basket.totalCount }}</td>
                                        </tr>
<!--                                        <tr v-if="orderMode != 3 && mode != 3">-->
<!--                                            <td class="sm-hide"></td>-->
<!--                                            <td class="sm-hide"></td>-->
<!--                                            <td>Общий размер упаковки</td>-->
<!--                                            <td>{{ rm.basket.totalSize }}</td>-->
<!--                                        </tr>-->
                                        <tr>
                                            <td colspan="4"></td>
                                        </tr>
                                        </tbody>
                                        <tbody>
                                        <tr>
                                            <td class="sm-hide"></td>
                                            <td class="sm-hide"></td>
                                            <td>Сумма без скидки, руб.</td>
<!--                                            <td>{{ rm.basket.totalPrice - rm.basket.totalPriceCornice | fixed }}</td>-->
                                            <td>{{ rm.basket.totalPrice | fixed }}</td>
                                        </tr>
                                        <tr>
                                            <td class="sm-hide"></td>
                                            <td class="sm-hide"></td>
                                            <td>Ваша Скидка, % (средняя)</td>
                                            <td>{{ rm.basket.totalSale2 | fixed }}</td>
                                        </tr>
                                        <tr>
                                            <td class="sm-hide"></td>
                                            <td class="sm-hide"></td>
                                            <td>Скидка составила, руб.</td>
                                            <td class="red">
<!--                                                {{ rm.basket.totalSaleSum - rm.basket.totalCorniceSale | fixed }}-->
                                                {{ rm.basket.totalSaleSum | fixed }}
                                            </td>
                                        </tr>
                                        <tr class="font-weight-bold">
                                            <td class="sm-hide"></td>
                                            <td class="sm-hide"></td>
                                            <td>Сумма со скидкой, руб.</td>
<!--                                            <td class="red">{{ rm.basket.totalTotal - rm.basket.totalCornice | fixed }}</td>-->
                                            <td class="red">{{ rm.basket.totalTotal | fixed }}</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div v-if="nextItems > 0 && nextSale > 0 && nextSale != rm.basket.totalSale"
                                     class="row mt-4 mb-2">
                                    <div class="col-md-12">
                                        <svg
                                            class="bi bi-info-lg"
                                            fill="currentColor" height="60" style="color: #0056b3; float: left; margin-right: 10px; margin-left: -10px;"
                                            viewBox="0 0 16 16" width="60" xmlns="http://www.w3.org/2000/svg">
                                            <path d="m9.708 6.075-3.024.379-.108.502.595.108c.387.093.464.232.38.619l-.975 4.577c-.255 1.183.14 1.74 1.067 1.74.72 0 1.554-.332 1.933-.789l.116-.549c-.263.232-.65.325-.905.325-.363 0-.494-.255-.402-.704l1.323-6.208Zm.091-2.755a1.32 1.32 0 1 1-2.64 0 1.32 1.32 0 0 1 2.64 0Z"/>
                                        </svg>
                                        <p v-if="isPF" class="mb-1 mt-1 font-weight-bold" style="font-size: 15px">Действуют Представительские условия.</p>
                                        <p class="mb-1 font-weight-bold" style="font-size: 15px">Для увеличения скидки до <span style="color: #0056b3; font-size: 20px">{{ nextSale }}%</span>, добавьте в заказ <span style="color: #0056b3; font-size: 20px">{{ nextItems }}</span> изделий(ия).</p>
                                        <p class="font-weight-bold" style="font-size: 15px; margin-left: 59px;">Скидка рассчитывается исходя из суммарно отгруженных изделий FOROOM и изделий RM за последние 30 дней.</p>
                                    </div>
                                </div>

                                <div class="row mb-4">
                                    <div class="col-md-2">
                                    </div>
                                    <div class="col-md-10">
                                        <input type="checkbox" id="useAltBarcodes2" v-model="useAltBarcodes" class="custom-control-input" @change="useBarcodes()">
                                        <label for="useAltBarcodes2" class="custom-control-label"></label>
                                        Печатать и наклеивать альтернативные этикетки на товар
                                    </div>
                                </div>

                                <div class="text-center mb-3">
                                    <button class="btn btn-outline-primary btn-lg" @click="prepareOrder()"><i class="las la-shopping-basket"></i> Оформить заказ</button>
<!--                                    <button class="btn btn-outline-primary btn-lg" @click="addToBasket()"><i class="las la-shopping-basket"></i> Добавить в корзину</button>-->
                                </div>

                                <div class="text-center mb-3">
<!--                                    <button class="btn btn-outline-primary btn-lg" @click="makeExcel()"><i class="las la-file-excel"></i> Сохранить в Excel</button>-->
                                    <download-excel class="btn btn-outline-primary btn-lg" :data="json_data" :fields="json_fields" worksheet="Ready Made" name="RM.xls">
                                        <i class="las la-file-excel"></i> Сохранить в Excel
                                    </download-excel>
                                </div>

                                <div v-if="isStorageAdmin" class="text-center mb-3">
                                    <button class="btn btn-outline-primary btn-lg" @click="fullfillStorage()"><i class="las la-shopping-basket"></i> Пополнить склад</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <br>
                </div>
            </div>
        </div>

        <modal :adaptive="true" :min-height="200"
               :min-width="200"
               :reset="true"
               :scrollable="true"
               height="auto"
               name="order"
               width="600px">
            <div style="padding: 20px">
                <p>Выберите Плательщика:</p>
                <select v-model="orderPayerID" class="form-control">
                    <option disabled="disabled" value="-1">Не выбрано</option>
                    <option v-for="payer in payers" v-bind:key="payer.id" :value="payer.id">{{ payer.name }}</option>
                </select>
                <br>
                <p>Выберите способ доставки:</p>
                <select v-model="orderDeliveryID" class="form-control">
                    <option v-for="(delivery, index) in deliveryTypes" v-bind:key="index" :value="delivery['id']">
                        {{ delivery['name'] }}
                    </option>
                </select>
                <br>
                <p>Укажите свой номер заказа:</p>
                <input v-model="orderNumber" class="form-control" maxlength="10" type="text">
                <hr>
                <div class="row">
                    <div class="col-md-6">
                        <input v-if="!orderSent" class="btn btn-primary btn-block" type="button" value="ОТПРАВИТЬ ЗАКАЗ" @click="sendOrder()"/>
                        <input v-else class="btn btn-secondary btn-block" disabled type="button" value="ОТПРАВИТЬ ЗАКАЗ"/>
                    </div>
                    <div class="col-md-6">
                        <input class="btn btn-primary btn-block mt-3 mt-sm-3 mt-md-0 mt-lg-0" type="button" value="ОТМЕНА" @click="closeOrder()"/>
                    </div>
                </div>
            </div>
        </modal>

        <modal :adaptive="true" :backdrop="false"
               :min-height="200"
               :min-width="200"
               :reset="true"
               :scrollable="true"
               height="auto"
               name="modalTable"
               width="600px">
            <div style="padding: 20px">
                <div class="row">
                    <div v-if="corniceModalMid == 101" class="col-md-12">
                        <h3>Комплектность однорядного круглого карниза RM</h3>
                        <table class="table">
                            <thead>
                            <tr>
                                <th>Длина карзиза, м <i class="las la-arrow-right"></i></th>
                                <th>1,4</th>
                                <th>1,6</th>
                                <th>1,8</th>
                                <th>2,0</th>
                                <th>2,4</th>
                                <th>2,8<br>составной</th>
                                <th>3,2<br>составной</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>Трубы (16), шт.</td>
                                <td>1</td>
                                <td>1</td>
                                <td>1</td>
                                <td>1</td>
                                <td>1</td>
                                <td>2 (1,4)</td>
                                <td>2 (1,6)</td>
                            </tr>
                            <tr>
                                <td>Наконечник (Заглушка) пара, шт.</td>
                                <td>1</td>
                                <td>1</td>
                                <td>1</td>
                                <td>1</td>
                                <td>1</td>
                                <td>1</td>
                                <td>1</td>
                            </tr>
                            <tr>
                                <td>Кольцо металлическое, шт.</td>
                                <td>20</td>
                                <td>20</td>
                                <td>20</td>
                                <td>20</td>
                                <td>30</td>
                                <td>30</td>
                                <td>40</td>
                            </tr>
                            <tr>
                                <td>Крючок пластиковый, шт.</td>
                                <td>20</td>
                                <td>20</td>
                                <td>20</td>
                                <td>20</td>
                                <td>30</td>
                                <td>30</td>
                                <td>40</td>
                            </tr>
                            <tr>
                                <td>Кронштейн 1й открытый, шт.</td>
                                <td>2</td>
                                <td>2</td>
                                <td>3</td>
                                <td>3</td>
                                <td>3</td>
                                <td>3</td>
                                <td>3</td>
                            </tr>
                            <tr>
                                <td>Соединитель (16), шт.</td>
                                <td>0</td>
                                <td>0</td>
                                <td>0</td>
                                <td>0</td>
                                <td>0</td>
                                <td>1</td>
                                <td>1</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-if="corniceModalMid == 102" class="col-md-12">
                        <h3>Комплектность двухрядного круглого карниза RM</h3>
                        <table class="table">
                            <thead>
                            <tr>
                                <th>Длина карзиза, м <i class="las la-arrow-right"></i></th>
                                <th>1,4</th>
                                <th>1,6</th>
                                <th>1,8</th>
                                <th>2,0</th>
                                <th>2,4</th>
                                <th>2,8<br>составной</th>
                                <th>3,2<br>составной</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>Трубы (16), шт.</td>
                                <td>2</td>
                                <td>2</td>
                                <td>2</td>
                                <td>2</td>
                                <td>2</td>
                                <td>4 (1,4)</td>
                                <td>4 (1,6)</td>
                            </tr>
                            <tr>
                                <td>Наконечник (Заглушка) пара, шт.</td>
                                <td>2</td>
                                <td>2</td>
                                <td>2</td>
                                <td>2</td>
                                <td>2</td>
                                <td>2</td>
                                <td>2</td>
                            </tr>
                            <tr>
                                <td>Кольцо металлическое, шт.</td>
                                <td>30</td>
                                <td>40</td>
                                <td>40</td>
                                <td>50</td>
                                <td>50</td>
                                <td>60</td>
                                <td>70</td>
                            </tr>
                            <tr>
                                <td>Крючок пластиковый, шт.</td>
                                <td>30</td>
                                <td>40</td>
                                <td>40</td>
                                <td>50</td>
                                <td>50</td>
                                <td>60</td>
                                <td>70</td>
                            </tr>
                            <tr>
                                <td>Кронштейн 2й открытый, шт.</td>
                                <td>2</td>
                                <td>2</td>
                                <td>3</td>
                                <td>3</td>
                                <td>3</td>
                                <td>3</td>
                                <td>3</td>
                            </tr>
                            <tr>
                                <td>Соединитель (16), шт.</td>
                                <td>0</td>
                                <td>0</td>
                                <td>0</td>
                                <td>0</td>
                                <td>0</td>
                                <td>2</td>
                                <td>2</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <input class="btn btn-primary btn-block" type="button" value="Закрыть"
                               @click="$modal.hide('modalTable')"/>
                    </div>
                </div>
            </div>
        </modal>

        <modal :adaptive="true" :backdrop="false"
               :min-height="200"
               :min-width="200"
               :reset="true"
               :scrollable="true"
               height="auto"
               name="modalClear"
               width="600px">
            <div style="padding: 20px">
                <div class="row">
                    <div class="col-md-12">
                        <h2 class="text-center">Очистите корзину, прежде чем поменять тип заказа</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <input class="btn btn-primary btn-block" type="button" value="Закрыть"
                               @click="$modal.hide('modalClear')"/>
                    </div>
                </div>
            </div>
        </modal>

        <modal :adaptive="true" :backdrop="false"
               :min-height="200"
               :min-width="200"
               :reset="true"
               :scrollable="true"
               height="auto"
               name="toOrder"
               width="600px">
            <div style="padding: 20px">
                <div class="row">
                    <div class="col-md-12">
                        <h2 class="text-center">Товары к заказу:</h2>
                        <table class="table">
                            <thead>
                            <tr>
                                <td>Наименование</td>
                                <td>Материал</td>
                                <td>Ширина</td>
                                <td>Высота</td>
                                <td>Количество</td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in toOrder" v-bind:key="item.id">
                                <td>{{ item.type }} {{ item.name }}</td>
                                <td>{{ item.material }}</td>
                                <td>{{ item.width }}</td>
                                <td>{{ item.height }}</td>
                                <td>{{ item.toOrder }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <input class="btn btn-primary btn-block" type="button" value="Добавить ГЖ" @click="sendStorageOrder(1)"/>
                        <input class="btn btn-primary btn-block" type="button" value="Добавить РШ" @click="sendStorageOrder(2)"/>
                        <input class="btn btn-primary btn-block" type="button" value="Добавить ремкомплекты" @click="sendStorageOrder(3)"/>
                        <input class="btn btn-primary btn-block" type="button" value="Закрыть" @click="$modal.hide('toOrder')"/>
                    </div>
                </div>
            </div>
        </modal>

        <modal :adaptive="true" :backdrop="false"
               :min-height="200"
               :min-width="200"
               :reset="true"
               :scrollable="true"
               height="auto"
               name="modalClear2"
               width="600px">
            <div style="padding: 20px">
                <div class="row">
                    <div class="col-md-12">
                        <h2 class="text-center">При смене типа изделия корзина будет очищена. Продолжить?</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <input class="btn btn-primary btn-block mb-2" type="button" value="Продолжить"
                               @click="clearAll()"/>
                    </div>
                    <div class="col-md-6">
                        <input class="btn btn-primary btn-block" type="button" value="Закрыть"
                               @click="$modal.hide('modalClear2')"/>
                    </div>
                </div>
            </div>
        </modal>

        <modal :adaptive="true" :backdrop="false"
               :min-height="200"
               :min-width="200"
               :reset="true"
               :scrollable="true"
               height="auto"
               name="modalDownload"
               width="600px">
            <div style="padding: 20px">
                <div class="row">
                    <div class="col-md-12">
                        <h2 class="text-center">Уважаемые партнеры!</h2>

                        <p>Изображения и видео, представленные в данном разделе, принадлежат ООО "Фирма "КАЛИТА".</p>

                        <p>Уникальные изображения и видео, предоставленные нами, помогут вам создавать привлекательный контент для карточек товаров на маркетплейс-платформах. Наш материал позволит вам выделиться среди конкурентов и привлечь больше внимания покупателей. Разнообразие изображений, а также полезные видеоинструкции по установке изделий помогут вам эффективно представить продукцию и наглядно убедить клиентов в ее качестве, простоте установки и комфорте при использовании.</p>

                        <p>Мы предоставляем вам:</p>
                        <p>- изображения продукции в интерьере или на прозрачном/белом фоне. Вы можете добавлять на изображения свой текст и графику, которые сочтете нужными и полезными для потребителя.</p>
                        <p>- видеоинструкции для самостоятельной установки изделий. Данные видео представляют собой готовое решение, любые изменения в них возможны только по согласованию с ООО "Фирма "КАЛИТА"</p>

                        <p>Использовать данный контент рекомендуется только с целью рекламы, продвижения или представления информации об изделиях стандартных размеров, которые производит ООО "Фирма "КАЛИТА".</p>

                        <p>Использование данных изображений и видео не по назначению или для рекламы, продвижения или представления продукции других производителей запрещено.</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <a class="btn btn-primary btn-block mb-2" href="https://cloud.foroom.ru/index.php/s/sQR5llT6se6kVZC" target="_blank" @click="$modal.hide('modalDownload')">Ознакомлен, продолжить</a>
                    </div>
                    <div class="col-md-6">
                        <input class="btn btn-primary btn-block" type="button" value="Закрыть"
                               @click="$modal.hide('modalDownload')"/>
                    </div>
                </div>
            </div>
        </modal>

        <modal :adaptive="true" :backdrop="false"
               :min-height="200"
               :min-width="200"
               :reset="true"
               :scrollable="true"
               height="auto"
               name="modalBlister"
               width="300px">
            <div style="padding: 20px">
                <div class="row">
                    <div class="col-md-12">
                        <h2 class="text-center">Горизонтальные жалюзи (блистер) RM</h2>

                        <p>Горизонтальные жалюзи стандартных размеров, упакованные в блистерный рукав. В блистерный рукав вкладывается картонная упаковка с описанием продукта и подробной схемой установки. Изделия комплектуются набором крепёжных элементов(саморезы, кронштейны, крючок,наконечник, соединительная втулка, держатель нижней планки, стержень управления)</p>
                        <p>Изделия рекомендуется для реализации в розничных магазинах.</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <input class="btn btn-primary btn-block" type="button" value="Закрыть"
                               @click="$modal.hide('modalBlister')"/>
                    </div>
                </div>
            </div>
        </modal>

        <modal :adaptive="true" :backdrop="false"
               :min-height="200"
               :min-width="200"
               :reset="true"
               :scrollable="true"
               height="auto"
               name="modalCarton"
               width="300px">
            <div style="padding: 20px">
                <div class="row">
                    <div class="col-md-12">
                        <h2 class="text-center">Горизонтальные жалюзи (картон) RM</h2>

                        <p>Горизонтальные жалюзи стандартных размеров, упакованные только в картон.</p>
                        <p>Изделия не упаковываются в полиэтиленовый рукав. В коробку с изделием вкладывается эксплуатационная документация с описанием продукта и подробной схемой установки. Изделия комплектуются набором крепёжных элементов (саморезы, кронштейны, крючок, наконечник, соединительная втулка, держатель нижней планки, стержень управления)</p>
                        <p>Изделия рекомендуются для реализации на маркетплейсах (OZON, WB, Яндекс Маркет и т. Д.)</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <input class="btn btn-primary btn-block" type="button" value="Закрыть" @click="$modal.hide('modalCarton')"/>
                    </div>
                </div>
            </div>
        </modal>

        <modal :adaptive="true" :backdrop="false"
               :min-height="200"
               :min-width="200"
               :reset="true"
               :scrollable="true"
               height="auto"
               name="kitInfo"
               width="1024px">

            <div style="padding: 20px">
                <div class="row">
                    <div class="col-md-12 text-center">
                        <img class="mb-2" :src="'./../img/' + kitImage" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <input class="btn btn-primary btn-block" type="button" value="Закрыть" @click="$modal.hide('kitInfo')"/>
                    </div>
                </div>
            </div>
        </modal>

        <modal :adaptive="true" :backdrop="false"
               :min-height="200"
               :min-width="200"
               :reset="true"
               :scrollable="true"
               height="auto"
               name="orderInfo"
               width="1024px">

            <div style="padding: 20px">
                <div class="row">
                    <div class="col-md-6 text-center">
                        <carousel :navigationEnabled="false" :scrollPerPage="true" :perPage="1" :paginationEnabled="true" :paginationColor="'#b7b7b7'" :navigateTo="0" :loop="true" :speed="2500">
                            <slide v-for="(image, index) in selectedImages" v-bind:key="index">
                                <div class="slide">
                                    <div class="sliderImage">
                                        <img style="width: 100%" :src="'./../img/' + image" />
                                    </div>
                                </div>
                            </slide>
                        </carousel>
                    </div>
                    <div class="col-md-6" style="font-size: 16px;">
<!--                        <div v-if="selectedPackInfo.type == 5">-->
<!--                            <b>В полный комплект входит:</b><br/>-->
<!--                            - блок управления с цепью - 1шт<br/>-->
<!--                            - цепь – цепь управления d4.2 с соединителем цепи<br/>-->
<!--                            - длина цепи 110 см<br/>-->
<!--                            - ограничители движения цепи – 2 шт<br/>-->
<!--                            - ограничители ткани – 2 шт<br/>-->
<!--                            - навесные пластиковые кронштейны – 2 шт<br/>-->
<!--                            - скотч для навесного кронштейна<br/>-->
<!--                            - магнит для фиксации нижней планки – 2 шт<br/>-->
<!--                            - саморезы – 6 шт<br/><br/>-->
<!--                        </div>-->

<!--                        <div v-if="selectedPackInfo.type == 6">-->
<!--                            <b>В комплект блока входит:</b><br/>-->
<!--                            - адаптивный блок управления с замкнутой цепью управления – 1шт<br/>-->
<!--                            - замкнутая цепь управления d-4.5мм * 6мм, длина цепи управления 115 см<br/>-->
<!--                            - ограничитель движения цепи – 1шт<br/>-->
<!--                            - ограничители ткани – 2 шт<br/>-->
<!--                            - навесные пластиковые кронштейны – 2 шт<br/>-->
<!--                            - скотч для навесного кронштейна – 2 шт<br/><br/>-->
<!--                        </div>-->

                        <p>
                            <span v-if="selectedPackInfo.type == 1"><b>Габариты блистера с изделием:</b> </span>
                            <span v-else-if="selectedPackInfo.type == 2 || selectedPackInfo.type == 5 || selectedPackInfo.type == 6"><b>Габариты коробок с изделием:</b> </span>
                            <span v-else-if="selectedPackInfo.type == 3"><b>Габариты упакованного изделия:</b> </span>
                            <span v-else-if="selectedPackInfo.type == 4"><b>Габариты коробки с ламелями:</b> </span>

                            <span> {{selectedPackInfo.gab1}}</span>
                        </p>

                        <p><b>Кол-во в упаковке:</b> <span>{{selectedPackInfo.gab3}}</span></p>
                        <p><b>Габариты целой упаковки:</b> <span>{{selectedPackInfo.gab2}}</span></p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <input class="btn btn-primary btn-block" type="button" value="Закрыть" @click="$modal.hide('orderInfo')"/>
                    </div>
                </div>
            </div>
        </modal>

        <modal :adaptive="true" :backdrop="false"
               :min-height="200"
               :min-width="200"
               :reset="true"
               :scrollable="true"
               height="auto"
               name="excelUpload"
               width="1024px">

            <div style="padding: 20px">
                <div class="row">
                    <div class="col-md-12">
                        <h3>Загрузка файла в формате .xls</h3>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-md-8 mb-3">
                        <input type="file" id="inputGroupFile" class="custom-file-input" @change="attachFile()" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
                        <label for="inputGroupFile" class="custom-file-label">{{fileName}}</label>
                    </div>
                </div>
                <div class="row justify-content-center" v-if="jsonExcelContent.length > 0">
                    <div class="col-md-12 mb-3">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col">symbol</th>
                                    <th scope="col">Количество</th>
                                    <th scope="col">Тип шк</th>
                                    <th scope="col">Номер ШК</th>
                                    <th scope="col">Строка 1</th>
                                    <th scope="col">Строка 2</th>
                                    <th scope="col">Строка 3</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in jsonExcelContent" v-bind:key="index">
                                    <th scope="row">{{ item.symbol }}</th>
                                    <td>{{ item.Количество }}</td>
                                    <td><span v-if="item['тип шк']">{{ item["тип шк"] }}</span></td>
                                    <td><span v-if="item['Номер ШК']">{{ item["Номер ШК"] }}</span></td>
                                    <td><span v-if="item['Строка 1']">{{ item["Строка 1"] }}</span></td>
                                    <td><span v-if="item['Строка 2']">{{ item["Строка 2"] }}</span></td>
                                    <td><span v-if="item['Строка 3']">{{ item["Строка 3"] }}</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <input v-if="jsonExcelContent.length > 0" class="btn btn-primary btn-block" type="button" value="Добавить к заказу" @click="addExcelItems()"/>
                        <a href="/files/rm_storage_template.xlsx" class="btn btn-primary btn-block">Скачать пример файла</a>

                        <download-excel class="btn btn-primary btn-block" :data="json_data2" :fields="json_fields2" worksheet="Ready Made Catalog" name="RMStorageCatalog.xls">
                            Скачать справочник
                        </download-excel>

                        <input class="btn btn-primary btn-block" type="button" value="Закрыть" @click="$modal.hide('excelUpload')"/>
                    </div>
                </div>
            </div>
        </modal>

        <modal :adaptive="true" :backdrop="false"
               :min-height="200"
               :min-width="200"
               :reset="true"
               :scrollable="true"
               height="auto"
               name="modalCarton2"
               width="300px">
            <div style="padding: 20px">
                <div class="row">
                    <div class="col-md-6 text-center">
                        <img style="width: 100%" :src="'./../img/packCard005.jpg'" />
                    </div>
                    <div class="col-md-6" style="font-size: 16px;">
                        <b>Рулонные шторы стандартных размеров INTEGRA SLIM RM картон, упакованные только в картон.</b><br/>
                        Изделия не упаковываются в полиэтиленовый рукав. В коробку с изделием вкладывается эксплуатационная документация с описанием продукта и подробной схемой установки.<br/><br/>
                        <b>В комплект блока управления входят:</b><br/>
                        - блок управления с цепью - 1шт<br/>
                        - цепь управления d4.2 с соединителем цепи<br/>
                        - длина цепи 110 см<br/>
                        - ограничители движения цепи – 2 шт<br/>
                        - ограничители ткани – 2 шт<br/>
                        - навесные пластиковые кронштейны – 2 шт<br/>
                        - скотч для навесного кронштейна – 2 шт<br/>
                        - магнит для фиксации нижней планки – 2 шт<br/>
                        - саморезы – 6 шт<br/><br/>

                        Изделия рекомендуются для реализации на маркетплейсах (OZON, WB, Яндекс Маркет и т. д.)
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <input class="btn btn-primary btn-block" type="button" value="Закрыть" @click="$modal.hide('modalCarton2')"/>
                    </div>
                </div>
            </div>
        </modal>

        <modal :adaptive="true" :backdrop="false"
               :min-height="200"
               :min-width="200"
               :reset="true"
               :scrollable="true"
               height="auto"
               name="modal140"
               width="300px">
            <div style="padding: 20px">
                <div class="row">
                    <div class="col-md-6 text-center">
                        <img style="width: 100%" :src="'./../img/complect.jpg'" />
                    </div>
                    <div class="col-md-6" style="font-size: 16px;">
                        <b>Рулонные шторы стандартных размеров INTEGRA SLIM RM-140 картон, упакованные только в картон.</b><br/>
                        Изделия не упаковываются в полиэтиленовый рукав. В коробку с изделием вкладывается эксплуатационная документация с описанием продукта и подробной схемой установки.<br/><br/>
                        <b>В комплект блока входит:</b><br/>
                        - адаптивный блок управления с замкнутой цепью управления – 1шт<br/>
                        - замкнутая цепь - диаметр шарика-4,5 мм, шаг-6 мм<br/>
                        - длина цепи 115 см<br/>
                        - ограничитель движения цепи – 1шт<br/>
                        - ограничители ткани – 2 шт<br/>
                        - навесные пластиковые кронштейны – 2 шт<br/>
                        - скотч для навесного кронштейна – 2 шт
                        <br/><br/>

                        Изделия рекомендуются для реализации на маркетплейсах (OZON, WB, Яндекс Маркет и т. д.)
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <input class="btn btn-primary btn-block" type="button" value="Закрыть" @click="$modal.hide('modal140')"/>
                    </div>
                </div>
            </div>
        </modal>

        <modal :adaptive="true" :backdrop="false"
               :min-height="200"
               :min-width="200"
               :reset="true"
               :scrollable="true"
               height="auto"
               name="modalRolo"
               width="300px">
            <div style="padding: 20px">
                <div class="row">
                    <div class="col-md-6 text-center">
                        <img style="width: 100%" :src="'./../img/packCard005.jpg'" />
                    </div>
                    <div class="col-md-6" style="font-size: 16px;">
                        <b>Рулонные шторы RM блистер</b><br/>
                        Рулонные шторы стандартных размеров, упакованные в блистерный рукав. В блистерный рукав вкладывается картонная упаковка с описанием продукта и подробной схемой установки. Изделия комплектуются набором крепёжных элементов.<br/><br/>

                        <b>В комплект блока управления входят:</b><br/>
                        - блок управления с цепью - 1шт<br/>
                        - цепь управления d4.2 с соединителем цепи<br/>
                        - длина цепи 110 см<br/>
                        - ограничители движения цепи – 2 шт<br/>
                        - ограничители ткани – 2 шт<br/>
                        - навесные пластиковые кронштейны – 2 шт<br/>
                        - скотч для навесного кронштейна – 2 шт<br/>
                        - магнит для фиксации нижней планки – 2 шт<br/>
                        - саморезы – 6 шт<br/><br/>

                        Изделия рекомендуется для реализации в розничных магазинах.
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <input class="btn btn-primary btn-block" type="button" value="Закрыть" @click="$modal.hide('modalRolo')"/>
                    </div>
                </div>
            </div>
        </modal>

        <modal :adaptive="true" :backdrop="false"
               :min-height="200"
               :min-width="200"
               :reset="true"
               :scrollable="true"
               height="auto"
               name="modalRolo2"
               width="300px">
            <div style="padding: 20px">
                <div class="row">
                    <div class="col-md-12">
                        <br/>
                        <b>Рулонные шторы RM блистер</b><br/>
                        Рулонные шторы стандартных размеров, упакованные в блистерный рукав. В блистерный рукав вкладывается картонная упаковка с описанием продукта и подробной схемой установки. Изделия комплектуются набором крепёжных элементов.<br/><br/>

                        <b>В комплект блока управления входят:</b><br/>
                        - блок управления с цепью - 1шт<br/>
                        - цепь управления d4.2 с соединителем цепи<br/>
                        - длина цепи 110 см<br/>
                        - ограничители движения цепи – 2 шт<br/>
                        - ограничители ткани – 2 шт<br/>
                        - навесные пластиковые кронштейны – 2 шт<br/>
                        - скотч для навесного кронштейна – 2 шт<br/>
                        - магнит для фиксации нижней планки – 2 шт<br/>
                        - саморезы – 6 шт<br/><br/>

                        Изделия рекомендуется для реализации в розничных магазинах.<br/><br/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <input class="btn btn-primary btn-block" type="button" value="Закрыть" @click="$modal.hide('modalRolo2')"/>
                    </div>
                </div>
            </div>
        </modal>
    </main>
</template>

<script>
import rm_katris from '../js/rm_katris/app';
import RMCalc from "../js/rm_katris/main/RMCalc";
// import RMOrder from "../js/rm_katris/main/RMOrder";
import ServiceClass from "../js/rm_katris/main/ServiceClass";
import Vue2Filters from "vue2-filters";

let series = require("async-series");

import { read, utils } from 'xlsx';

let storage, basketStorage;

export default {
    name: "ReadyMade",
    metaInfo: {
        title: 'Готовые изделия',
        titleTemplate: '%s - sale.katris'
    },
    mixins: [Vue2Filters.mixin],
    filters: {
        fixed(value) {
            if (value && value > 0) {
                return value.toFixed(2)
            } else {
                return '0.00'
            }
        }
    },
    props: ['orderId'],
    data() {
        return {
            loaded: false,
            types: [],
            typesAll: [],
            typesCornice: [],
            items: [],
            itemsCornice: [],
            itemsCorniceVertical: [],
            itemsMaterialVertical: [],
            itemsStorage: [],
            itemsKits: [],
            fabrics: [],
            search: '',
            rm: {
                basket: {
                    totalCount: 0,

                    totalPrice: 0,
                    totalSaleSum: 0,
                    totalTotal: 0,

                    totalPriceCornice: 0,
                    totalCorniceSale: 0,
                    totalCornice: 0
                }
            },
            deliveryTypes: {},
            payers: [],
            orderPayerID: -1,
            orderDeliveryID: -1,
            orderNumber: '',
            orderSent: false,
            notifyList: [],
            corniceModalMid: 0,
            rmOpened: true,
            corniceOpened: false,
            verticalOpened: false,
            mode: 2,
            storageGroups: {},
            storageMids: [],
            isPF: false,
            discounts: [],
            discounts_pf: [],
            nextSale: 0,
            nextItems: 0,
            toOrder: [],
            isStorageAdmin: false,
            vFormHeights: [],
            vFormLenghts: [],
            vFormLenghtsToMech: [],
            vFormLenghtsFromMech: [],
            orderMode: 1,
            nextMode: 1,
            corniceInfo: {},
            corniceInfo2: {},
            popup: true,
            backImage: '',
            getHref: '',
            gFormCarton: [35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100],
            actions: [],
            kitImage: 'kit1.jpg',
            useAltBarcodes: false,
            oldBarcodes: [],
            packageImages: {
                gform: [],
                gform_box: [],
                rolo1: [],
                rolo2: [],
                vform: [],
                cornice: [],
                zebra: [],
                rolo140_1: [],
                rolo140_2: [],
                roloCarton1: [],
                roloCarton2: [],
            },
            selectedImages: [],
            selectedPackInfo: {
                gab1: 0,
                gab2: 0,
                gab3: 0,
                type: 1
            },

            json_fields: {
                "Тип изделия": "name",
                "Материал": "material",
                "Габ-ная ширина изделия, см": "height",
                "Габ-ная высота изделия, см": "width",
                "Габаритные размеры упаковки": "packSize",
                "Кол-во (шт.)": "amount",
                "Сторона управления": "side",
                "Намотка ткани": "backWrap",
                "Тип штрихкода": "barcodeType",
                "Штрихкод": "barcode",
                "Текстовое поле ШК 1": "barcodeText1",
                "Текстовое поле ШК 2": "barcodeText2",
                "Текстовое поле ШК 3": "barcodeText3",
                "Цена за одно изделие (прайс)": "price1",
                "Цена за одно изделие со скидкой": "price2",
                "Цена общая со скидкой": "price3",
            },
            json_data: [

            ],
            json_meta: [
                [
                    {
                        key: "charset",
                        value: "utf-8",
                    },
                ],
            ],

            json_fields2: {
                "Тип изделия": "type",
                "Наименование": "name",
                "Материал": "material",
                "Ширина": "width",
                "Высота": "height",
                "Сторона управления 0 - левая. 1 - правая": "controlSide",
                "symbol": "symbol",
                "Остаток": "count",
                "Штук в упаковке": "amountInPack"
            },
            json_data2: [

            ],
            json_meta2: [
                [
                    {
                        key: "charset",
                        value: "utf-8",
                    },
                ],
            ],


            file: null,
            fileName: 'Выбор файла',
            jsonExcelContent: [],
            uploadList: [],
            allowBuyMore: false
        }
    },
    components: {

    },
    computed: {
        filteredList() {
            function compare(a, b) {
                if (a.name < b.name)
                    return -1;
                if (a.name > b.name)
                    return 1;
                return 0;
            }
            function action(a) {
                if (a.action)
                    return -1;
                if (!a.action)
                    return 1;
            }

            return this.fabrics.filter(fabrics => {
                return fabrics.name.toLowerCase().includes(this.search.toLowerCase())
            }).sort(compare).sort(action)
        },
        sortedTypes() {
            const order = [6, 13, 5];
            return this.types.slice().sort((a, b) => {
                return order.indexOf(a.mid) - order.indexOf(b.mid);
            });
        }
    },
    created() {
        let self = this;

        rm_katris.params.url = 'https://sale.katris.ru/proxy/';
        rm_katris.params.session = this.$session.get('user');
        rm_katris.user = this.$session.get('user');

        if (rm_katris.user.loginId == 3351) {
            self.allowBuyMore = true
        }

        storage = new ServiceClass('rmItems');

        basketStorage = new ServiceClass('rmItemsBasket')

        if (self.$session.get('user').loginId == '4141') {
            self.isStorageAdmin = true;
        }

        for (let i = 104; i < 259; i += 5) {
            self.vFormHeights.push(i);
        }

        for (let i = 66; i < 266; i += 8) {
            self.vFormLenghts.push(i);
            if (i == 98) {
                self.vFormLenghts.push(100)
            }
            if (i == 106) {
                self.vFormLenghts.push(110)
            }
        }

        self.vFormLenghtsToMech = [...[73, 81, 89, 97, 105, 113, 119, 129, 137, 145, 153, 161, 169, 177, 180, 185, 190, 193], ...self.vFormLenghts].sort(function (a, b) {
            return a - b;
        });
        self.vFormLenghtsFromMech = [...[119], ...self.vFormLenghts].sort(function (a, b) {
            return a - b;
        });

        self.corniceInfo = {
            "1.4": {
                "size": 1.4,
                "pipes": 1,
                "cap": 1,
                "ring": 20,
                "hook": 20,
                "bracket": 2,
                "connector": 0
            },
            "1.6": {
                "size": 1.6,
                "pipes": 1,
                "cap": 1,
                "ring": 20,
                "hook": 20,
                "bracket": 2,
                "connector": 0
            },
            "1.8": {
                "size": 1.8,
                "pipes": 1,
                "cap": 1,
                "ring": 20,
                "hook": 20,
                "bracket": 3,
                "connector": 0
            },
            "2": {
                "size": 2.0,
                "pipes": 1,
                "cap": 1,
                "ring": 20,
                "hook": 20,
                "bracket": 4,
                "connector": 0
            },
            "2.4": {
                "size": 2.4,
                "pipes": 1,
                "cap": 1,
                "ring": 30,
                "hook": 30,
                "bracket": 3,
                "connector": 0
            },
            "2.8": {
                "size": 2.8,
                "pipes": "2 (1.4)",
                "cap": 1,
                "ring": 30,
                "hook": 30,
                "bracket": 3,
                "connector": 1
            },
            "3.2": {
                "size": 3.2,
                "pipes": "2 (1.6)",
                "cap": 1,
                "ring": 40,
                "hook": 40,
                "bracket": 3,
                "connector": 1
            }
        };

        self.corniceInfo2 = {
            "1.4": {
                "size": 1.4,
                "pipes": 2,
                "cap": 2,
                "ring": 30,
                "hook": 30,
                "bracket": 2,
                "connector": 0
            },
            "1.6": {
                "size": 1.6,
                "pipes": 2,
                "cap": 2,
                "ring": 40,
                "hook": 40,
                "bracket": 2,
                "connector": 0
            },
            "1.8": {
                "size": 1.8,
                "pipes": 2,
                "cap": 2,
                "ring": 40,
                "hook": 40,
                "bracket": 3,
                "connector": 0
            },
            "2": {
                "size": 2.0,
                "pipes": 2,
                "cap": 2,
                "ring": 50,
                "hook": 50,
                "bracket": 3,
                "connector": 0
            },
            "2.4": {
                "size": 2.4,
                "pipes": 2,
                "cap": 2,
                "ring": 50,
                "hook": 50,
                "bracket": 3,
                "connector": 0
            },
            "2.8": {
                "size": 2.8,
                "pipes": "4 (1.4)",
                "cap": 2,
                "ring": 60,
                "hook": 60,
                "bracket": 3,
                "connector": 2
            },
            "3.2": {
                "size": 3.2,
                "pipes": "4 (1.6)",
                "cap": 2,
                "ring": 70,
                "hook": 70,
                "bracket": 3,
                "connector": 2
            }
        };

        self.packageImages.gform.push('gform_blister.jpg')
        self.packageImages.gform.push('gform_blister_united.jpg')
        self.packageImages.gform_box.push('gform_box.jpg')
        self.packageImages.gform_box.push('gform_box_united.jpg')
        self.packageImages.rolo1.push('packCard005.jpg')
        self.packageImages.rolo1.push('int_slim.jpg')
        self.packageImages.rolo1.push('int_slim_united.jpg')
        self.packageImages.rolo2.push('packCard005.jpg')
        self.packageImages.rolo2.push('roll.jpg')
        self.packageImages.rolo2.push('roll_united.jpg')
        self.packageImages.vform.push('vform_material.jpg')
        self.packageImages.vform.push('vform_material_closed.jpg')
        self.packageImages.cornice.push('cornice.jpg')
        self.packageImages.zebra.push('slim_duo.jpg')
        self.packageImages.zebra.push('slim_duo_united.jpg')

        // self.packageImages.roloCarton1.push('packCard005.jpg');
        self.packageImages.roloCarton1.push('packCard001.jpg');
        self.packageImages.roloCarton1.push('packCard002.jpg');
        self.packageImages.roloCarton1.push('packCard006.jpg');

        // self.packageImages.roloCarton2.push('packCard005.jpg');
        self.packageImages.roloCarton2.push('packCard003.jpg');
        self.packageImages.roloCarton2.push('packCard004.jpg');
        self.packageImages.roloCarton2.push('packCard007.jpg');

        // self.packageImages.rolo140_1.push('packCard010.jpg');
        self.packageImages.rolo140_1.push('packCard001.jpg');
        self.packageImages.rolo140_1.push('packCard002.jpg');
        self.packageImages.rolo140_1.push('packCard006.jpg');

        // self.packageImages.rolo140_2.push('packCard010.jpg');
        self.packageImages.rolo140_2.push('packCard003.jpg');
        self.packageImages.rolo140_2.push('packCard004.jpg');
        self.packageImages.rolo140_2.push('packCard007.jpg');

        series([
            function (done) {
                rm_katris.makePost('katrisService', 'getNotifications', {'token': self.$session.get('jwt')}, null, function (response) {
                    if (response.status === 'OK') {
                        self.notifyList = response.data;
                        done()
                    }
                });
            },
            function(done) {
                rm_katris.makePost('katrisService', 'getPrevBarcodes', {'token': self.$session.get('jwt')}, null, function (respond) {
                    if (respond.status === 'OK') {
                        // console.log('old barcodes', respond.data)
                        self.oldBarcodes = respond.data;
                        done()
                    }
                });
            },
            function () {
                rm_katris.init(function () {
                    self.typesAll = Object.assign(rm_katris.params.init_data.items, rm_katris.params.init_data.itemsByMat);

                    for (let type in self.typesAll) {
                        if (type != 14 && type != 140 && type != 141) {
                            self.types.push(self.typesAll[type])
                        }
                    }

                    self.typesCornice = rm_katris.params.init_data.itemsCornice;
                    self.itemsStorage = rm_katris.params.init_data.itemsStorage;

                    self.isPF = rm_katris.isPF;
                    self.discounts = rm_katris.discounts;
                    self.discounts_pf = rm_katris.discounts_pf;

                    self.processStorageItems();

                    let restore = storage.get('items');
                    restore = null; //test

                    if (restore != null && restore[0]) {
                        for (let i in restore) {
                            if (restore[i].mid < 100) {
                                self.items.push(new RMCalc(rm_katris, restore[i].mid));
                                self.items[self.items.length - 1].template = restore[i];
                                self.recalc(self.items.length - 1, self.items[self.items.length - 1].mid);
                            } else {
                                self.itemsCornice.push(new RMCalc(rm_katris, restore[i].mid));
                                self.itemsCornice[self.itemsCornice.length - 1].template = restore[i];
                                self.recalc(self.itemsCornice.length - 1, self.itemsCornice[self.itemsCornice.length - 1].mid);
                            }
                        }
                    } else if (!self.orderId) {
                        self.addNewProcess();
                    }

                    if (!self.itemsCornice[0]) {
                        // self.itemsCornice.push(new RMCalc(rm_katris, 101));
                        // self.recalc(self.itemsCornice.length - 1, self.itemsCornice[self.itemsCornice.length - 1].mid);
                    }

                    // let restoreCornice = storage.get('itemsCornice');
                    //
                    // if (restoreCornice != null && restoreCornice[0]) {
                    //     for (let i in restoreCornice) {
                    //         self.itemsCornice.push(new RMCalc(rm_katris, restoreCornice[i].mid));
                    //         self.itemsCornice[self.itemsCornice.length - 1].template = restoreCornice[i];
                    //         self.recalc(self.itemsCornice.length - 1);
                    //     }
                    // } else {
                    //     self.itemsCornice.push(new RMCalc(rm_katris, 101));
                    // }

                    self.basketUpdate();
                    self.rm = rm_katris;

                    if (self.orderId) {
                        rm_katris.makePost('katrisOrdersState', 'getOrder', {'orderId': self.orderId}, null, function(response) {
                            if (response.status === 'OK') {
                                self.loaded = true;

                                self.setMode(response.data[0].mode)

                                for (let item in response.data) {
                                    if (response.data[item].mode == 2 || (response.data[item].mode == 1 && ["20000163", "30003320"].indexOf(response.data[item].productType) != -1)) {
                                        self.addNewProcess();

                                        let mid = 6;

                                        if (response.data[item].productType == '20000163' && response.data[item].productSubtype == '7') {
                                            mid = 6;
                                        } else if (response.data[item].productType == '20000163' && response.data[item].productSubtype == '8') {
                                            mid = 5;
                                        } else if (response.data[item].productType == '20000163' && response.data[item].productSubtype == '9') {
                                            mid = 13;
                                        } else if (response.data[item].productType == '30003320' && response.data[item].productSubtype == '4') {
                                            mid = 14;
                                        } else if (response.data[item].productType == '30003320' && response.data[item].productSubtype == '5') {
                                            mid = 140;
                                        } else if (response.data[item].productType == '30003320' && response.data[item].productSubtype == '6') {
                                            mid = 141;
                                        }

                                        self.changeType(self.items.length - 1, mid);
                                        self.selectFabric(response.data[item].material, self.items.length - 1, false, false);

                                        self.items[self.items.length - 1].template.gab_height = response.data[item].height * 10;
                                        self.items[self.items.length - 1].template.gab_width = response.data[item].width * 10;
                                        self.items[self.items.length - 1].template.amount = response.data[item].amount;
                                        self.items[self.items.length - 1].template.ControlSide = response.data[item].controlSide;
                                        self.items[self.items.length - 1].template.BackWrap = response.data[item].namotka;

                                        self.changeSize(self.items.length - 1, 1);
                                        self.changeAmount(self.items.length - 1);
                                    } else if (response.data[item].mode == 1 && ["30003607"].indexOf(response.data[item].productType) != -1) {
                                        self.addNewCornice();
                                    } else if (response.data[item].mode == 1 && ["20000131"].indexOf(response.data[item].productType) != -1 && response.data[item].productSubtype == '10') {
                                        self.orderMode = 2;

                                        self.addNewCorniceVertical();

                                        self.itemsCorniceVertical[self.itemsCorniceVertical.length - 1].template.mountType = response.data[item].mountType;
                                        self.itemsCorniceVertical[self.itemsCorniceVertical.length - 1].template.drive = response.data[item].drive;
                                        self.itemsCorniceVertical[self.itemsCorniceVertical.length - 1].template.corniceSize = response.data[item].corniceSize;
                                        self.itemsCorniceVertical[self.itemsCorniceVertical.length - 1].template.amount = response.data[item].amount;

                                        self.recalc(self.itemsCorniceVertical.length - 1, 201)
                                    } else if (response.data[item].mode == 1 && ["20000131"].indexOf(response.data[item].productType) != -1 && response.data[item].productSubtype == '11') {
                                        self.orderMode = 2;

                                        self.addNewMaterialVertical();

                                        self.selectFabric(response.data[item].material, self.itemsMaterialVertical.length - 1, true, false);

                                        self.itemsMaterialVertical[self.itemsMaterialVertical.length - 1].template.lamels = response.data[item].lamels;
                                        self.itemsMaterialVertical[self.itemsMaterialVertical.length - 1].template.height = response.data[item].height;
                                        self.itemsMaterialVertical[self.itemsMaterialVertical.length - 1].template.amount = response.data[item].amount;

                                        self.recalc(self.itemsMaterialVertical.length - 1, 202)
                                    }
                                }
                            }
                        });
                    }
                });
            }
        ])
    },
    methods: {
        processStorageItems() {
            let self = this;
            let mid = 0;
            // let material = '';
            // let height = 0;

            for (let item in this.itemsStorage) {
                if (this.itemsStorage[item].controlSide == 0) {
                    this.itemsStorage[item].controlSide = 2;
                }
                this.itemsStorage[item].width = this.itemsStorage[item].width * 10;
                this.itemsStorage[item].height = this.itemsStorage[item].height * 10;

                switch (this.itemsStorage[item].name) {
                    case "картон RM":
                        mid = 141;
                        break;
                    case "стандартные RM":
                        mid = 14;
                        break;
                    case "MINI RM":
                        mid = 6;
                        break;
                    case "Zebra RM":
                        mid = 13;
                        break;
                }

                if (this.itemsStorage[item].type == 'Набор ремкомплект') {
                    mid = 301
                }

                if (!self.storageGroups[mid]) {
                    self.storageGroups[mid] = [];
                    self.storageGroups[mid].mid = mid;
                    self.storageGroups[mid].name = this.itemsStorage[item].type + ' ' + this.itemsStorage[item].name;
                    self.storageGroups[mid].materials = {};
                    self.storageGroups[mid].materialsNames = [];
                    self.storageMids.push(mid);
                }

                if (!self.storageGroups[mid].materials[this.itemsStorage[item].material_id]) {
                    self.storageGroups[mid].materials[this.itemsStorage[item].material_id] = {
                        heights: {},
                        available: false
                    };
                    self.storageGroups[mid].materialsNames.push(this.itemsStorage[item].material_id);
                }

                if (this.itemsStorage[item].count > 0) {
                    self.storageGroups[mid].materials[this.itemsStorage[item].material_id].available = true;
                }

                if (!self.storageGroups[mid].materials[this.itemsStorage[item].material_id].heights[this.itemsStorage[item].height]) {
                    self.storageGroups[mid].materials[this.itemsStorage[item].material_id].heights[this.itemsStorage[item].height] = {widths: {}};
                }

                if (!self.storageGroups[mid].materials[this.itemsStorage[item].material_id].heights[this.itemsStorage[item].height].widths[this.itemsStorage[item].width]) {
                    self.storageGroups[mid].materials[this.itemsStorage[item].material_id].heights[this.itemsStorage[item].height].widths[this.itemsStorage[item].width] = {controlSides: {}}
                }

                if (!self.storageGroups[mid].materials[this.itemsStorage[item].material_id].heights[this.itemsStorage[item].height].widths[this.itemsStorage[item].width].controlSides[this.itemsStorage[item].controlSide]) {
                    self.storageGroups[mid].materials[this.itemsStorage[item].material_id].heights[this.itemsStorage[item].height].widths[this.itemsStorage[item].width].controlSides[this.itemsStorage[item].controlSide] = {count: this.itemsStorage[item].count};
                }

                if (mid == 301) {
                    if (!self.storageGroups[mid].subtypes) {
                        self.storageGroups[mid].subtypes = [];
                    }

                    if (!self.storageGroups[mid].subtypes[parseInt(this.itemsStorage[item].name)]) {
                        self.storageGroups[mid].subtypes[parseInt(this.itemsStorage[item].name)] = {count: this.itemsStorage[item].count}
                    }
                }
            }
            // console.log('sg', self.storageGroups[141])
        },
        setMode(id) {
            if (this.items.length > 0 || this.itemsCornice.length > 0 || this.itemsCorniceVertical.length > 0 || this.itemsMaterialVertical.length > 0) {
                this.$modal.show('modalClear')
            } else {
                if (this.loaded) {
                    if (id == 3) {
                        this.orderMode = 7
                    } else if (id == 1) {
                        this.orderMode = 10
                        if (this.isStorageAdmin) {
                            this.orderMode = 1
                        }
                    } else {
                        this.orderMode = 1
                    }

                    this.mode = id;

                    if (this.mode == 3) {
                        rm_katris.mode = 1;
                        rm_katris.basket.mode = 1;
                    } else {
                        rm_katris.mode = id;
                        rm_katris.basket.mode = id;
                    }

                    this.types = [];
                    if (this.mode == 3) {
                        this.types = rm_katris.params.init_data.itemsByMat;
                    } else if (this.mode == 1) {
                        this.types.push(this.typesAll[17])
                    } else {
                        for (let type in this.typesAll) {
                            if (type != 14 && type != 140 && type != 141 && type != 15 && type != 16 && type != 17 && type != 405 && type != 406) {
                            // if (type != 14 && type != 140 && type != 141) {
                                this.types.push(this.typesAll[type])
                            }
                        }
                    }

                    if (!this.orderId) {
                        this.addNewProcess();
                    }
                }
            }
        },
        addNew() {
            this.addNewProcess();
        },
        addNewProcess() {
            let self = this;
            let addNum = 6;
            if (self.orderMode == 4 && self.mode == 2) {
                addNum = 141;
            } else if (self.orderMode == 4 && self.mode == 1) {
                addNum = 141;
            } else if (self.orderMode == 5) {
                addNum = 140;
            } else if (self.orderMode == 7) {
                addNum = 406;
            } else if (self.orderMode == 9) {
                addNum = 15;
            } else if (self.orderMode == 10) {
                addNum = 17;
            }
            self.items.push(new RMCalc(rm_katris, addNum));

            self.loaded = true;
            // self.items[self.items.length - 1].systemsState = false;
            self.items[self.items.length - 1].template.ControlSide = 2;

            this.items[self.items.length - 1].template.barcodeRed = false;
            if (this.items[self.items.length - 1].template.barcodeType == 0 && this.useAltBarcodes) {
                this.items[self.items.length - 1].template.barcodeType = 1;
            }

            if (this.useAltBarcodes && this.items[self.items.length - 1].template.barcode == '') {
                this.searchBarcodeForItem(this.items[self.items.length - 1])
            }

            if ((self.mode == 1 || self.mode == 3) && !self.isStorageAdmin) {
                // if (self.orderMode == 4 && self.mode == 1) {
                if (self.orderMode == 4) {
                    self.items[self.items.length - 1].template.gab_width = self.gFormCarton[0] * 10;
                }

                self.items[self.items.length - 1].template.BackWrap = 1;
                if (self.items[self.items.length - 1].materials[self.items[self.items.length - 1].template.material].name.indexOf('Натали') != -1) {
                    self.items[self.items.length - 1].template.BackWrap = 0;
                }
            } else if (self.mode == 2 || self.isStorageAdmin) {
                console.log(self.storageGroups)
                console.log(addNum)
                console.log(self.storageGroups[addNum])

                if (!self.storageGroups[addNum].materials[self.items[self.items.length - 1].template.material]) {
                    if (self.isStorageAdmin) {
                        // Надо найти материал, который есть на остатке, чтобы можно было выписать. Складские остатки учитывать нельзя
                        for (let mat in self.storageGroups[addNum].materials) {
                            if (self.items[self.items.length - 1].materials[mat].available != "red") {
                                self.items[self.items.length - 1].template.material = mat
                                break
                            }
                        }
                    } else {
                        self.items[self.items.length - 1].template.material = Object.keys(self.storageGroups[addNum].materials)[0];
                    }
                }

                if (!self.storageGroups[addNum].materials[self.items[self.items.length - 1].template.material].heights[self.items[self.items.length - 1].template.gab_height]) {
                    self.items[self.items.length - 1].template.gab_height = Object.keys(self.storageGroups[addNum].materials[self.items[self.items.length - 1].template.material].heights)[0];
                }

                if (!self.storageGroups[addNum].materials[self.items[self.items.length - 1].template.material].heights[self.items[self.items.length - 1].template.gab_height].widths[self.items[self.items.length - 1].template.gab_width]) {
                    self.items[self.items.length - 1].template.gab_width = Object.keys(self.storageGroups[addNum].materials[self.items[self.items.length - 1].template.material].heights[self.items[self.items.length - 1].template.gab_height].widths)[0];
                }

                if (!self.isStorageAdmin) {
                    //Если нет в наличии
                    if (self.storageGroups[addNum].materials[self.items[self.items.length - 1].template.material].heights[self.items[self.items.length - 1].template.gab_height].widths[self.items[self.items.length - 1].template.gab_width].controlSides[self.items[self.items.length - 1].template.ControlSide].count == 0 || self.storageGroups[addNum].materials[self.items[self.items.length - 1].template.material].heights[self.items[self.items.length - 1].template.gab_height].widths[self.items[self.items.length - 1].template.gab_width].controlSides[self.items[self.items.length - 1].template.ControlSide].count < self.items[self.items.length - 1].prices[self.items[self.items.length - 1].template.material][self.items[self.items.length - 1].template.gab_height][self.items[self.items.length - 1].template.gab_width].amount) {
                        let founded = false;
                        for (let material in self.storageGroups[addNum].materials) {
                            for (let height in self.storageGroups[addNum].materials[material].heights) {
                                for (let width in self.storageGroups[addNum].materials[material].heights[height].widths) {
                                    for (let controlSide in self.storageGroups[addNum].materials[material].heights[height].widths[width].controlSides) {
                                        if (self.storageGroups[addNum].materials[material].heights[height].widths[width].controlSides[controlSide].count > 0 && self.storageGroups[addNum].materials[material].heights[height].widths[width].controlSides[controlSide].count >= self.items[self.items.length - 1].prices[self.items[self.items.length - 1].template.material][self.items[self.items.length - 1].template.gab_height][self.items[self.items.length - 1].template.gab_width].amount && !founded) {
                                            founded = true;
                                            self.items[self.items.length - 1].template.material = material;
                                            self.items[self.items.length - 1].template.gab_height = height;
                                            self.items[self.items.length - 1].template.gab_width = width;
                                            self.items[self.items.length - 1].template.ControlSide = controlSide;
                                            self.items[self.items.length - 1].template.amount = self.items[self.items.length - 1].prices[self.items[self.items.length - 1].template.material][self.items[self.items.length - 1].template.gab_height][self.items[self.items.length - 1].template.gab_width].amount;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                // if (self.items[self.items.length - 1].materials[self.items[self.items.length - 1].template.material].name.indexOf('Натали') != -1) {
                //     self.items[self.items.length - 1].template.BackWrap = 2;
                // }
            }

            this.basketUpdate()
        },
        addNewCornice() {
            this.itemsCornice.push(new RMCalc(rm_katris, 101));

            this.itemsCornice[this.itemsCornice.length - 1].template.barcodeRed = false;
            if (this.itemsCornice[this.itemsCornice.length - 1].template.barcodeType == 0 && this.useAltBarcodes) {
                this.itemsCornice[this.itemsCornice.length - 1].template.barcodeType = 1;
                this.itemsCornice[this.itemsCornice.length - 1].template.barcode = ''
            }

            if (this.useAltBarcodes && this.itemsCornice[this.itemsCornice.length - 1].template.barcode == '') {
                this.searchBarcodeForCornice(this.itemsCornice[this.itemsCornice.length - 1])
            }

            this.basketUpdate();
        },
        copy(key) {
            this.items.push(new RMCalc(rm_katris, this.items[key].mid));
            this.items[this.items.length - 1].template = JSON.parse(JSON.stringify(this.items[key].template));
            this.recalc(this.items.length - 1, this.items[key].mid);

            this.basketUpdate();
        },
        copyCornice(key) {
            this.itemsCornice.push(new RMCalc(rm_katris, this.itemsCornice[key].mid));
            this.itemsCornice[this.itemsCornice.length - 1].template = JSON.parse(JSON.stringify(this.itemsCornice[key].template));
            this.recalc(this.itemsCornice.length - 1, this.itemsCornice[key].mid);

            this.basketUpdate();
        },
        copyVFormCornice(key) {
            this.itemsCorniceVertical.push(new RMCalc(rm_katris, this.itemsCorniceVertical[key].mid));
            this.itemsCorniceVertical[this.itemsCorniceVertical.length - 1].template = JSON.parse(JSON.stringify(this.itemsCorniceVertical[key].template));
            this.recalc(this.itemsCorniceVertical.length - 1, this.itemsCorniceVertical[key].mid);

            this.basketUpdate();
        },
        copyMaterial(key) {
            this.itemsMaterialVertical.push(new RMCalc(rm_katris, this.itemsMaterialVertical[key].mid));
            this.itemsMaterialVertical[this.itemsMaterialVertical.length - 1].template = JSON.parse(JSON.stringify(this.itemsMaterialVertical[key].template));
            this.recalc(this.itemsMaterialVertical.length - 1, this.itemsMaterialVertical[key].mid);

            this.basketUpdate();
        },
        copyKit(key) {
            this.itemsKits.push(new RMCalc(rm_katris, this.itemsKits[key].mid));
            this.itemsKits[this.itemsKits.length - 1].template = JSON.parse(JSON.stringify(this.itemsKits[key].template));
            this.recalc(this.itemsKits.length - 1, this.itemsKits[key].mid);

            this.basketUpdate();
        },
        remove(key) {
            this.items.splice(key, 1);
            this.basketUpdate();
        },
        removeCornice(key) {
            this.itemsCornice.splice(key, 1);
            this.basketUpdate();
        },
        removeVFormCornice(key) {
            this.itemsCorniceVertical.splice(key, 1);
            this.basketUpdate();
        },
        removeMaterial(key) {
            this.itemsMaterialVertical.splice(key, 1);
            this.basketUpdate();
        },
        removeKit(key) {
            this.itemsKits.splice(key, 1);
            this.basketUpdate();
        },
        changeType(key, newKey) {
            let self = this;
            let replacement = new RMCalc(rm_katris, newKey);

            // console.log(key, newKey)

            if (newKey < 100 || newKey == 140 || newKey == 141 || newKey > 400) {
                replacement.template.ControlSide = 2;

                if (self.mode == 1 || self.mode == 3) {
                    // replacement.template.BackWrap = 0;

                    if (newKey == 141) {
                        replacement.template.gab_width = self.gFormCarton[0] * 10;
                    }

                    replacement.template.BackWrap = 1;
                    if (replacement.materials[replacement.template.material].name.indexOf('Натали') != -1 && !self.isStorageAdmin) {
                        replacement.template.BackWrap = 0;
                    }
                } else {
                    // replacement.template.amount = 0;
                    // replacement.template.ControlSide = 1;
                    if (!self.storageGroups[newKey].materials[replacement.template.material]) {
                        replacement.template.material = Object.keys(self.storageGroups[newKey].materials)[0];
                    }

                    if (!self.storageGroups[newKey].materials[replacement.template.material].heights[replacement.template.gab_height]) {
                        replacement.template.gab_height = Object.keys(self.storageGroups[newKey].materials[replacement.template.material].heights)[0];
                    }

                    if (!self.storageGroups[newKey].materials[replacement.template.material].heights[replacement.template.gab_height].widths[replacement.template.gab_width]) {
                        replacement.template.gab_width = Object.keys(self.storageGroups[newKey].materials[replacement.template.material].heights[replacement.template.gab_height].widths)[0];
                    }

                    //Если нет в наличии
                    if (self.storageGroups[newKey].materials[replacement.template.material].heights[replacement.template.gab_height].widths[replacement.template.gab_width].controlSides[replacement.template.ControlSide].count == 0 || self.storageGroups[newKey].materials[replacement.template.material].heights[replacement.template.gab_height].widths[replacement.template.gab_width].controlSides[replacement.template.ControlSide].count < replacement.prices[replacement.template.material][replacement.template.gab_height][replacement.template.gab_width].amount) {
                        let founded = false;
                        for (let material in self.storageGroups[newKey].materials) {
                            for (let height in self.storageGroups[newKey].materials[material].heights) {
                                for (let width in self.storageGroups[newKey].materials[material].heights[height].widths) {
                                    for (let controlSide in self.storageGroups[newKey].materials[material].heights[height].widths[width].controlSides) {
                                        if (self.storageGroups[newKey].materials[material].heights[height].widths[width].controlSides[controlSide].count > 0 && self.storageGroups[newKey].materials[material].heights[height].widths[width].controlSides[controlSide].count >= replacement.prices[replacement.template.material][replacement.template.gab_height][replacement.template.gab_width].amount && !founded) {
                                            founded = true;
                                            replacement.template.material = material;
                                            replacement.template.gab_height = height;
                                            replacement.template.gab_width = width;
                                            replacement.template.ControlSide = controlSide;
                                            replacement.template.amount = replacement.prices[replacement.template.material][replacement.template.gab_height][replacement.template.gab_width].amount;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    // if (replacement.materials[replacement.template.material].name.indexOf('Натали') != -1) replacement.template.BackWrap = 2;
                }

                this.$set(this.items, key, replacement);


                if (this.items[key].template.barcodeType == 0 && this.useAltBarcodes) {
                    this.items[key].template.barcodeType = 1;
                }

                if (this.useAltBarcodes && this.items[key].template.barcode == '') {
                    this.searchBarcodeForItem(this.items[key])
                }
            } else {
                if (newKey == 101) {
                    this.backImage = 'karn2.png';
                } else if (newKey == 102) {
                    this.backImage = 'karn.png';
                }

                this.$set(this.itemsCornice, key, replacement);

                if (this.itemsCornice[key].template.barcodeType == 0 && this.useAltBarcodes) {
                    this.itemsCornice[key].template.barcodeType = 1;
                    this.itemsCornice[key].template.barcode = "";
                }

                // console.log(this.itemsCornice[key].template.barcode)
                if (this.useAltBarcodes && this.itemsCornice[key].template.barcode == '') {
                    this.searchBarcodeForCornice(this.itemsCornice[key])
                }
            }

            this.basketUpdate();
        },
        openFabric(key, mid = 1) {
            let self = this;

            this.fabrics = [];

            let items = []
            if (mid == 202) {
                items = this.itemsMaterialVertical
            } else {
                items = this.items
            }

            for (let i in items[key].materials) {
                if (items[key].materials[i] != undefined) {
                    for (let notify in self.notifyList) {
                        if (self.notifyList[notify].goodID == items[key].materials[i].id_good && self.notifyList[notify].active == 1 && self.notifyList[notify].type == 3) {
                            items[key].materials[i].notify = true;
                            items[key].materials[i].notificationID = self.notifyList[notify].id;
                        } else if (self.notifyList[notify].goodID == items[key].materials[i].id_good) {
                            items[key].materials[i].notify = false;
                        }
                    }

                    this.fabrics.push(items[key].materials[i]);
                }
            }

            items[key].fabricState = !items[key].fabricState;
        },
        selectFabric(id, key, vform = false, turnState = true) {
            let self = this;

            let items = []
            if (vform) {
                items = this.itemsMaterialVertical
                if (this.useAltBarcodes && items[key].template.barcode == "") {
                    this.searchBarcodeForVMaterial(items[key])
                }
            } else {
                items = this.items
                if (this.useAltBarcodes && items[key].template.barcode == "") {
                    this.searchBarcodeForItem(items[key])
                }
            }

            if (turnState) items[key].fabricState = !items[key].fabricState;
            let mid = items[key].template.mid;

            if (this.mode == 2 || self.isStorageAdmin) {
                items[key].template.gab_width = Object.keys(self.storageGroups[mid].materials[id].heights[items[key].template.gab_height].widths)[0];

                if (!self.isStorageAdmin) {
                    if (!self.storageGroups[mid].materials[id].heights[items[key].template.gab_height].widths[items[key].template.gab_width] || self.storageGroups[mid].materials[id].heights[items[key].template.gab_height].widths[items[key].template.gab_width].controlSides[items[key].template.ControlSide].count == 0 || self.storageGroups[mid].materials[id].heights[items[key].template.gab_height].widths[items[key].template.gab_width].controlSides[items[key].template.ControlSide].count < items[key].prices[items[key].template.material][items[key].template.gab_height][items[key].template.gab_width].amount) {
                        let founded = false;
                        for (let height in self.storageGroups[mid].materials[id].heights) {
                            for (let width in self.storageGroups[mid].materials[id].heights[height].widths) {
                                for (let controlSide in self.storageGroups[mid].materials[id].heights[height].widths[width].controlSides) {
                                    if (self.storageGroups[mid].materials[id].heights[height].widths[width].controlSides[controlSide].count > 0 && self.storageGroups[mid].materials[id].heights[height].widths[width].controlSides[controlSide].count >= items[key].prices[id][items[key].template.gab_height][items[key].template.gab_width].amount && !founded) {
                                        founded = true;
                                        items[key].template.gab_height = height;
                                        items[key].template.gab_width = width;
                                        items[key].template.ControlSide = controlSide;
                                        items[key].template.amount = items[key].prices[items[key].template.material][items[key].template.gab_height][items[key].template.gab_width].amount;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            items[key].template.matAmount = items[key].getMatAmount(items[key].template);

            let totalAmount = 0;

            for (let item in items) {
                if (items[item].template.material === id && item != key) {
                    totalAmount += items[item].template.matAmount
                }
            }

            let changed = true
            if (items[key].template.material) {
                if (!items[key].matAmounts[id]) items[key].matAmounts[id] = 0;
                if ((items[key].materials[id] && items[key].materials[id].gdsInStock) || this.mode == 2) {
                    let matAmount = totalAmount + items[key].template.matAmount;
                    if (matAmount < items[key].materials[id].gdsInStock || this.mode == 2) {
                        items[key].chooseFabric(id);

                        if (this.mode == 2) {
                            // if (items[key].materials[id].name.indexOf('Натали') != -1)
                            //     items[key].template.BackWrap = 2;
                            // else
                                this.items[key].template.BackWrap = 1;
                        } else {
                            if (items[key].materials[id].name.indexOf('Натали') != -1 && !self.isStorageAdmin)
                                items[key].template.BackWrap = 0;
                            else
                                items[key].template.BackWrap = 1;
                        }

                        this.basketUpdate();
                    } else {
                        alert('Недостаточно материала! Выберите другой материал или уменьшите кол-во изделий! 1');
                        changed = false
                    }
                } else {
                    alert('Недостаточно материала! Выберите другой материал!');
                    changed = false
                }
            }

            if (vform) {
                items = this.itemsMaterialVertical
                if (changed) {
                    this.recalc(key, items[key].template.mid)
                }
            } else {
                if (this.useAltBarcodes && items[key].template.barcode == "") {
                    this.searchBarcodeForItem(items[key])
                }
            }
        },
        openSystems(key, mid = 1) {
            // let self = this;

            let items = []
            if (mid == 202) {
                items = this.itemsMaterialVertical
            } else {
                items = this.items
            }

            items[key].systemsState = !items[key].systemsState;
        },
        selectSystem(mid, key, vform = false, turnState = true) {
            let items = []
            if (vform) {
                items = this.itemsMaterialVertical
            } else {
                items = this.items
            }

            if (turnState) items[key].fabricState = !items[key].fabricState;

            this.changeType(key, mid)
        },
        overlayClick() {
            for (let key in this.itemsMaterialVertical) {
                this.itemsMaterialVertical[key].fabricState = false;
                this.itemsMaterialVertical[key].systemsState = false;
            }

            for (let key in this.items) {
                this.items[key].fabricState = false;
                this.items[key].systemsState = false;
            }
        },
        changeColor(key) {
            this.itemsCornice[key].reCalc();

            if (this.useAltBarcodes && this.itemsCornice[key].template.barcode == '') {
                this.searchBarcodeForCornice(this.itemsCornice[key])
            }

            this.basketUpdate();
        },
        prepareOrder() {
            let controlSideAlert = false;
            for (let obj in this.items) {
                if (this.items[obj].template.BackWrap == 0 && this.items[obj].template.mid != 14 && this.items[obj].template.mid != 140 && this.items[obj].template.mid != 141) {
                    controlSideAlert = true;
                    this.items[obj].alert = true;
                }
            }

            if (!controlSideAlert) {
                this.payersList = rm_katris.payersList;

                this.payers = [];
                for (let key in rm_katris.payersList) {
                    this.payers.push({id: key, name: rm_katris.payersList[key].showName});
                }

                this.deliveryTypes = rm_katris.deliveriesList;

                this.$modal.show('order')
            } else {
                alert('Выберите намотку ткани!')
            }
        },
        changeSize(key, type) {
            // let self = this;
            // console.log(this.items[key])
            //
            // console.log(this.items[key].template.gab_height, this.items[key].template.gab_width, this.items[key].template.ControlSide)
            // console.log(self.storageGroups[this.items[key].mid].materials[this.items[key].template.material].heights[this.items[key].template.gab_height].widths[this.items[key].template.gab_width].controlSides[this.items[key].template.ControlSide])

            //type - ширина или высота
            if (type != 2) {
                this.items[key].reCalc();

                if (type == 1 && this.mode == 2) {


                    if (!self.storageGroups[this.items[key].template.mid].materials[this.items[key].template.material].heights[this.items[key].template.gab_height].widths[this.items[key].template.gab_width] || self.storageGroups[this.items[key].template.mid].materials[this.items[key].template.material].heights[this.items[key].template.gab_height].widths[this.items[key].template.gab_width].controlSides[this.items[key].template.ControlSide].count == 0 || self.storageGroups[this.items[key].template.mid].materials[this.items[key].template.material].heights[this.items[key].template.gab_height].widths[this.items[key].template.gab_width].controlSides[this.items[key].template.ControlSide].count < this.items[key].prices[this.items[key].template.material][this.items[key].template.gab_height][this.items[key].template.gab_width].amount) {
                        let founded = false;
                        for (let width in self.storageGroups[this.items[key].template.mid].materials[this.items[key].template.material].heights[this.items[key].template.gab_height].widths) {
                            for (let controlSide in self.storageGroups[this.items[key].template.mid].materials[this.items[key].template.material].heights[this.items[key].template.gab_height].widths[width].controlSides) {
                                if (self.storageGroups[this.items[key].template.mid].materials[this.items[key].template.material].heights[this.items[key].template.gab_height].widths[width].controlSides[controlSide].count > 0 && self.storageGroups[this.items[key].template.mid].materials[this.items[key].template.material].heights[this.items[key].template.gab_height].widths[width].controlSides[controlSide].count >= this.items[key].prices[this.items[key].template.material][this.items[key].template.gab_height][this.items[key].template.gab_width].amount && !founded) {
                                    founded = true;
                                    this.items[key].template.gab_width = width;
                                    this.items[key].template.ControlSide = controlSide;
                                    this.items[key].template.amount = this.items[key].prices[this.items[key].template.material][this.items[key].template.gab_height][this.items[key].template.gab_width].amount;
                                }
                            }
                        }

                    }
                }

                if (type == 0 && this.mode == 2) {
                    // this.items[key].template.ControlSide = 2;
                }

                this.items[key].template.matAmount = this.items[key].getMatAmount(this.items[key].template);

                let totalAmount = 0;

                for (let item in this.items) {
                    if (this.items[item].template.material === this.items[key].template.material && item != key) {
                        this.items[item].template.matAmount = this.items[item].getMatAmount(this.items[item].template);
                        totalAmount += this.items[item].template.matAmount;
                    }
                }

                if (this.items[key].template.amount % this.items[key].prices[this.items[key].template.material][this.items[key].template.gab_height][this.items[key].template.gab_width].amount != 0) {
                    this.items[key].template.amount = this.items[key].prices[this.items[key].template.material][this.items[key].template.gab_height][this.items[key].template.gab_width].amount;
                }

                if (this.items[key].template.material) {
                    if (!this.items[key].matAmounts[this.items[key].template.material]) this.items[key].matAmounts[this.items[key].template.material] = 0;
                    if ((this.items[key].materials[this.items[key].template.material] && this.items[key].materials[this.items[key].template.material].gdsInStock) || this.mode == 2) {
                        let matAmount = totalAmount + this.items[key].template.matAmount;
                        if (matAmount < this.items[key].materials[this.items[key].template.material].gdsInStock || this.mode == 2) {
                            this.recalc(key, this.items[key].mid);
                        } else {
                            alert('Недостаточно материала! Выберите другой материал или уменьшите кол-во изделий! 2');
                            if (type == 0) {
                                this.items[key].template.gab_width = Object.keys(this.items[key].prices[this.items[key].template.material][this.items[key].template.gab_height])[0];
                            } else {
                                this.items[key].template.gab_height = Object.keys(this.items[key].prices[this.items[key].template.material])[0];
                            }
                            this.recalc(key, this.items[key].mid);
                        }
                    } else {
                        alert('Недостаточно материала! Выберите другой материал!');
                        if (type == 0) {
                            this.items[key].template.gab_width = Object.keys(this.items[key].prices[this.items[key].template.material][this.items[key].template.gab_height])[0];
                        } else {
                            this.items[key].template.gab_height = Object.keys(this.items[key].prices[this.items[key].template.material])[0];
                        }
                        this.recalc(key, this.items[key].mid);
                    }
                }

                if (this.useAltBarcodes && this.items[key].template.barcode == '') {
                    this.searchBarcodeForItem(this.items[key])
                }
            } else {
                this.itemsCornice[key].template.corniceSubtype = this.itemsCornice[key].prices[this.itemsCornice[key].template['color']][this.itemsCornice[key].template['size']].subtype;
                if (this.itemsCornice[key].template.amount % this.itemsCornice[key].prices[this.itemsCornice[key].template['color']][this.itemsCornice[key].template['size']].amount != 0) {
                    this.itemsCornice[key].template.amount = this.itemsCornice[key].prices[this.itemsCornice[key].template['color']][this.itemsCornice[key].template['size']].amount;
                }
                this.itemsCornice[key].reCalc();

                if (this.useAltBarcodes && this.itemsCornice[key].template.barcode == '') {
                    this.searchBarcodeForCornice(this.itemsCornice[key])
                }
                this.recalc(key, this.itemsCornice[key].mid);
            }
        },
        changeAmount(key) {
            this.items[key].reCalc();

            this.items[key].template.matAmount = this.items[key].getMatAmount(this.items[key].template);

            let totalAmount = 0;

            for (let item in this.items) {
                if (this.items[item].template.material === this.items[key].template.material && item != key) {
                    this.items[item].template.matAmount = this.items[item].getMatAmount(this.items[item].template);
                    totalAmount += this.items[item].template.matAmount
                }
            }

            // for (let item in this.itemsCornice) {
            //
            // }

            if (this.items[key].template.material) {
                if (!this.items[key].matAmounts[this.items[key].template.material]) this.items[key].matAmounts[this.items[key].template.material] = 0;
                if ((this.items[key].materials[this.items[key].template.material] && this.items[key].materials[this.items[key].template.material].gdsInStock) || this.mode == 2) {
                    let matAmount = totalAmount + this.items[key].template.matAmount;
                    if (matAmount < this.items[key].materials[this.items[key].template.material].gdsInStock || this.mode == 2) {
                        this.recalc(key, this.items[key].mid);
                    } else {
                        console.log(matAmount, this.items[key].materials[this.items[key].template.material].gdsInStock)
                        alert('Недостаточно материала! Выберите другой материал или уменьшите кол-во изделий! 3');

                        this.items[key].template.amount = this.items[key].prices[this.items[key].template.material][this.items[key].template.gab_height][this.items[key].template.gab_width].amount;
                        this.recalc(key, this.items[key].mid);
                    }

                } else {
                    if (!rm_katris.noAlerts) {
                        alert('Недостаточно материала! Выберите другой материал!');
                    }
                    this.items[key].template.amount = this.items[key].prices[this.items[key].template.material][this.items[key].template.gab_height][this.items[key].template.gab_width].amount;
                    this.recalc(key, this.items[key].mid);
                }
            }
        },
        changeAmountCornice(key) {
            this.recalc(key, this.itemsCornice[key].mid);
        },
        changeAmountKits(key, item) {
            if (item.template.amount > 99) { item.template.amount = 99 }
            if (item.template.amount < 1) { item.template.amount = 1 }

            this.recalc(key, this.itemsKits[key].mid);
        },
        changeControlSide(item, key) {
            let mid = item.template.mid;
            if (this.storageGroups[mid].materials[item.template.material].heights[item.template.gab_height].widths[item.template.gab_width].controlSides[item.template.ControlSide].count <= 0) {
                alert('Недостаточно изделий!');
                for (let item2 in this.storageGroups[mid].materials[item.template.material].heights[item.template.gab_height].widths[item.template.gab_width].controlSides) {
                    if (this.storageGroups[mid].materials[item.template.material].heights[item.template.gab_height].widths[item.template.gab_width].controlSides[item2].count > 0) {
                        item.template.ControlSide = item2;
                    }
                }
            }
            this.recalc(key, mid)
        },
        recalc(key, mid) {
            if (mid < 100 || mid == 140 || mid == 141 || mid > 400) {
                // if (this.useAltBarcodes && this.items[key].template.barcode == '') {
                //     this.searchBarcodeForItem(this.items[key])
                // }

                if (this.items[key].template.BackWrap != 0) {
                    this.items[key].alert = false;
                }

                this.items[key].reCalc();

                if (this.mode == 1 || this.mode == 3) {
                    if (this.items[key].template.amount % this.items[key].prices[this.items[key].template.material][this.items[key].template.gab_height][this.items[key].template.gab_width].amount > 0) {
                        this.items[key].template.amount = this.items[key].prices[this.items[key].template.material][this.items[key].template.gab_height][this.items[key].template.gab_width].amount;
                    }

                    this.items[key].template.matAmount = this.items[key].getMatAmount(this.items[key].template);

                    let totalAmount = 0;

                    for (let item in this.items) {
                        if (this.items[item].template.material === this.items[key].template.material && item != key) {
                            this.items[item].template.matAmount = this.items[item].getMatAmount(this.items[item].template);
                            totalAmount += this.items[item].template.matAmount
                        }
                    }

                    if (this.items[key].template.material) {
                        if (!this.items[key].matAmounts[this.items[key].template.material]) this.items[key].matAmounts[this.items[key].template.material] = 0;
                        if ((this.items[key].materials[this.items[key].template.material] && this.items[key].materials[this.items[key].template.material].gdsInStock) || this.mode == 2) {
                            let matAmount = totalAmount + this.items[key].template.matAmount;
                            if (matAmount < this.items[key].materials[this.items[key].template.material].gdsInStock || this.mode == 2) {
                                this.basketUpdate();
                            } else {
                                if (!rm_katris.noAlerts) {
                                    alert('Недостаточно материала! Выберите другой материал или уменьшите кол-во изделий! 4');
                                    this.items.splice(key, 1);
                                } else {
                                    this.items[key].template.amount = 0;
                                    this.items[key].template.price = 0;
                                }
                            }

                        } else {
                            this.items[key].template.gab_width = Object.keys(this.items[key].prices[this.items[key].template.material][this.items[key].template.gab_height])[0];

                            if (!rm_katris.noAlerts) {
                                alert('Недостаточно материала! Выберите другой материал!');
                                this.items.splice(key, 1);
                            } else {
                                this.items[key].template.amount = 0;
                                this.items[key].template.price = 0;
                            }
                        }
                    }
                } else {
                    let totalAmount = 0;
                    let maxAmount = this.storageGroups[mid].materials[this.items[key].template.material].heights[this.items[key].template.gab_height].widths[this.items[key].template.gab_width].controlSides[this.items[key].template.ControlSide].count;
                    for (let item in this.items) {
                        if (this.items[item].template.material === this.items[key].template.material && this.items[item].template.gab_height === this.items[key].template.gab_height && this.items[item].template.gab_width === this.items[key].template.gab_width && this.items[item].template.ControlSide === this.items[key].template.ControlSide) {
                            totalAmount += this.items[item].template.amount;
                        }
                    }

                    if (totalAmount > maxAmount && !this.allowBuyMore) {
                        alert('Недостаточно товара на складе!');
                        this.items[key].template.amount = 0;
                        this.items[key].template.price = 0;
                    }

                    this.basketUpdate();
                }
            } else if (mid < 200) {
                if (this.useAltBarcodes && this.itemsCornice[key].template.barcode == '') {
                    this.searchBarcodeForCornice(this.itemsCornice[key])
                }
                this.itemsCornice[key].reCalc();
                this.basketUpdate();
            } else if (mid == 201) {
                if (this.useAltBarcodes && this.itemsCorniceVertical[key].template.barcode == '') {
                    this.searchBarcodeForVCornice(this.itemsCorniceVertical[key])
                }
                this.itemsCorniceVertical[key].reCalc();
                this.basketUpdate();
            } else if (mid == 301) {
                if (this.mode == 2) {
                    let sum = 0;

                    for (let i in this.itemsKits) {
                        if (i != key && this.itemsKits[i].template.subtype == this.itemsKits[key].template.subtype) {
                            sum += this.itemsKits[i].template.amount;
                        }
                    }

                    if (sum + this.itemsKits[key].template.amount > this.storageGroups[this.itemsKits[key].mid].subtypes[this.itemsKits[key].template.subtype].count) {
                        alert('Недостаточно товаров на складе!')
                        this.itemsKits[key].template.amount = this.storageGroups[this.itemsKits[key].mid].subtypes[this.itemsKits[key].template.subtype].count - sum;
                        if (this.itemsKits[key].template.amount <= 0) {
                            this.removeKit(key)
                        }
                    }
                }

                if (this.itemsKits[key]) {
                    this.itemsKits[key].reCalc();
                }
                this.basketUpdate();
            } else if (mid == 202) {
                if (this.useAltBarcodes && this.itemsMaterialVertical[key].template.barcode == '') {
                    this.searchBarcodeForVMaterial(this.itemsMaterialVertical[key])
                }
                this.itemsMaterialVertical[key].reCalc();

                let totalAmount = 0;
                let maxAmount = this.itemsMaterialVertical[key].materials[this.itemsMaterialVertical[key].template.material].gdsInStock * 100;

                for (let item in this.itemsMaterialVertical) {
                    if (this.itemsMaterialVertical[item].template.material === this.itemsMaterialVertical[key].template.material) {
                        // let width = 0;
                        // if (this.itemsMaterialVertical[item].template.lamels == 10) {
                        //     width = 7.5;
                        // } else if (this.itemsMaterialVertical[item].template.lamels == 15) {
                        //     width = 11.5;
                        // } else if (this.itemsMaterialVertical[item].template.lamels == 20) {
                        //     width = 15.5;
                        // }
                        //
                        // console.log(width, this.itemsMaterialVertical[item].template.height)
                        //
                        // totalAmount += (width * this.itemsMaterialVertical[item].template.height) * this.itemsMaterialVertical[item].template.amount;

                        // console.log(this.itemsMaterialVertical[item].template.height, this.itemsMaterialVertical[item].template.lamels, this.itemsMaterialVertical[item].template.amount)
                        let size = (parseInt(this.itemsMaterialVertical[item].template.height) + 6) * this.itemsMaterialVertical[item].template.lamels * this.itemsMaterialVertical[item].template.amount
                        // console.log(size / 100)
                        totalAmount += size
                    }
                }

                // console.log(totalAmount / 100, maxAmount / 100)

                if (totalAmount > maxAmount) {
                    if (!rm_katris.noAlerts) {
                        alert('Недостаточно материала! Выберите другой материал!');
                    }

                    this.itemsMaterialVertical.splice(key, 1);
                }

                this.basketUpdate();
            }
        },
        updateActionsGoodsList() {
            let actionsGoodsList = [];

            for (let i in this.items) {
                // this.items[i].materials[this.items[i].template.material].action = true;

                if (this.items[i].materials[this.items[i].template.material] && (this.items[i].materials[this.items[i].template.material].action || this.items[i].materials[this.items[i].template.material].storageAction)) {
                    actionsGoodsList.push(this.items[i])
                }
            }

            for (let i in this.itemsMaterialVertical) {
                // this.itemsMaterialVertical[i].materials[this.itemsMaterialVertical[i].template.material].action = true;

                if (this.itemsMaterialVertical[i].materials[this.itemsMaterialVertical[i].template.material] && this.itemsMaterialVertical[i].materials[this.itemsMaterialVertical[i].template.material].action) {
                    actionsGoodsList.push(this.itemsMaterialVertical[i])
                }
            }

            let actions = rm_katris.actions;
            for (let action in actions) {
                if (actions[action].type == 1) {
                    let goodsArr = [];
                    if (actions[action].goodsArray != '') {
                        goodsArr = JSON.parse(actions[action].goodsArray)
                    }

                    for (let good in goodsArr) {
                        for (let i in this.itemsCorniceVertical) {
                            if (goodsArr[good].slice(0, 3) == 400) { //VForm
                                if (parseInt(goodsArr[good].slice(7)) == this.itemsCorniceVertical[i].template.mountType) {
                                    actionsGoodsList.push(this.itemsCorniceVertical[i])
                                }
                            }
                        }

                        for (let i in this.itemsCornice) {
                            if (goodsArr[good].slice(0, 3) == 401) {
                                if (parseInt(goodsArr[good].slice(6, 8)) == this.itemsCornice[i].template.corniceSubtype) {
                                    actionsGoodsList.push(this.itemsCornice[i])
                                }
                            }
                        }
                    }
                }
            }

            rm_katris.actionItems = actionsGoodsList;

            // console.log(actionsGoodsList)
        },
        basketUpdate() {
            // console.log('baskupd')

            this.updateExcelData()
            this.updateActionsGoodsList()

            rm_katris.basket.clear();

            for (let i in this.items) {
                this.items[i].store();
                this.items[i].reCalc();
                rm_katris.orderItemsConfirm(this.items[i]);
            }

            for (let i in this.itemsCornice) {
                this.itemsCornice[i].store();
                this.itemsCornice[i].reCalc();
                rm_katris.orderItemsConfirm(this.itemsCornice[i]);
            }

            for (let i in this.itemsCorniceVertical) {
                this.itemsCorniceVertical[i].store();
                this.itemsCorniceVertical[i].reCalc();
                rm_katris.orderItemsConfirm(this.itemsCorniceVertical[i]);
            }

            for (let i in this.itemsMaterialVertical) {
                this.itemsMaterialVertical[i].store();
                this.itemsMaterialVertical[i].reCalc();
                rm_katris.orderItemsConfirm(this.itemsMaterialVertical[i]);
            }

            for (let i in this.itemsKits) {
                this.itemsKits[i].store();
                this.itemsKits[i].reCalc();
                rm_katris.orderItemsConfirm(this.itemsKits[i]);
            }

            rm_katris.basket.reCalc();

            let itemsCount = rm_katris.basket.totalCount + rm_katris.basket.prevOrdersCount;

            let discountsActual = this.discounts;
            if (this.isPF && this.discounts_pf && this.mode == 2) {
                discountsActual = this.discounts_pf;
            }

            for (let count in discountsActual) {
                if (count > itemsCount) {
                    this.nextItems = count - itemsCount;
                    this.nextSale = discountsActual[count];
                    break;
                }
            }

            this.store();
        },
        store() {
            let itemsStoreList = [];
            let itemsCorniceStoreList = [];
            for (let item in this.items) {
                itemsStoreList.push(this.items[item].template);
            }
            for (let item in this.itemsCornice) {
                // itemsCorniceStoreList.push(this.itemsCornice[item].template);
                itemsStoreList.push(this.itemsCornice[item].template);
            }

            storage.remove('items');
            storage.remove('itemsCornice');
            storage.set('items', itemsStoreList);
            storage.set('itemsCornice', itemsCorniceStoreList);
        },
        closeOrder: function () {
            this.$modal.hide('order')
        },
        sendOrder: function () {
            if (this.orderNumber != '' && this.orderDeliveryID != -1 && this.orderPayerID != -1) {
                this.orderSent = true;
                let barcodesValid = true;

                //Уберем штрихи если не стоит галка и проверем валидацию если стоит
                for (let item in this.items) {
                    if (!this.useAltBarcodes) {
                        this.items[item].template.barcodeType = 0;
                        this.items[item].template.barcode = "";
                    } else {
                        this.items[item].template.barcodeRed = false;
                        let valid = false;
                        if (this.items[item].template.barcodeType == 1) {
                            valid = this.validateBarcode(this.items[item].template.barcode)
                        } else if (this.items[item].template.barcodeType == 2) {
                            if (this.items[item].template.barcode.length > 0) {
                                valid = true
                            }
                        }
                        if (!valid) {
                            this.items[item].template.barcodeRed = true
                            barcodesValid = false
                        }
                    }
                }
                for (let item in this.itemsCornice) {
                    if (!this.useAltBarcodes) {
                        this.itemsCornice[item].template.barcodeType = 0;
                        this.itemsCornice[item].template.barcode = "";
                    } else {
                        this.itemsCornice[item].template.barcodeRed = false;
                        let valid = false;
                        if (this.itemsCornice[item].template.barcodeType == 1) {
                            valid = this.validateBarcode(this.itemsCornice[item].template.barcode)
                        } else if (this.itemsCornice[item].template.barcodeType == 2) {
                            if (this.itemsCornice[item].template.barcode.length > 0) {
                                valid = true
                            }
                        }
                        if (!valid) {
                            this.itemsCornice[item].template.barcodeRed = true
                            barcodesValid = false
                        }
                    }
                }
                for (let item in this.itemsCorniceVertical) {
                    if (!this.useAltBarcodes) {
                        this.itemsCorniceVertical[item].template.barcodeType = 0;
                        this.itemsCorniceVertical[item].template.barcode = "";
                    } else {
                        this.itemsCorniceVertical[item].template.barcodeRed = false;
                        let valid = false;
                        if (this.itemsCorniceVertical[item].template.barcodeType == 1) {
                            valid = this.validateBarcode(this.itemsCorniceVertical[item].template.barcode)
                        } else if (this.itemsCorniceVertical[item].template.barcodeType == 2) {
                            if (this.itemsCorniceVertical[item].template.barcode.length > 0) {
                                valid = true
                            }
                        }
                        if (!valid) {
                            this.itemsCorniceVertical[item].template.barcodeRed = true
                            barcodesValid = false
                        }
                    }
                }
                for (let item in this.itemsMaterialVertical) {
                    if (!this.useAltBarcodes) {
                        this.itemsMaterialVertical[item].template.barcodeType = 0;
                        this.itemsMaterialVertical[item].template.barcode = "";
                    } else {
                        this.itemsMaterialVertical[item].template.barcodeRed = false;
                        let valid = false;
                        if (this.itemsMaterialVertical[item].template.barcodeType == 1) {
                            valid = this.validateBarcode(this.itemsMaterialVertical[item].template.barcode)
                        } else if (this.itemsMaterialVertical[item].template.barcodeType == 2) {
                            if (this.itemsMaterialVertical[item].template.barcode.length > 0) {
                                valid = true
                            }
                        }
                        if (!valid) {
                            this.itemsMaterialVertical[item].template.barcodeRed = true
                            barcodesValid = false
                        }
                    }
                }

                if (barcodesValid) {
                    rm_katris.num = this.orderNumber;
                    rm_katris.delivery = this.orderDeliveryID;
                    rm_katris.payer = this.orderPayerID;
                    rm_katris.proccessDoneSend();
                } else {
                    this.orderSent = false;
                    alert('Проверьте правильность ввода выделенных штрихкодов!')
                    this.$modal.hide('order')
                }

            } else {
                alert('Не все поля корректно заполнены!');
            }
        },
        notifyMe: function (item) {
            let self = this;

            rm_katris.makePost('katrisService', 'createNotification', {
                'token': this.$session.get('jwt'),
                'goodID': item.id_good,
                'type': 3
            }, null, function (respond) {
                if (respond.status === 'OK') {
                    item.notify = true;
                    item.notificationID = respond.data.ID;

                    self.$notificationsGlobal.waitListLength += 1;
                    if (self.$notificationsGlobal.emptyNotices) self.$notificationsGlobal.emptyNotices = false;

                    for (let mat in rm_katris.params.init_data.materials) {
                        if (rm_katris.params.init_data.materials[mat].id_good == item.id_good) {
                            rm_katris.params.init_data.materials[mat].notify = true;
                            rm_katris.params.init_data.materials[mat].notificationID = respond.data.ID;
                        }
                    }

                    self.notifyList.push({goodID: item.id_good, active: 1, type: 3})
                }
            });
        },
        disableNotifications: function (item) {
            let self = this;
            rm_katris.makePost('katrisService', 'disableNotification', {
                'token': this.$session.get('jwt'),
                'notificationID': item.notificationID
            }, null, function (respond) {
                if (respond.status === 'OK') {
                    item.notify = false;

                    self.$notificationsGlobal.waitListLength -= 1;
                    if (self.$notificationsGlobal.waitListLength == 0) self.$notificationsGlobal.emptyNotices = true;

                    for (let mat in rm_katris.params.init_data.materials) {
                        if (rm_katris.params.init_data.materials[mat].id_good == item.id_good) {
                            rm_katris.params.init_data.materials[mat].notify = false;
                        }
                    }

                    for (let notify in self.notifyList) {
                        if (self.notifyList[notify].goodID == item.id_good && self.notifyList[notify].active == 1 && self.notifyList[notify].type == 3) {
                            self.notifyList[notify].active = 0;
                        }
                    }
                }
            });
        },
        openCorniceModal: function (mid) {
            this.corniceModalMid = mid;
            this.$modal.show('modalTable')
        },
        openCornice: function () {
            let self = this;

            if (!self.itemsCornice[0]) {
                self.itemsCornice.push(new RMCalc(rm_katris, 101));
                self.recalc(self.itemsCornice.length - 1, self.itemsCornice[self.itemsCornice.length - 1].mid);
            }
        },
        fullfillStorage: function () {
            let self = this;
            rm_katris.makePost('katrisService', 'getStorageRMLimits', {'token': self.$session.get('jwt')}, null, function (respond) {
                if (respond.status == "OK") {
                    // console.log(respond.data)
                    self.toOrder = [];
                    for (let item in respond.data) {
                        if (parseInt(respond.data[item].count2) <= parseInt(respond.data[item].min) && respond.data[item].min != null && respond.data[item].max != null && parseInt(respond.data[item].max) > 0 && parseInt(respond.data[item].max) > parseInt(respond.data[item].min) && respond.data[item].name != 'стандартные RM') {
                            respond.data[item].toOrder = respond.data[item].max - respond.data[item].count2;
                            self.toOrder.push(respond.data[item])
                        }
                    }
                    self.$modal.show('toOrder');
                }
            });

        },
        sendStorageOrder: function (type) {
            let self = this;

            self.$modal.hide('toOrder');

            self.items = [];
            self.basketUpdate();

            self.setMode(1);

            if (type == 1) {
                self.orderMode = 4;
            } else if (type == 2) {
                self.orderMode = 1;
            } else if (type == 3) {
                self.orderMode = 6;
            }

            this.types = [];

            if (this.orderMode == 1) {
                for (let type in this.typesAll) {
                    if (type != 14 && type != 140 && type != 141) {
                        this.types.push(this.typesAll[type])
                    }
                }
            } else if (this.orderMode == 4) {
                for (let type in this.typesAll) {
                    // if (type == 14 || type == 140 || type == 141) {
                    if (type == 140 || type == 141) {
                        this.types.push(this.typesAll[type])
                    }
                }
            }

            self.items = [];
            self.basketUpdate();

            rm_katris.noAlerts = true;

            for (let item in self.toOrder) {
                let mid = 0;

                // switch (self.toOrder[item].type + ' ' + self.toOrder[item].name) {
                //     case "Горизонтальные жалюзи стандартные RM":
                //         mid = 14;
                //         break;
                //     case "Рулонные шторы MINI RM":
                //         mid = 6;
                //         break;
                //     case "Рулонные шторы Zebra RM":
                //         mid = 13;
                //         break;
                // }

                switch (self.toOrder[item].name) {
                    case "картон RM":
                        mid = 141;
                        break;
                    case "стандартные RM":
                        mid = 14;
                        break;
                    case "MINI RM":
                        mid = 6;
                        break;
                    case "Zebra RM":
                        mid = 13;
                        break;
                }
                if (self.toOrder[item].type == "Набор ремкомплект") {
                    mid = 301;
                }

                if (mid > 0 && (((mid == 14 || mid == 140 || mid == 141) && type == 1) || ((mid == 6 || mid == 13) && type == 2)) || (mid == 301 && type == 3)) {
                    let materialID = 0;
                    if (type == 3) {
                        self.itemsKits.push(new RMCalc(rm_katris, mid));
                    } else {
                        self.items.push(new RMCalc(rm_katris, mid));
                    }

                    if (type != 3) {
                        for (let material in self.items[self.items.length - 1].materials) {
                            if (self.items[self.items.length - 1].materials[material] && self.items[self.items.length - 1].materials[material].name == self.toOrder[item].material) {
                                materialID = self.items[self.items.length - 1].materials[material].id_good;
                            }
                        }
                    }

                    let maxPerOne = 10;
                    if (mid == 141) {
                        maxPerOne = self.items[self.items.length - 1].prices[materialID][self.toOrder[item].height * 10][self.toOrder[item].width * 10].amount * 50;
                    } else if (mid == 301) {
                        maxPerOne = 99;
                    } else {
                        maxPerOne = self.items[self.items.length - 1].prices[materialID][self.toOrder[item].height * 10][self.toOrder[item].width * 10].amount * 40;
                    }
                    let countToAdd = self.toOrder[item].toOrder;

                    let amount = 0;

                    if (countToAdd > maxPerOne) {
                        amount = maxPerOne;
                    } else {
                        amount = countToAdd;
                    }

                    let firstItem = {}

                    if (type != 3) {
                        self.items[self.items.length - 1].template.amount = amount;
                        countToAdd -= maxPerOne;
                        self.items[self.items.length - 1].template.gab_height = self.toOrder[item].height * 10;
                        self.items[self.items.length - 1].template.gab_width = self.toOrder[item].width * 10;
                        self.items[self.items.length - 1].template.material = materialID;
                        if (self.toOrder[item].controlSide == 0) {
                            self.items[self.items.length - 1].template.ControlSide = 2;
                        } else {
                            self.items[self.items.length - 1].template.ControlSide = 1;
                        }

                        firstItem = self.items[self.items.length - 1];
                    } else {
                        self.itemsKits[self.itemsKits.length - 1].template.amount = amount;
                        countToAdd -= maxPerOne;
                        self.itemsKits[self.itemsKits.length - 1].template.gab_height = self.toOrder[item].height * 10;
                        self.itemsKits[self.itemsKits.length - 1].template.gab_width = self.toOrder[item].width * 10;
                        self.itemsKits[self.itemsKits.length - 1].template.material = materialID;
                        self.itemsKits[self.itemsKits.length - 1].template.subtype = parseInt(self.toOrder[item].name);

                        if (self.toOrder[item].controlSide == 0) {
                            self.itemsKits[self.itemsKits.length - 1].template.ControlSide = 2;
                        } else {
                            self.itemsKits[self.itemsKits.length - 1].template.ControlSide = 1;
                        }

                        firstItem = self.itemsKits[self.itemsKits.length - 1];
                    }

                    while (countToAdd > 0) {
                        if (countToAdd > maxPerOne) {
                            amount = maxPerOne;
                        } else {
                            amount = countToAdd;
                        }

                        countToAdd -= amount;

                        if (type != 3) {
                            self.items.push(new RMCalc(rm_katris, mid));
                            self.items[self.items.length - 1].template = JSON.parse(JSON.stringify(firstItem.template));
                            self.items[self.items.length - 1].template.amount = amount;
                        } else {
                            self.itemsKits.push(new RMCalc(rm_katris, mid));
                            self.itemsKits[self.itemsKits.length - 1].template = JSON.parse(JSON.stringify(firstItem.template));
                            self.itemsKits[self.itemsKits.length - 1].template.amount = amount;
                        }
                    }

                    // console.log(self.items[self.items.length - 1])

                    // self.recalc(self.items.length - 1, mid)
                }
            }

            for (let obj in self.items) {
                self.recalc(obj, self.items[obj].template.mid)
            }

            for (let obj in self.itemsKits) {
                self.recalc(obj, self.itemsKits[obj].template.mid)
            }

            // rm_katris.noAlerts = false;

            // console.log(self.items)
            this.basketUpdate();
        },
        addNewMaterialVertical: function() {
            this.backImage = 'vform.jpg';

            this.itemsMaterialVertical.push(new RMCalc(rm_katris, 202));
            this.itemsMaterialVertical[this.itemsMaterialVertical.length - 1].template.barcodeRed = false;

            this.itemsMaterialVertical[this.itemsMaterialVertical.length - 1].template.barcodeType = 0;
            this.itemsMaterialVertical[this.itemsMaterialVertical.length - 1].template.barcode = "";

            if (this.itemsMaterialVertical[this.itemsMaterialVertical.length - 1].template.barcodeType == 0 && this.useAltBarcodes) {
                this.itemsMaterialVertical[this.itemsMaterialVertical.length - 1].template.barcodeType = 1;
            }

            if (this.useAltBarcodes && this.itemsMaterialVertical[this.itemsMaterialVertical.length - 1].template.barcode == '') {
                this.searchBarcodeForVMaterial(this.itemsMaterialVertical[this.itemsMaterialVertical.length - 1])
            }

            this.recalc(this.itemsMaterialVertical.length - 1, this.itemsMaterialVertical[this.itemsMaterialVertical.length - 1].template.mid)

            this.basketUpdate();
        },
        addNewCorniceVertical: function() {
            this.backImage = 'vformkarn.jpg';

            this.itemsCorniceVertical.push(new RMCalc(rm_katris, 201));
            this.itemsCorniceVertical[this.itemsCorniceVertical.length - 1].template.barcodeRed = false;

            this.itemsCorniceVertical[this.itemsCorniceVertical.length - 1].template.barcodeType = 0;
            this.itemsCorniceVertical[this.itemsCorniceVertical.length - 1].template.barcode = "";

            if (this.itemsCorniceVertical[this.itemsCorniceVertical.length - 1].template.barcodeType == 0 && this.useAltBarcodes) {
                this.itemsCorniceVertical[this.itemsCorniceVertical.length - 1].template.barcodeType = 1;
            }

            if (this.useAltBarcodes && this.itemsCorniceVertical[this.itemsCorniceVertical.length - 1].template.barcode == '') {
                this.searchBarcodeForVCornice(this.itemsCorniceVertical[this.itemsCorniceVertical.length - 1])
            }

            this.basketUpdate();
        },
        addNewKit: function() {
            this.itemsKits.push(new RMCalc(rm_katris, 301));

            this.basketUpdate()
        },
        clearAll: function() {
            this.items = [];
            this.itemsCornice = [];
            this.itemsCorniceVertical = [];
            this.itemsMaterialVertical = [];

            this.$modal.hide('modalClear2');
            this.setOrderMode(this.nextMode)
        },
        setOrderMode: function(mode) {
            if (mode == 1 && this.mode == 2) {
                this.useAltBarcodes = false
            }

            if (this.items.length > 0 || this.itemsCornice.length > 0 || this.itemsCorniceVertical.length > 0 || this.itemsMaterialVertical.length > 0) {
                this.nextMode = mode;
                this.$modal.show('modalClear2');
            } else if (this.loaded) {
                this.orderMode = mode;

                if (this.orderMode == 2 && this.itemsMaterialVertical.length == 0 && this.itemsCorniceVertical.length == 0 ) {
                    this.backImage = 'vform.jpg';
                    this.addNewCorniceVertical();
                    // this.addNewMaterialVertical();
                } else if (this.orderMode == 8 && this.itemsMaterialVertical.length == 0 && this.itemsCorniceVertical.length == 0 ) {
                    this.backImage = 'vform.jpg';
                    this.addNewMaterialVertical();
                } else if (this.orderMode == 3 && this.itemsCornice.length == 0) {
                    this.backImage = 'karn2.png';
                    this.addNewCornice();
                } else if (this.orderMode == 6 && this.itemsKits == 0) {
                    this.addNewKit()
                } else if ((this.orderMode == 1 || this.orderMode == 4 || this.orderMode == 5 || this.orderMode == 7 || this.orderMode == 9 || this.orderMode == 10) && this.items.length == 0) {
                    this.backImage = '';
                    this.types = [];

                    console.log(this.typesAll)

                    if (this.orderMode == 1) {
                        for (let type in this.typesAll) {
                            if (type != 14 && type != 140 && type != 141 && type != 15 && type != 16 && type != 17 && type != 405 && type != 406) {
                                this.types.push(this.typesAll[type])
                            }
                        }
                    } else if (this.orderMode == 4) {
                        for (let type in this.typesAll) {
                            if (type == 141) {
                                if ((this.mode == 1 && type != 14) || this.mode == 2) {
                                    this.types.push(this.typesAll[type])
                                }
                            }
                        }
                    } else if (this.orderMode == 5) {
                        for (let type in this.typesAll) {
                            if (type == 140) {
                                if ((this.mode == 1 && type != 14) || this.mode == 2) {
                                    this.types.push(this.typesAll[type])
                                }
                            }
                        }
                    } else if (this.orderMode == 7) {
                        this.types = rm_katris.params.init_data.itemsByMat;
                    } else if (this.orderMode == 9) {
                        for (let type in this.typesAll) {
                            if (type == 15 || type == 16) {
                                this.types.push(this.typesAll[type])
                            }
                        }
                    } else if (this.orderMode == 10) {
                        for (let type in this.typesAll) {
                            if (type == 17) {
                                this.types.push(this.typesAll[type])
                            }
                        }
                    }

                    console.log('types', this.types)

                    this.addNewProcess();
                }
            }
        },
        checkLamelsType: function(item, index) {
            if (this.useAltBarcodes && item.template.barcode == '') {
                this.searchBarcodeForVCornice(item)
            }

            if (item.template.drive == 1) {
                if (!this.vFormLenghtsToMech.includes(parseInt(item.template.corniceSize))) {
                    item.template.corniceSize = this.vFormLenghtsToMech[0]
                    this.recalc(index, 201)
                }
            } else {
                if (!this.vFormLenghtsFromMech.includes(parseInt(item.template.corniceSize))) {
                    item.template.corniceSize = this.vFormLenghtsFromMech[0]
                    this.recalc(index, 201)
                }
            }

            this.updateExcelData()
        },
        openCorniceInfo: function(item) {
            item.corniceOpened = !item.corniceOpened;
        },
        openKitInfo: function(item) {
            this.kitImage = 'kit' + item.template.subtype + '.jpg';

            this.$modal.show('kitInfo')
        },
        useBarcodes: function() {
            // let self = this;
            this.updateExcelData()

            if (this.useAltBarcodes) {
                for (let item in this.items) {
                    if (this.items[item].template.barcodeType == 0) {
                        this.items[item].template.barcodeType = 1;
                    }

                    this.searchBarcodeForItem(this.items[item])
                }
                for (let item in this.itemsCornice) {
                    if (this.itemsCornice[item].template.barcodeType == 0) {
                        this.itemsCornice[item].template.barcodeType = 1;
                    }

                    this.searchBarcodeForCornice(this.itemsCornice[item])
                }
                for (let item in this.itemsCorniceVertical) {
                    if (this.itemsCorniceVertical[item].template.barcodeType == 0) {
                        this.itemsCorniceVertical[item].template.barcodeType = 1;
                    }

                    this.searchBarcodeForVCornice(this.itemsCorniceVertical[item])
                }
                for (let item in this.itemsMaterialVertical) {
                    if (this.itemsMaterialVertical[item].template.barcodeType == 0) {
                        this.itemsMaterialVertical[item].template.barcodeType = 1;
                    }

                    this.searchBarcodeForVMaterial(this.itemsMaterialVertical[item])
                }
            }
        },
        searchBarcodeForItem: function(item) {
            console.log('barcodeSearch')

            let typeReferences = {
                hblinds1: {
                    type: 30003320,
                    subtype: 4
                },
                rolo1: {
                    type: 20000163,
                    subtype: 7
                },
                rolo2: {
                    type: 20000163,
                    subtype: 8
                },
                zebra21: {
                    type: 20000163,
                    subtype: 9
                }
            }

            let founded = false;

            let itemWidth = parseInt(item.template.gab_width);

            if (this.mode == 3) {
                if (item.template.mid == 405) {
                    itemWidth += 37
                } else if (item.template.mid == 406) {
                    itemWidth += 40
                }
            }

            let ref = false;
            if (item.crutch.type) {
                ref = item.crutch
            } else if (typeReferences[item.template.type + '' + item.template.subtype]) {
                ref = typeReferences[item.template.type + '' + item.template.subtype];
            }

            console.log('ob', this.oldBarcodes)
            for (let barcode in this.oldBarcodes) {
                if (ref && ref.type == this.oldBarcodes[barcode].productType && ref.subtype == this.oldBarcodes[barcode].productSubtype) {
                    if (this.oldBarcodes[barcode].material == item.template.material && this.oldBarcodes[barcode].height * 10 == item.template.gab_height && this.oldBarcodes[barcode].width * 10 == itemWidth && this.oldBarcodes[barcode].barcodeType == item.template.barcodeType && this.oldBarcodes[barcode].controlSide == item.template.ControlSide) {
                        item.template.barcode = this.oldBarcodes[barcode].barcode
                        if (this.oldBarcodes[barcode].barcode1 != null) {
                            console.log(this.oldBarcodes[barcode])
                            item.template.barcodeText1 = this.oldBarcodes[barcode].barcode1
                            item.template.barcodeText2 = this.oldBarcodes[barcode].barcode2
                            item.template.barcodeText3 = this.oldBarcodes[barcode].barcode3
                        }
                        founded = true
                    }
                }
            }

            if (!founded) {
                item.template.barcode = ''
            }
        },
        searchBarcodeForCornice: function(item) {
            let founded = false;

            for (let barcode in this.oldBarcodes) {
                if (this.oldBarcodes[barcode].productType == '30003607' && this.oldBarcodes[barcode].corniceSubtype == item.template.corniceSubtype && this.oldBarcodes[barcode].barcodeType == item.template.barcodeType) {
                    item.template.barcode = this.oldBarcodes[barcode].barcode
                    if (this.oldBarcodes[barcode].barcode1 != null) {
                        item.template.barcodeText1 = this.oldBarcodes[barcode].barcode1
                        item.template.barcodeText2 = this.oldBarcodes[barcode].barcode2
                        item.template.barcodeText3 = this.oldBarcodes[barcode].barcode3
                    }
                    founded = true
                }
            }

            if (!founded) {
                item.template.barcode = ''
            }
        },
        searchBarcodeForVCornice: function(item) {
            let founded = false;

            for (let barcode in this.oldBarcodes) {
                if (this.oldBarcodes[barcode].productType == '20000131' && this.oldBarcodes[barcode].productSubtype == '10') {
                    if (this.oldBarcodes[barcode].corniceSize == item.template.corniceSize && this.oldBarcodes[barcode].mountType == item.template.mountType && this.oldBarcodes[barcode].drive == item.template.drive && this.oldBarcodes[barcode].barcodeType == item.template.barcodeType) {
                        item.template.barcode = this.oldBarcodes[barcode].barcode
                        if (this.oldBarcodes[barcode].barcode1 != null) {
                            item.template.barcodeText1 = this.oldBarcodes[barcode].barcode1
                            item.template.barcodeText2 = this.oldBarcodes[barcode].barcode2
                            item.template.barcodeText3 = this.oldBarcodes[barcode].barcode3
                        }
                        founded = true
                    }
                }
            }

            if (!founded) {
                item.template.barcode = ''
            }
        },
        searchBarcodeForVMaterial: function(item) {
            // console.log('barcodeSearchVFormMat')

            let founded = false;

            // console.log('ob', this.oldBarcodes)
            for (let barcode in this.oldBarcodes) {
                if (this.oldBarcodes[barcode].productType == '20000131' && this.oldBarcodes[barcode].productSubtype == '11') {
                    // console.log(this.oldBarcodes[barcode])
                    // console.log(this.oldBarcodes[barcode].material, item.template.material, this.oldBarcodes[barcode].height, item.template.height, this.oldBarcodes[barcode].lamels == item.template.lamels, this.oldBarcodes[barcode].barcodeType, item.template.barcodeType)

                    if (this.oldBarcodes[barcode].material == item.template.material && this.oldBarcodes[barcode].height == item.template.height && this.oldBarcodes[barcode].lamels == item.template.lamels && this.oldBarcodes[barcode].barcodeType == item.template.barcodeType) {
                        item.template.barcode = this.oldBarcodes[barcode].barcode
                        if (this.oldBarcodes[barcode].barcode1 != null) {
                            item.template.barcodeText1 = this.oldBarcodes[barcode].barcode1
                            item.template.barcodeText2 = this.oldBarcodes[barcode].barcode2
                            item.template.barcodeText3 = this.oldBarcodes[barcode].barcode3
                        }
                        founded = true
                    }
                }
            }

            if (!founded) {
                item.template.barcode = ''
            }
        },
        validateBarcode: function(barcode) {
            if (barcode.length != 13) {
                return false;
            } else {
                let num1 = parseInt(barcode[1]) + parseInt(barcode[3]) + parseInt(barcode[5]) + parseInt(barcode[7]) + parseInt(barcode[9]) + parseInt(barcode[11]);
                let num2 = parseInt(barcode[0]) + parseInt(barcode[2]) + parseInt(barcode[4]) + parseInt(barcode[6]) + parseInt(barcode[8]) + parseInt(barcode[10]);
                let num3 = (num1 * 3) + num2

                // console.log(num1, num2, num3, 10 - num3.toString()[num3.toString().length - 1], barcode[12])

                if (10 - num3.toString()[num3.toString().length - 1] == barcode[12]) {
                    return true
                } else if (num3.toString()[num3.toString().length - 1] == 0 && barcode[12] == 0) {
                    return true
                } else {
                    return false
                }
            }
        },
        openInfo: function(template) {
            let self = this;

            switch (template.mid) {
                case 6:
                    self.selectedImages = self.packageImages.rolo1
                    self.selectedPackInfo.type = 1
                    break;
                case 5:
                    self.selectedImages = self.packageImages.rolo2
                    self.selectedPackInfo.type = 1
                    break;
                case 13:
                    self.selectedImages = self.packageImages.zebra
                    self.selectedPackInfo.type = 1
                    break;
                case 15:
                    if (template.gab_width < 650) {
                        self.selectedImages = self.packageImages.roloCarton1
                    } else {
                        self.selectedImages = self.packageImages.roloCarton2
                    }
                    self.selectedPackInfo.type = 5
                    break;
                case 16:
                    self.selectedImages = self.packageImages.zebra;
                    self.selectedPackInfo.type = 2
                    break;
                case 17:
                    if (template.gab_width < 650) {
                        self.selectedImages = self.packageImages.rolo140_1
                    } else {
                        self.selectedImages = self.packageImages.rolo140_2
                    }
                    self.selectedPackInfo.type = 6
                    break;
                case 141:
                    self.selectedImages = self.packageImages.gform_box
                    self.selectedPackInfo.type = 2
                    break;
                case 140:
                    self.selectedImages = self.packageImages.gform
                    self.selectedPackInfo.type = 1
                    break;
                case 201:
                    self.selectedImages = self.packageImages.cornice
                    self.selectedPackInfo.type = 3
                    break;
                case 202:
                    self.selectedImages = self.packageImages.vform
                    self.selectedPackInfo.type = 4
                    break;
            }

            self.selectedPackInfo.gab1 = template.packSize2
            self.selectedPackInfo.gab2 = template.packSize
            self.selectedPackInfo.gab3 = template.amountInPack

            this.$modal.show('orderInfo')
        },
        updateExcelData: function() {
            let self = this

            this.json_data = []

            if (this.orderMode == 1 || this.orderMode == 4 || this.orderMode == 5 || this.orderMode == 7 || this.orderMode == 9 || this.orderMode == 10) {
                this.json_fields = {
                    "Тип изделия": "name",
                    "Материал": "material",
                    "Габ-ная ширина изделия, см": "width",
                    "Габ-ная высота изделия, см": "height",
                    "Габаритные размеры упаковки": "packSize",
                    "Кол-во (шт.)": "amount",
                    "Сторона управления": "side",
                    "Намотка ткани": "backWrap",
                    "Тип штрихкода": "barcodeType",
                    "Штрихкод": "barcode",
                    "Текстовое поле ШК 1": "barcodeText1",
                    "Текстовое поле ШК 2": "barcodeText2",
                    "Текстовое поле ШК 3": "barcodeText3",
                    "Цена за одно изделие (прайс)": "price1",
                    "Цена за одно изделие со скидкой": "price2",
                    "Цена общая со скидкой": "price3",
                }

                for (let item in this.items) {
                    let side = 'Левая';
                    if (this.items[item].template.ControlSide == 2) {
                        side = 'Правая'
                    }

                    let backWrap = '-'
                    if (this.items[item].template.BackWrap == 1) {
                        backWrap = 'Прямая'
                    } else if (this.items[item].template.BackWrap == 2) {
                        backWrap = 'Обратная'
                    }

                    let barcodeType = "EAN 13"
                    if (this.items[item].template.barcodeType == 2) {
                        barcodeType = 'Code 39'
                    }

                    let object = {
                        name: this.items[item].header,
                        material: this.items[item].materials[this.items[item].template.material].name,
                        height: this.items[item].template.gab_height / 10,
                        width: this.items[item].template.gab_width / 10,
                        packSize: this.items[item].template.packSize,
                        amount: this.items[item].template.amount,
                        price1: (this.items[item].template.price / this.items[item].template.amount).toFixed(2),
                        price2: this.items[item].template.sale == 0 ? ((this.items[item].template.price - (self.rm.basket.totalSale / 100 * this.items[item].template.price)) / this.items[item].template.amount).toFixed(2) : ((this.items[item].template.price - (this.items[item].template.sale / 100 * this.items[item].template.price)) / this.items[item].template.amount).toFixed(2),
                        price3: this.items[item].template.sale == 0 ? (this.items[item].template.price - (self.rm.basket.totalSale / 100 * this.items[item].template.price)).toFixed(2) : (this.items[item].template.price - (this.items[item].template.sale / 100 * this.items[item].template.price)).toFixed(2),
                        side: side,
                        backWrap: backWrap,
                        barcodeType: barcodeType,
                        barcode: this.items[item].template.barcode,
                        barcodeText1: this.items[item].template.barcodeText1,
                        barcodeText2: this.items[item].template.barcodeText2,
                        barcodeText3: this.items[item].template.barcodeText3

                    }
                    this.json_data.push(object)
                }
            } else if (this.orderMode == 2) {
                this.json_fields = {
                    "Тип изделия": "name",
                    "Тип крепления": "mountType",
                    "Тип раздвижки ламелей": "drive",
                    "Длина": "length",
                    "Высота управления": "controlHeight",

                    "Габаритные размеры упаковки": "packSize",
                    "Кол-во (шт.)": "amount",
                    "Тип штрихкода": "barcodeType",
                    "Штрихкод": "barcode",
                    "Текстовое поле ШК 1": "barcodeText1",
                    "Текстовое поле ШК 2": "barcodeText2",
                    "Текстовое поле ШК 3": "barcodeText3",
                    "Цена за одно изделие (прайс)": "price1",
                    "Цена за одно изделие со скидкой": "price2",
                    "Цена общая со скидкой": "price3",
                }

                for (let item in this.itemsCorniceVertical) {
                    let mountType = "Потолок"
                    if (this.itemsCorniceVertical[item].template.mountType == 2) {
                        mountType = 'Стена'
                    } else if (this.itemsCorniceVertical[item].template.mountType == 3) {
                        mountType = 'Стена с удлинителем'
                    }

                    let drive = "К механизму управления"
                    if (this.itemsCorniceVertical[item].template.mountType == 2) {
                        drive = 'От центра в две стороны'
                    } else if (this.itemsCorniceVertical[item].template.mountType == 3) {
                        drive = 'От механизма управления'
                    }

                    let barcodeType = "EAN 13"
                    if (this.itemsCorniceVertical[item].template.barcodeType == 2) {
                        barcodeType = 'Code 39'
                    }

                    let object = {
                        name: this.itemsCorniceVertical[item].header,
                        mountType: mountType,
                        drive: drive,
                        length: this.itemsCorniceVertical[item].template.corniceSize,
                        controlHeight: this.itemsCorniceVertical[item].template.controlHeight,
                        packSize: this.itemsCorniceVertical[item].template.packSize,
                        amount: this.itemsCorniceVertical[item].template.amount,
                        price1: (this.itemsCorniceVertical[item].template.price / this.itemsCorniceVertical[item].template.amount).toFixed(2),
                        price2: this.itemsCorniceVertical[item].template.sale == 0 ? ((this.itemsCorniceVertical[item].template.price - (self.rm.basket.totalSale / 100 * this.itemsCorniceVertical[item].template.price)) / this.itemsCorniceVertical[item].template.amount).toFixed(2) : ((this.itemsCorniceVertical[item].template.price - (this.itemsCorniceVertical[item].template.sale / 100 * this.itemsCorniceVertical[item].template.price)) / this.itemsCorniceVertical[item].template.amount).toFixed(2),
                        price3: this.itemsCorniceVertical[item].template.sale == 0 ? (this.itemsCorniceVertical[item].template.price - (self.rm.basket.totalSale / 100 * this.itemsCorniceVertical[item].template.price)).toFixed(2) : (this.itemsCorniceVertical[item].template.price - (this.itemsCorniceVertical[item].template.sale / 100 * this.itemsCorniceVertical[item].template.price)).toFixed(2),
                        barcodeType: barcodeType,
                        barcode: this.itemsCorniceVertical[item].template.barcode,
                        barcodeText1: this.itemsCorniceVertical[item].template.barcodeText1,
                        barcodeText2: this.itemsCorniceVertical[item].template.barcodeText2,
                        barcodeText3: this.itemsCorniceVertical[item].template.barcodeText3

                    }
                    this.json_data.push(object)
                }
            } else if (this.orderMode == 8) {
                this.json_fields = {
                    "Тип изделия": "name",
                    "Материал": "material",
                    "Количество ламелей": "lamelsAmount",
                    "Габаритная высота изделия": "height",

                    "Габаритные размеры упаковки": "packSize",
                    "Кол-во (шт.)": "amount",
                    "Тип штрихкода": "barcodeType",
                    "Штрихкод": "barcode",
                    "Текстовое поле ШК 1": "barcodeText1",
                    "Текстовое поле ШК 2": "barcodeText2",
                    "Текстовое поле ШК 3": "barcodeText3",
                    "Цена за одно изделие (прайс)": "price1",
                    "Цена за одно изделие со скидкой": "price2",
                    "Цена общая со скидкой": "price3",
                }

                for (let item in this.itemsMaterialVertical) {
                    let barcodeType = "EAN 13"
                    if (this.itemsMaterialVertical[item].template.barcodeType == 2) {
                        barcodeType = 'Code 39'
                    }

                    let object = {
                        name: this.itemsMaterialVertical[item].header,
                        material: this.itemsMaterialVertical[item].materials[this.itemsMaterialVertical[item].template.material].name,
                        lamelsAmount: this.itemsMaterialVertical[item].template.lamels,
                        height: this.itemsMaterialVertical[item].template.height,

                        packSize: this.itemsMaterialVertical[item].template.packSize,
                        amount: this.itemsMaterialVertical[item].template.amount,
                        price1: (this.itemsMaterialVertical[item].template.price / this.itemsMaterialVertical[item].template.amount).toFixed(2),
                        price2: this.itemsMaterialVertical[item].template.sale == 0 ? ((this.itemsMaterialVertical[item].template.price - (self.rm.basket.totalSale / 100 * this.itemsMaterialVertical[item].template.price)) / this.itemsMaterialVertical[item].template.amount).toFixed(2) : ((this.itemsMaterialVertical[item].template.price - (this.itemsMaterialVertical[item].template.sale / 100 * this.itemsMaterialVertical[item].template.price)) / this.itemsMaterialVertical[item].template.amount).toFixed(2),
                        price3: this.itemsMaterialVertical[item].template.sale == 0 ? (this.itemsMaterialVertical[item].template.price - (self.rm.basket.totalSale / 100 * this.itemsMaterialVertical[item].template.price)).toFixed(2) : (this.itemsMaterialVertical[item].template.price - (this.itemsMaterialVertical[item].template.sale / 100 * this.itemsMaterialVertical[item].template.price)).toFixed(2),
                        barcodeType: barcodeType,
                        barcode: this.itemsMaterialVertical[item].template.barcode,
                        barcodeText1: this.itemsMaterialVertical[item].template.barcodeText1,
                        barcodeText2: this.itemsMaterialVertical[item].template.barcodeText2,
                        barcodeText3: this.itemsMaterialVertical[item].template.barcodeText3
                    }
                    this.json_data.push(object)
                }
            }
        },
        addToBasket: function() {
            let self = this;

            series([
                function (done) {
                    let controlSideAlert = false;
                    for (let obj in self.items) {
                        if (self.items[obj].template.BackWrap == 0 && self.items[obj].template.mid != 14 && self.items[obj].template.mid != 140 && self.items[obj].template.mid != 141) {
                            controlSideAlert = true;
                            self.items[obj].alert = true;
                        }
                    }

                    if (!controlSideAlert) {
                        done()
                    } else {
                        alert('Выберите намотку ткани!')
                    }
                },
                function (done) {
                    if (this.orderNumber != '' && this.orderDeliveryID != -1 && this.orderPayerID != -1) {
                        this.orderSent = true;
                        let barcodesValid = true;

                        //Уберем штрихи если не стоит галка и проверем валидацию если стоит
                        for (let item in this.items) {
                            if (!this.useAltBarcodes) {
                                this.items[item].template.barcodeType = 0;
                                this.items[item].template.barcode = "";
                            } else {
                                this.items[item].template.barcodeRed = false;
                                let valid = false;
                                if (this.items[item].template.barcodeType == 1) {
                                    valid = this.validateBarcode(this.items[item].template.barcode)
                                } else if (this.items[item].template.barcodeType == 2) {
                                    if (this.items[item].template.barcode.length > 0) {
                                        valid = true
                                    }
                                }
                                if (!valid) {
                                    this.items[item].template.barcodeRed = true
                                    barcodesValid = false
                                }
                            }
                        }
                        for (let item in this.itemsCornice) {
                            if (!this.useAltBarcodes) {
                                this.itemsCornice[item].template.barcodeType = 0;
                                this.itemsCornice[item].template.barcode = "";
                            } else {
                                this.itemsCornice[item].template.barcodeRed = false;
                                let valid = false;
                                if (this.itemsCornice[item].template.barcodeType == 1) {
                                    valid = this.validateBarcode(this.itemsCornice[item].template.barcode)
                                } else if (this.itemsCornice[item].template.barcodeType == 2) {
                                    if (this.itemsCornice[item].template.barcode.length > 0) {
                                        valid = true
                                    }
                                }
                                if (!valid) {
                                    this.itemsCornice[item].template.barcodeRed = true
                                    barcodesValid = false
                                }
                            }
                        }
                        for (let item in this.itemsCorniceVertical) {
                            if (!this.useAltBarcodes) {
                                this.itemsCorniceVertical[item].template.barcodeType = 0;
                                this.itemsCorniceVertical[item].template.barcode = "";
                            } else {
                                this.itemsCorniceVertical[item].template.barcodeRed = false;
                                let valid = false;
                                if (this.itemsCorniceVertical[item].template.barcodeType == 1) {
                                    valid = this.validateBarcode(this.itemsCorniceVertical[item].template.barcode)
                                } else if (this.itemsCorniceVertical[item].template.barcodeType == 2) {
                                    if (this.itemsCorniceVertical[item].template.barcode.length > 0) {
                                        valid = true
                                    }
                                }
                                if (!valid) {
                                    this.itemsCorniceVertical[item].template.barcodeRed = true
                                    barcodesValid = false
                                }
                            }
                        }
                        for (let item in this.itemsMaterialVertical) {
                            if (!this.useAltBarcodes) {
                                this.itemsMaterialVertical[item].template.barcodeType = 0;
                                this.itemsMaterialVertical[item].template.barcode = "";
                            } else {
                                this.itemsMaterialVertical[item].template.barcodeRed = false;
                                let valid = false;
                                if (this.itemsMaterialVertical[item].template.barcodeType == 1) {
                                    valid = this.validateBarcode(this.itemsMaterialVertical[item].template.barcode)
                                } else if (this.itemsMaterialVertical[item].template.barcodeType == 2) {
                                    if (this.itemsMaterialVertical[item].template.barcode.length > 0) {
                                        valid = true
                                    }
                                }
                                if (!valid) {
                                    this.itemsMaterialVertical[item].template.barcodeRed = true
                                    barcodesValid = false
                                }
                            }
                        }

                        if (barcodesValid) {
                            done()
                        } else {
                            this.orderSent = false;
                            alert('Проверьте правильность ввода выделенных штрихкодов!')
                        }

                    } else {
                        alert('Не все поля корректно заполнены!');
                    }
                },
                function () {
                    // let basketCount = basketStorage.get('basketCount');

                    if (self.items.length > 0) {
                        let controlSideAlert = false;
                        for (let obj in this.items) {
                            if (this.items[obj].template.BackWrap == 0 && this.items[obj].template.mid != 14 && this.items[obj].template.mid != 140 && this.items[obj].template.mid != 141) {
                                controlSideAlert = true;
                                this.items[obj].alert = true;
                            }
                        }

                        if (!controlSideAlert) {
                            let basketItems = basketStorage.get('items');
                            if (!basketItems) {
                                basketItems = []
                            }

                            for (let obj in self.items) {
                                if (self.mode == 2) {
                                    self.items[obj].template.storage = true
                                } else {
                                    self.items[obj].template.storage = false
                                }
                                if (self.mode == 3) {
                                    self.items[obj].template.byMat = true
                                } else {
                                    self.items[obj].template.byMat = false
                                }
                                basketItems.push(self.items[obj].template)
                                self.$countGlobal.basket += 1
                            }

                            basketStorage.set('items', basketItems)
                        } else {
                            alert('Выберите намотку ткани!')
                        }

                        self.items = []
                    } else if (self.itemsCorniceVertical.length > 0) {
                        let basketItemsCorniceVertical = basketStorage.get('itemsCorniceVertical');
                        if (!basketItemsCorniceVertical) {
                            basketItemsCorniceVertical = []
                        }
                        for (let obj in self.itemsCorniceVertical) {
                            basketItemsCorniceVertical.push(self.itemsCorniceVertical[obj].template)
                            self.$countGlobal.basket += 1
                        }
                        basketStorage.set('itemsCorniceVertical', basketItemsCorniceVertical)

                        self.itemsCorniceVertical = []
                    } else if (self.itemsMaterialVertical.length > 0) {
                        let basketItemsMaterialVertical = basketStorage.get('itemsMaterialVertical');
                        if (!basketItemsMaterialVertical) {
                            basketItemsMaterialVertical = []
                        }
                        for (let obj in self.itemsMaterialVertical) {
                            basketItemsMaterialVertical.push(self.itemsMaterialVertical[obj].template)
                            self.$countGlobal.basket += 1
                        }
                        basketStorage.set('itemsMaterialVertical', basketItemsMaterialVertical)

                        self.itemsMaterialVertical = []
                    }

                    basketStorage.set('basketCount', self.$countGlobal.basket)
                    self.basketUpdate();

                    self.$added.state = true;
                    setTimeout(function () {
                        self.$added.state = false;
                    }, 2500);
                }
            ])


        },
        uploadExcel: function() {
            let self = this;

            this.jsonExcelContent = []
            this.$modal.show('excelUpload')

            this.json_data2 = []
            this.json_fields2 = {
                "Тип изделия": "type",
                "Наименование": "name",
                "Материал": "material",
                "Ширина": "width",
                "Высота": "height",
                "Сторона управления 0 - левая. 1 - правая": "controlSide",
                "symbol": "symbol",
                "Остаток": "count",
                "Штук в упаковке": "amountInPack"
            }

            console.log(self.itemsStorage)

            for (let item in self.itemsStorage) {
                if (self.itemsStorage[item].type != 'Набор ремкомплект' && self.itemsStorage[item].type != 'Каталог тканей FOROOM ROLL 2024' && self.itemsStorage[item].type != 'Каталог тканей FOROOM V-FORM 2024' && self.itemsStorage[item].type != 'Каталог ал ленты FOROOM G-FORM 2024' && self.itemsStorage[item].name != "стандартные RM") {
                    let obj = {
                        type: self.itemsStorage[item].type,
                        name: self.itemsStorage[item].name,
                        material: self.itemsStorage[item].material,
                        width: self.itemsStorage[item].width / 10,
                        height: self.itemsStorage[item].height / 10,
                        controlSide: self.itemsStorage[item].controlSide - 1,
                        symbol: self.itemsStorage[item].symbol,
                        count: self.itemsStorage[item].count,
                        amountInPack: self.itemsStorage[item].package_amount
                    }
                    this.json_data2.push(obj)
                }
            }

        },
        attachFile() {
            let self = this

            let file = document.querySelector('#inputGroupFile');
            file = file.files[0];
            this.fileName = file.name;
            this.file = file;

            console.log(file)

            let reader = new FileReader();
            reader.readAsArrayBuffer(file);
            reader.onload = function () {
                let data = new Uint8Array(reader.result);
                let workbook = read(data, {type: 'array'});
                let sheet = workbook.Sheets[workbook.SheetNames[0]];
                let json = utils.sheet_to_json(sheet);

                self.jsonExcelContent = json

                console.log(json)
            };

        },
        addExcelItems() {
            let self = this;
            self.items = []

            let type = 0

            for (let newItem in self.jsonExcelContent) {
                let founded = false

                for (let item in self.itemsStorage) {
                    if (self.jsonExcelContent[newItem].symbol == self.itemsStorage[item].symbol && self.itemsStorage[item].name != "стандартные RM") {
                        founded = true

                        let mid = 0;

                        switch (self.itemsStorage[item].name) {
                            case "картон RM":
                                mid = 141;
                                break;
                            case "стандартные RM":
                                mid = 14;
                                break;
                            case "MINI RM":
                                mid = 6;
                                break;
                            case "Zebra RM":
                                mid = 13;
                                break;
                        }

                        if (type == 0) {
                            type = mid
                            if (mid == 141) {
                                self.orderMode = 4

                                for (let type in this.typesAll) {
                                    if (type == 141) {
                                        if ((this.mode == 1 && type != 14) || this.mode == 2) {
                                            this.types.push(this.typesAll[type])
                                        }
                                    }
                                }
                            }
                        }

                        if (type != 0) {
                            if (type == 141 && mid != 141) {
                                alert(self.jsonExcelContent[newItem].symbol + ': Нельзя добавить системы разного вида в один заказ!')
                            } else {
                                if (self.jsonExcelContent[newItem].Количество % self.itemsStorage[item].package_amount > 0) {
                                    alert(self.jsonExcelContent[newItem].symbol + ': Кол-во должно быть кратно ' + self.itemsStorage[item].package_amount)
                                } else {
                                    if (parseInt(self.itemsStorage[item].count) < self.itemsStorage[item].package_amount) {
                                        alert(self.jsonExcelContent[newItem].symbol + ': Нет на складе')
                                    } else {
                                        console.log(mid)

                                        let newSystem = new RMCalc(rm_katris, mid)

                                        if (self.jsonExcelContent[newItem].Количество > parseInt(self.itemsStorage[item].count) && !self.allowBuyMore) {
                                            let newCount = parseInt(self.itemsStorage[item].count) - (parseInt(self.itemsStorage[item].count) % self.itemsStorage[item].package_amount)

                                            alert(self.jsonExcelContent[newItem].symbol + ': Нет такого количества. Будет добавлено ' + newCount)

                                            newSystem.template.amount = newCount
                                        } else {
                                            newSystem.template.amount = self.jsonExcelContent[newItem].Количество
                                        }

                                        newSystem.template.ControlSide = self.itemsStorage[item].controlSide
                                        newSystem.template.gab_width = self.itemsStorage[item].width
                                        newSystem.template.gab_height = self.itemsStorage[item].height
                                        newSystem.template.material = self.itemsStorage[item].material_id

                                        if (self.jsonExcelContent[newItem]['Номер ШК'] && self.jsonExcelContent[newItem]['тип шк']) {
                                            let barcodeType = 0
                                            switch (self.jsonExcelContent[newItem]['тип шк']) {
                                                case "EAN 13":
                                                    barcodeType = 1;
                                                    break;
                                                case "Code 39":
                                                    barcodeType = 2;
                                                    break;
                                            }
                                            if (barcodeType == 0) {
                                                alert(self.jsonExcelContent[newItem].symbol + ': Неустановленный тип штрихкода')
                                            } else {
                                                newSystem.template.barcodeType = barcodeType
                                                newSystem.template.barcode = self.jsonExcelContent[newItem]['Номер ШК']

                                                if (self.jsonExcelContent[newItem]['Строка 1']) {
                                                    newSystem.template.barcodeText1 = self.jsonExcelContent[newItem]['Строка 1']
                                                }
                                                if (self.jsonExcelContent[newItem]['Строка 2']) {
                                                    newSystem.template.barcodeText2 = self.jsonExcelContent[newItem]['Строка 2']
                                                }
                                                if (self.jsonExcelContent[newItem]['Строка 3']) {
                                                    newSystem.template.barcodeText3 = self.jsonExcelContent[newItem]['Строка 3']
                                                }

                                                self.useAltBarcodes = true
                                            }
                                        }

                                        self.items.push(newSystem);

                                        this.recalc(this.items.length - 1, mid);
                                    }

                                }
                            }
                        }

                        break
                    }
                }

                if (!founded) {
                    alert('Символ ' + self.jsonExcelContent[newItem].symbol + ' не найден')
                }
            }

            this.basketUpdate();
            this.$modal.hide('excelUpload')
        }
    }
}
</script>

<style scoped>
@media (min-width: 1200px) {
    .container, .container-sm, .container-md, .container-lg, .container-xl {
        max-width: 1340px;
    }
}

.basket {
    font-weight: normal;
    font-size: 12px;
}

.readyMadeTable {
    font-size: 14px;
}

.readyMadeTable th {
    vertical-align: middle;
    border-top: none;
    font-weight: normal;
}

.readyMadeTable td,
.readyMadeTable th {
    padding: 3px;
}

.readyMadeTable .form-control {
    padding: 6px;
    font-size: 14px;
}

.fabricSelect .button, .systemSelect .button {
    background-color: white;
    display: flex;
}

.fabricSelect .content, .systemSelect .content {
    position: absolute;
    padding: 15px;
    background-color: #fff;
    border: 1px solid #dee2e6;
    z-index: 10;
    box-shadow: 2px 3px 6px 0px #b9b9b9;
    width: 520px;
}

.fabricSelect .content .col-4 {
    padding-left: 0;
}

.fabricSelect .content .search {
    margin-bottom: 15px;
    font-size: 12px;
}

.content .scroll {
    max-height: 414px;
    overflow-y: scroll;
    padding-left: 15px;
}

.fabricSelect .content figure {
    padding: 10px;
    border: 1px solid #ced4da;
}

.fabricSelect .content figure:hover {
    cursor: pointer;
}

.fabricSelect .content figcaption {
    padding-top: 10px;
    font-weight: normal;
}

.fabricSelect .content img {
    width: 100%;
}

.fabricSelect, .systemSelect {
    width: 285px;
    position: relative;
}

.systemSelect .content ul {
    padding: 0;
    margin: 0;
}

.systemSelect .content ul li {
    list-style: none;
}

.systemSelect .content {
    padding: 0;
    width: 350px;
}

.fabricSelect::after, .systemSelect::after {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: .255em;
    vertical-align: .255em;
    content: "";
    border-top: .5em solid;
    border-right: .2em solid transparent;
    border-bottom: 0;
    border-left: .2em solid transparent;
    position: absolute;
    right: 13px;
    top: 19px;
    color: #495057;
}

.fabricSelect .button img {
    height: 33px;
    width: 44px;
}

.systemSelect .button img {
    height: 33px;
    width: 33px;
}

.fabricSelect .button, .systemSelect .button {
    border: 1px solid #ced4da;
    color: #495057;
    height: 35px;
    overflow: hidden;
}

.fabricSelect .button div, .systemSelect .button div {
}

.fabricSelect .button .text, .systemSelect .button .text {
    padding: 7px 5px;
    word-break: break-all;
    width: 100%;
}

.basketItem {
    border: 1px solid #dee2e6;
    box-shadow: 2px 3px 6px 0px #b9b9b9;
    padding: 15px;
    position: relative;
    margin-bottom: 20px;
}

.basketItem .remove {
    position: absolute;
    top: -4px;
    right: 10px;
}

.basketItem table {
    margin-bottom: 0;
}

.basketItem table th,
.basketItem table td {
    padding: 8px;
    vertical-align: top !important;
}

.totalTable {
    margin-bottom: 80px;
    font-size: 12px;
}

.overlay {
    z-index: 9;
    display: block;
    height: 100vh;
    left: 0;
    position: fixed;
    top: 0;
    width: 100vw;
}

figure button {
    background: white;
}

figure button:hover {
    background: #007bff;
}

.new {
    display: inline-block;
    position: absolute;
    left: -50px;
    top: 24px;
    font-weight: bold;
    color: rgb(5, 133, 189);
}

.readyMadeTable thead tr:first-of-type {
    height: auto;
    background-color: #0056b3;
    color: #fff;
}

.readyMadeTable thead tr:first-of-type th {
    padding-bottom: 3px;
}

.readyMadeTable thead tr {
    height: 70px;
}

.readyMadeTable th {
    position: relative;
    padding-left: 5px;
    padding-bottom: 20px;
}

.readyMadeTable th > .la-angle-down {
    position: absolute;
    bottom: 5px;
    left: calc(50% - 8px);
}

.readyMadeTable th:after {
    content: '';
    height: 30px;
    width: 1px;
    background: #b7b7b7;
    display: block;
    position: absolute;
    /*right: 3px;*/
    right: 0px;
    top: calc(50% - 15px);
}

.readyMadeTable .noAfter:after {
    width: 0px;
}

.readyMadeTable th p {
    display: inline-block;
    font-size: 15px;
    /*padding: 8px;*/
}

.readyMadeTable th .btn-light {
    /*float: right;*/
    /*margin: 9px;*/
    position: absolute;
    right: 10px;
    top: 13px;
}

.rmGroup {
    -webkit-box-shadow: 2px 3px 6px 0px #b9b9b9;
    box-shadow: 2px 3px 6px 0px #b9b9b9;
    margin-bottom: 20px;
}

.tab {
    cursor: pointer;
}

.redBack {
    background-color: #c74343;
}

.redBorder {
    border: 2px solid #c74343;
}

.readyMadeTable th a {
    color: #fff;
    margin-right: 14px;
    display: inline-block;
    margin-bottom: 3px;
    padding: 10px;
}

.readyMadeTable th a.selected {
    text-decoration: underline;
}

.corniceTable {

}
.corniceTable tr td {
    vertical-align: top !important;
}
.corniceTable .opened {
    height: 100px;
    position: relative;
}
.corniceTable .infoText {
    position: absolute;
    top: 45px;
    padding: 0px 10px;
}

.rmMenu a.newRm {
    background-color: #2b5468;
    padding: 10px;
    border-radius: 25px;
}

.rmMenu a.newRm2 {
    background-color: #e94779;
    padding: 10px;
    border-radius: 25px;
}

.rmMenu a.selected {
    background-color: #fff !important;
    padding: 10px;
    border-radius: 25px;
    color: #0056b3;
    text-decoration: none !important;
}

.popupCards {
    background: white;
    /*position: fixed;*/
    /*width: 500px;*/
    /*height: 400px;*/
    /*right: 20px;*/
    /*bottom: 0px;*/
    /*box-shadow: 0px 0px 8px 0px rgba(34, 60, 80, 0.3);*/
    text-align: center;
    /*padding: 0 10px;*/
    /*padding-top: 20px;*/
    font-weight: bold;
    /*z-index: 200;*/
}
.popupCards p {
    margin-bottom: 5px;
}
.popupCards .bigText {
    text-transform: uppercase;
    font-size: 20px;
    color: rgb(0, 86, 179);
}
.popupCards .innerBlock {
    /*background: #353535;*/
    width: 400px;
    height: 250px;
    margin: 0 auto;
    margin-top: 20px;
    border-radius: 20px 20px 0 0;
    background-position: center;
    background-size: cover;
}

.popupCards .innerBlock video {
    border-radius: 20px 20px 0 0;
}
.cardHref {
    color: #000;
}
.cardHref:hover {
    text-decoration: none;
}

.silentbox-single:before {
    top: -4px;
    left: 11px;
}

.barcodesMaterial .text {
    font-size: 12px;
    word-break: break-word !important;
    padding: 0px 3px !important;
}

.barcodesMaterial:after {
    top: 56px;
}

.select2_el {
    padding: 10px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid grey;
}

.select2_el img {
    width: 30px;
    margin-right: 10px;
}

.select2_el .name {
    display: inline-block;
    margin-right: 5px;
    flex-shrink: 0;
    font-size: 14px;
    font-weight: 700;
}
</style>
